<template>
  <div class="main-content">
    <breadcrumb
      :nameSection="nameSection"
      :listRoutes="listRoutes"
      :activeRoute="activeRoute"
    ></breadcrumb>

    <!--<circle-spin v-if="!orderDataShow"></circle-spin>-->

    <div v-if="orderDataShow">
      <div class="card-status-content">
        <div class="card-status-block">
          <button type="button" class="btn btn-line" @click="backPage">
            <i class="fas fa-long-arrow-alt-left"></i>Volver
          </button>

          <span
            v-if="
              orderDataShow.attributes.status >= 1 && orderDataShow.attributes.status <= 3
            "
            class="btn statusInit"
            >Inicializando</span
          >

          <span
            v-if="
              orderDataShow.attributes.status >= 4 && orderDataShow.attributes.status <= 7
            "
            class="btn statusProgress"
            >En proceso</span
          >

          <span v-if="orderDataShow.attributes.status == 8" class="btn statusProgress"
            >Finalizado</span
          >

          <span v-if="orderDataShow.attributes.status == 10" class="btn statusCancel"
            >Cancelado</span
          >

          <span v-if="orderDataShow.attributes.status == 1" class="card-status-message"
            >En re-evaluación inicial</span
          >

          <span v-if="orderDataShow.attributes.status == 2" class="card-status-message"
            >Re-evaluado esperando confirmación</span
          >

          <span v-if="orderDataShow.attributes.status == 3" class="card-status-message"
            >Completando información de compra</span
          >

          <span v-if="orderDataShow.attributes.status == 4" class="card-status-message"
            >Comprado y en camino a dirección de origen</span
          >

          <span v-if="orderDataShow.attributes.status == 5" class="card-status-message"
            >Recibido en dirección de origen y en evaluación</span
          >

          <span v-if="orderDataShow.attributes.status == 6" class="card-status-message"
            >Listo para embarque</span
          >

          <span v-if="orderDataShow.attributes.status == 7" class="card-status-message"
            >En embarque</span
          >

          <span v-if="orderDataShow.attributes.status == 8" class="card-status-message"
            >Entregado correctamente</span
          >

          <span
            v-if="
              orderDataShow.attributes.status == 10 &&
              orderDataShow.attributes.cancelled_reason_flag == 1
            "
            class="card-status-message"
            >Por decisión propia</span
          >

          <span
            v-if="
              orderDataShow.attributes.status == 10 &&
              orderDataShow.attributes.cancelled_reason_flag == 2
            "
            class="card-status-message"
            >Por incidente en tracking</span
          >

          <span
            v-if="
              orderDataShow.attributes.status == 10 &&
              orderDataShow.attributes.cancelled_reason_flag == 3
            "
            class="card-status-message"
            >Por no autorizar reposición de items</span
          >
        </div>
      </div>

      <div class="m">
        <div class="nm n-1">
          <div class="details-collapse">
            <orderImportantInfo
              v-bind:orderDataShow="orderDataShow"
              v-bind:fromDetail="true"
              v-bind:fromTracking="false"
              @inicialize-data="inicializeDataFromImportantInfo"
            ></orderImportantInfo>

            <div
              v-if="
                orderDataShow.attributes.status == 1 &&
                ((orderDataShow.attributes.is_from_grabr_flag &&
                  orderDataShow.attributes.grabrOrder.attributes.approved_flag == 0) ||
                  (orderDataShow.attributes.is_from_linio_flag &&
                    orderDataShow.attributes.linioOrder.attributes.approved_flag == 0) ||
                  (orderDataShow.attributes.is_from_meli_flag &&
                    orderDataShow.attributes.meliOrder.attributes.approved_flag == 0))
              "
              class="card card-standby collapsed"
              id="headingOne"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              <div class="card-content-container">
                <div class="card-content-block">
                  <span>Oferta por evaluar</span>
                </div>

                <div class="card-content-block">
                  <b-button
                    v-b-modal.modalReevaluation
                    class="btn btn-primary btn-lg"
                    :disabled="noEvaluationFlag"
                    >Evaluar</b-button
                  >
                </div>
              </div>

              <div
                id="collapseOne"
                class="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
                v-if="
                  (orderDataShow.attributes.is_from_grabr_flag &&
                    orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
                  (orderDataShow.attributes.is_from_linio_flag &&
                    orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
                  (orderDataShow.attributes.is_from_meli_flag &&
                    orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
                "
              >
                <resumePurchaseOrder
                  v-bind:orderDataShow="orderDataShow"
                ></resumePurchaseOrder>
              </div>
            </div>

            <div
              v-if="
                orderDataShow.attributes.status == 2 &&
                ((orderDataShow.attributes.is_from_grabr_flag &&
                  orderDataShow.attributes.grabrOrder.attributes.approved_flag == 3) ||
                  (orderDataShow.attributes.is_from_linio_flag &&
                    orderDataShow.attributes.linioOrder.attributes.approved_flag == 3) ||
                  (orderDataShow.attributes.is_from_meli_flag &&
                    orderDataShow.attributes.meliOrder.attributes.approved_flag == 3))
              "
              class="card card-cancel collapsed"
              id="headingTwo"
              data-toggle="collapse"
              data-target="#collapseTwo"
              aria-expanded="true"
              aria-controls="collapseTwo"
            >
              <div class="card-content-container">
                <div class="card-content-block">
                  <span>Oferta no aprobada</span>
                </div>

                <div class="card-content-block">
                  <b-button
                    v-b-modal.modalReevaluation
                    class="btn btn-primary btn-lg"
                    :disabled="noEvaluationFlag"
                    >Re-evaluar</b-button
                  >

                  <button
                    v-if="
                      orderDataShow.attributes.is_from_grabr_flag &&
                      orderDataShow.attributes.grabrOrder.attributes.confirmation_flag ==
                        0
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    {{
                      orderDataShow.attributes.grabrOrder.attributes.approved_flag == 1
                        ? "Reafirmar aprobación"
                        : "Forzar aprobación"
                    }}
                  </button>

                  <button
                    v-else-if="
                      orderDataShow.attributes.is_from_linio_flag &&
                      orderDataShow.attributes.linioOrder.attributes.confirmation_flag ==
                        0
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    {{
                      orderDataShow.attributes.linioOrder.attributes.approved_flag == 1
                        ? "Reafirmar aprobación"
                        : "Forzar aprobación"
                    }}
                  </button>

                  <button
                    v-else-if="
                      orderDataShow.attributes.is_from_meli_flag &&
                      orderDataShow.attributes.meliOrder.attributes.confirmation_flag == 0
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    {{
                      orderDataShow.attributes.meliOrder.attributes.approved_flag == 1
                        ? "Reafirmar aprobación"
                        : "Forzar aprobación"
                    }}
                  </button>

                  <button
                    v-if="
                      orderDataShow.attributes.is_from_grabr_flag &&
                      this.orderDataShow.attributes.grabrOrder.attributes
                        .confirmation_flag != 0
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    Procesar
                  </button>

                  <button
                    v-else-if="
                      (orderDataShow.attributes.is_from_linio_flag &&
                        this.orderDataShow.attributes.linioOrder.attributes
                          .confirmation_flag != 0) ||
                      (orderDataShow.attributes.is_from_meli_flag &&
                        this.orderDataShow.attributes.meliOrder.attributes
                          .confirmation_flag != 0)
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    Procesar
                  </button>
                </div>
              </div>

              <div
                id="collapseTwo"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
                v-if="
                  (orderDataShow.attributes.is_from_grabr_flag &&
                    orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
                  (orderDataShow.attributes.is_from_linio_flag &&
                    orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
                  (orderDataShow.attributes.is_from_meli_flag &&
                    orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
                "
              >
                <resumePurchaseOrder
                  v-bind:orderDataShow="orderDataShow"
                  @inicialize-data="inicializeDataFromImportantInfo"
                ></resumePurchaseOrder>
              </div>
            </div>

            <div
              v-if="
                orderDataShow.attributes.status == 2 &&
                ((orderDataShow.attributes.is_from_grabr_flag &&
                  orderDataShow.attributes.grabrOrder.attributes.approved_flag == 1) ||
                  (orderDataShow.attributes.is_from_linio_flag &&
                    orderDataShow.attributes.linioOrder.attributes.approved_flag == 1) ||
                  (orderDataShow.attributes.is_from_meli_flag &&
                    orderDataShow.attributes.meliOrder.attributes.approved_flag == 1))
              "
              class="card card-correct"
              id="headingThree"
            >
              <div class="card-content-container">
                <div class="card-content-block">
                  <span>Oferta aprobada</span>
                </div>

                <div class="card-content-block">
                  <b-button v-b-modal.modalReevaluation class="btn btn-primary btn-lg"
                    >Re-evaluar</b-button
                  >

                  <button
                    v-if="
                      orderDataShow.attributes.is_from_grabr_flag &&
                      orderDataShow.attributes.grabrOrder.attributes.confirmation_flag ==
                        0
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    {{
                      orderDataShow.attributes.grabrOrder.attributes.approved_flag == 1
                        ? "Reafirmar aprobación"
                        : "Forzar aprobación"
                    }}
                  </button>

                  <button
                    v-else-if="
                      orderDataShow.attributes.is_from_linio_flag &&
                      orderDataShow.attributes.linioOrder.attributes.confirmation_flag ==
                        0
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    {{
                      orderDataShow.attributes.linioOrder.attributes.approved_flag == 1
                        ? "Reafirmar aprobación"
                        : "Forzar aprobación"
                    }}
                  </button>

                  <button
                    v-else-if="
                      orderDataShow.attributes.is_from_meli_flag &&
                      orderDataShow.attributes.meliOrder.attributes.confirmation_flag == 0
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    {{
                      orderDataShow.attributes.meliOrder.attributes.approved_flag == 1
                        ? "Reafirmar aprobación"
                        : "Forzar aprobación"
                    }}
                  </button>

                  <button
                    v-if="
                      orderDataShow.attributes.is_from_grabr_flag &&
                      this.orderDataShow.attributes.grabrOrder.attributes
                        .confirmation_flag != 0
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    Procesar
                  </button>

                  <button
                    v-else-if="
                      orderDataShow.attributes.is_from_linio_flag &&
                      this.orderDataShow.attributes.linioOrder.attributes
                        .confirmation_flag != 0
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    Procesar
                  </button>

                  <button
                    v-else-if="
                      orderDataShow.attributes.is_from_meli_flag &&
                      this.orderDataShow.attributes.meliOrder.attributes
                        .confirmation_flag != 0
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    Procesar
                  </button>

                  <div
                    class="collapsed"
                    data-toggle="collapse"
                    data-target="#collapseThree"
                    aria-expanded="true"
                    aria-controls="collapseThree"
                    style="cursor: pointer"
                  >
                    <div class="details-text up-arrow"></div>
                  </div>
                </div>
              </div>

              <div
                id="collapseThree"
                class="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordion"
              >
                <resumePurchaseOrder
                  v-bind:orderDataShow="orderDataShow"
                  @inicialize-data="inicializeDataFromImportantInfo"
                ></resumePurchaseOrder>
              </div>
            </div>

            <div
              v-if="
                orderDataShow.attributes.status == 2 &&
                ((orderDataShow.attributes.is_from_linio_flag &&
                  orderDataShow.attributes.linioOrder.attributes.approved_flag == 2) ||
                  (orderDataShow.attributes.is_from_meli_flag &&
                    orderDataShow.attributes.meliOrder.attributes.approved_flag == 2))
              "
              class="card card-standby card-wait collapsed"
              id="headinFour"
              data-toggle="collapse"
              data-target="#collapsenFour"
              aria-expanded="true"
              aria-controls="collapseFour"
            >
              <div class="card-content-container">
                <div class="card-content-block">
                  <span>Esperando revisión del administrador</span>
                </div>

                <div class="card-content-block">
                  <b-button v-b-modal.modalReevaluation class="btn btn-primary btn-lg"
                    >Re-evaluar</b-button
                  >

                  <button
                    v-if="
                      orderDataShow.attributes.is_from_grabr_flag &&
                      orderDataShow.attributes.grabrOrder.attributes.confirmation_flag ==
                        0
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    {{
                      orderDataShow.attributes.grabrOrder.attributes.approved_flag == 1
                        ? "Reafirmar aprobación"
                        : "Forzar aprobación"
                    }}Forzar aprobación
                  </button>

                  <button
                    v-else-if="
                      orderDataShow.attributes.is_from_linio_flag &&
                      orderDataShow.attributes.linioOrder.attributes.confirmation_flag ==
                        0
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    {{
                      orderDataShow.attributes.linioOrder.attributes.approved_flag == 1
                        ? "Reafirmar aprobación"
                        : "Forzar aprobación"
                    }}Forzar aprobación
                  </button>

                  <button
                    v-else-if="
                      orderDataShow.attributes.is_from_meli_flag &&
                      orderDataShow.attributes.meliOrder.attributes.confirmation_flag == 0
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    {{
                      orderDataShow.attributes.meliOrder.attributes.approved_flag == 1
                        ? "Reafirmar aprobación"
                        : "Forzar aprobación"
                    }}Forzar aprobación
                  </button>

                  <button
                    v-if="
                      orderDataShow.attributes.is_from_grabr_flag &&
                      this.orderDataShow.attributes.grabrOrder.attributes
                        .confirmation_flag != 0
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    Procesar
                  </button>

                  <button
                    v-else-if="
                      orderDataShow.attributes.is_from_linio_flag &&
                      this.orderDataShow.attributes.linioOrder.attributes
                        .confirmation_flag != 0
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    Procesar
                  </button>

                  <button
                    v-else-if="
                      orderDataShow.attributes.is_from_meli_flag &&
                      this.orderDataShow.attributes.meliOrder.attributes
                        .confirmation_flag != 0
                    "
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                  >
                    Procesar
                  </button>

                  <div
                    class="collapsed"
                    data-toggle="collapse"
                    data-target="#collapseThree"
                    aria-expanded="true"
                    aria-controls="collapseThree"
                    style="cursor: pointer"
                  >
                    <div class="details-text up-arrow"></div>
                  </div>
                </div>
              </div>

              <div
                id="collapsenFour"
                class="collapse"
                aria-labelledby="headingnFour"
                data-parent="#accordion"
              >
                <resumePurchaseOrder
                  v-bind:orderDataShow="orderDataShow"
                  @inicialize-data="inicializeDataFromImportantInfo"
                ></resumePurchaseOrder>
              </div>
            </div>

            <!-- <div
              v-if="
                orderDataShow.attributes.status == 3 &&
                ((!orderDataShow.attributes.is_from_grabr_flag &&
                  !orderDataShow.attributes.is_from_linio_flag &
                    !orderDataShow.attributes.is_from_meli_flag) ||
                  (orderDataShow.attributes.is_from_grabr_flag &&
                    orderDataShow.attributes.grabrOrder.attributes.approved_flag !== 0 &&
                    (orderDataShow.attributes.grabrOrder.attributes.confirmation_flag ===
                      1 ||
                      orderDataShow.attributes.grabrOrder.attributes.confirmation_flag ===
                        2)) ||
                  (orderDataShow.attributes.is_from_linio_flag &&
                    orderDataShow.attributes.linioOrder.attributes.approved_flag !== 0 &&
                    (orderDataShow.attributes.linioOrder.attributes.confirmation_flag ===
                      1 ||
                      orderDataShow.attributes.linioOrder.attributes.confirmation_flag ===
                        2)) ||
                  (orderDataShow.attributes.is_from_meli_flag &&
                    orderDataShow.attributes.meliOrder.attributes.approved_flag !== 0 &&
                    (orderDataShow.attributes.meliOrder.attributes.confirmation_flag ===
                      1 ||
                      orderDataShow.attributes.meliOrder.attributes.confirmation_flag ===
                        2)))
              "
              class="card card-standby card-wait"
              id="headingTwo"
            >
              <div class="card-content-container">
                <div class="card-content-block">
                  <span>Esperando revisión del administrador</span>
                </div>

                <div class="card-content-block">
                  <button
                    class="btn btn-primary btn-lg"
                    @click="ProcessService(id)"
                    :disabled="orderDataShow.attributes.payed == 1"
                  >
                    Completar información
                  </button>

                  <div
                    v-if="
                      (orderDataShow.attributes.status == 3 &&
                        orderDataShow.attributes.is_from_linio_flag &&
                        orderDataShow.attributes.linioOrder.attributes.approved_flag !==
                          0 &&
                        (orderDataShow.attributes.linioOrder.attributes
                          .confirmation_flag === 1 ||
                          orderDataShow.attributes.linioOrder.attributes
                            .confirmation_flag === 2)) ||
                      (orderDataShow.attributes.is_from_meli_flag &&
                        orderDataShow.attributes.meliOrder.attributes.approved_flag !==
                          0 &&
                        (orderDataShow.attributes.meliOrder.attributes
                          .confirmation_flag === 1 ||
                          orderDataShow.attributes.meliOrder.attributes
                            .confirmation_flag === 2))
                    "
                    class="collapsed"
                    data-toggle="collapse"
                    data-target="#collapseTwo"
                    aria-expanded="true"
                    aria-controls="collapseTwo"
                    style="cursor: pointer"
                  >
                    <div class="details-text up-arrow"></div>
                  </div>
                </div>
              </div>

              <div
                id="collapseTwo"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
                v-if="
                  (orderDataShow.attributes.is_from_grabr_flag &&
                    orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
                  (orderDataShow.attributes.is_from_linio_flag &&
                    orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
                  (orderDataShow.attributes.is_from_meli_flag &&
                    orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
                "
              >
                <resumePurchaseOrder
                  v-bind:orderDataShow="orderDataShow"
                ></resumePurchaseOrder>
              </div>
            </div> -->

            <div
              v-if="orderDataShow.attributes.status == 4"
              class="card card-correct collapsed"
              id="headinThree"
            >
              <div class="card-content-container">
                <div class="card-content-block">
                  <span>Listo para el flujo de tracking</span>
                </div>

                <div class="card-content-block">
                  <button
                    class="btn btn-primary btn-lg"
                    @click="toTrackingView(orderDataShow)"
                  >
                    Ir al tracking
                  </button>

                  <div
                    v-if="
                      (orderDataShow.attributes.is_from_linio_flag &&
                        orderDataShow.attributes.linioOrder.attributes.approved_flag !==
                          0 &&
                        (orderDataShow.attributes.linioOrder.attributes
                          .confirmation_flag === 1 ||
                          orderDataShow.attributes.linioOrder.attributes
                            .confirmation_flag === 2)) ||
                      (orderDataShow.attributes.is_from_meli_flag &&
                        orderDataShow.attributes.meliOrder.attributes.approved_flag !==
                          0 &&
                        (orderDataShow.attributes.meliOrder.attributes
                          .confirmation_flag === 1 ||
                          orderDataShow.attributes.meliOrder.attributes
                            .confirmation_flag === 2))
                    "
                    class="collapsed"
                    data-toggle="collapse"
                    data-target="#collapsenThree"
                    aria-expanded="true"
                    aria-controls="collapseThree"
                    style="cursor: pointer"
                  >
                    <div class="details-text up-arrow"></div>
                  </div>
                </div>
              </div>

              <div
                id="collapsenThree"
                class="collapse"
                aria-labelledby="headingnThree"
                data-parent="#accordion"
                v-if="
                  (orderDataShow.attributes.is_from_grabr_flag &&
                    orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
                  (orderDataShow.attributes.is_from_linio_flag &&
                    orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
                  (orderDataShow.attributes.is_from_meli_flag &&
                    orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
                "
              >
                <resumePurchaseOrder
                  v-bind:orderDataShow="orderDataShow"
                ></resumePurchaseOrder>
              </div>
            </div>

            <div
              v-if="
                orderDataShow.attributes.status == 5 &&
                orderDataShow.attributes.warning_expired_flag == 0
              "
              class="card card-correct"
              id="headinThree"
            >
              <div class="card-content-container">
                <div class="card-content-block">
                  <span>En proceso de tracking</span>
                </div>

                <div class="card-content-block">
                  <button
                    class="btn btn-primary btn-lg"
                    @click="toTrackingView(orderDataShow)"
                  >
                    Ir al tracking
                  </button>

                  <div
                    v-if="
                      (orderDataShow.attributes.is_from_linio_flag &&
                        orderDataShow.attributes.linioOrder.attributes.approved_flag !==
                          0 &&
                        (orderDataShow.attributes.linioOrder.attributes
                          .confirmation_flag === 1 ||
                          orderDataShow.attributes.linioOrder.attributes
                            .confirmation_flag === 2)) ||
                      (orderDataShow.attributes.is_from_meli_flag &&
                        orderDataShow.attributes.meliOrder.attributes.approved_flag !==
                          0 &&
                        (orderDataShow.attributes.meliOrder.attributes
                          .confirmation_flag === 1 ||
                          orderDataShow.attributes.meliOrder.attributes
                            .confirmation_flag === 2))
                    "
                    class="collapsed"
                    data-toggle="collapse"
                    data-target="#collapsenThree"
                    aria-expanded="true"
                    aria-controls="collapseThree"
                    style="cursor: pointer"
                  >
                    <div class="details-text up-arrow"></div>
                  </div>
                </div>
              </div>

              <div
                id="collapsenThree"
                class="collapse"
                aria-labelledby="headingnThree"
                data-parent="#accordion"
                v-if="
                  (orderDataShow.attributes.is_from_linio_flag &&
                    orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
                  (orderDataShow.attributes.is_from_meli_flag &&
                    orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
                "
              >
                <resumePurchaseOrder
                  v-bind:orderDataShow="orderDataShow"
                ></resumePurchaseOrder>
              </div>
            </div>

            <div
              v-if="
                orderDataShow.attributes.status == 5 &&
                orderDataShow.attributes.warning_expired_flag == 1
              "
              class="card card-warning collapsed"
              id="headingOne"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              <div class="card-content-container">
                <div class="card-content-block">
                  <span>En proceso de tracking con retraso</span>
                </div>

                <div class="card-content-block">
                  <button
                    class="btn btn-primary btn-lg"
                    @click="toTrackingView(orderDataShow)"
                  >
                    Ir al tracking
                  </button>
                </div>
              </div>

              <div
                id="collapseOne"
                class="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
                v-if="
                  (orderDataShow.attributes.is_from_grabr_flag &&
                    orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
                  (orderDataShow.attributes.is_from_linio_flag &&
                    orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
                  (orderDataShow.attributes.is_from_meli_flag &&
                    orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
                "
              >
                <resumePurchaseOrder
                  v-bind:orderDataShow="orderDataShow"
                ></resumePurchaseOrder>
              </div>
            </div>

            <div
              v-if="
                orderDataShow.attributes.status == 5 &&
                orderDataShow.attributes.warning_expired_flag == 0
              "
              class="card card-correct collapsed"
              id="headingTwo"
              data-toggle="collapse"
              data-target="#collapseThree"
              aria-expanded="true"
              aria-controls="collapseThree"
            >
              <div class="card-content-container">
                <div class="card-content-block">
                  <span>Recibido y completando datos de recepción</span>
                </div>
              </div>

              <div
                id="collapsenThree"
                class="collapse"
                aria-labelledby="headingnThree"
                data-parent="#accordion"
                v-if="
                  (orderDataShow.attributes.is_from_grabr_flag &&
                    orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
                  (orderDataShow.attributes.is_from_linio_flag &&
                    orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
                  (orderDataShow.attributes.is_from_meli_flag &&
                    orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
                "
              >
                <resumePurchaseOrder
                  v-bind:orderDataShow="orderDataShow"
                ></resumePurchaseOrder>
              </div>
            </div>

            <div
              v-if="orderDataShow.attributes.status == 6"
              class="card card-correct"
              id="headinThree"
            >
              <div class="card-content-container">
                <div class="card-content-block">
                  <span>Listo para embarcar</span>
                </div>

                <div class="card-content-block">
                  <div
                    v-if="
                      (orderDataShow.attributes.is_from_linio_flag &&
                        orderDataShow.attributes.linioOrder.attributes.approved_flag !==
                          0 &&
                        (orderDataShow.attributes.linioOrder.attributes
                          .confirmation_flag === 1 ||
                          orderDataShow.attributes.linioOrder.attributes
                            .confirmation_flag === 2)) ||
                      (orderDataShow.attributes.is_from_meli_flag &&
                        orderDataShow.attributes.meliOrder.attributes.approved_flag !==
                          0 &&
                        (orderDataShow.attributes.meliOrder.attributes
                          .confirmation_flag === 1 ||
                          orderDataShow.attributes.meliOrder.attributes
                            .confirmation_flag === 2))
                    "
                    class="collapsed"
                    data-toggle="collapse"
                    data-target="#collapsenThree"
                    aria-expanded="true"
                    aria-controls="collapseThree"
                    style="cursor: pointer"
                  >
                    <div class="details-text up-arrow"></div>
                  </div>
                </div>
              </div>

              <div
                id="collapsenThree"
                class="collapse"
                aria-labelledby="headingnThree"
                data-parent="#accordion"
                v-if="
                  (orderDataShow.attributes.is_from_grabr_flag &&
                    orderDataShow.attributes.grabrOrder.attributes.approved_flag != 0) ||
                  (orderDataShow.attributes.is_from_linio_flag &&
                    orderDataShow.attributes.linioOrder.attributes.approved_flag != 0) ||
                  (orderDataShow.attributes.is_from_meli_flag &&
                    orderDataShow.attributes.meliOrder.attributes.approved_flag != 0)
                "
              >
                <resumePurchaseOrder
                  v-bind:orderDataShow="orderDataShow"
                ></resumePurchaseOrder>
              </div>
            </div>

            <div
              v-if="
                orderDataShow.attributes.status == 10 &&
                orderDataShow.attributes.cancelled == 1
              "
              class="card card-cancel collapsed"
              id="headingTwo"
              data-toggle="collapse"
              data-target="#collapseTwo"
              aria-expanded="true"
              aria-controls="collapseTwo"
            >
              <div class="card-content-container">
                <div class="card-content-block">
                  <span v-if="orderDataShow.attributes.cancelled_reason_flag == 1"
                    >Cancelado por decision propia</span
                  >

                  <span v-else-if="orderDataShow.attributes.cancelled_reason_flag == 2"
                    >Cancelado por incidente en tracking</span
                  >

                  <span v-else-if="orderDataShow.attributes.cancelled_reason_flag == 3"
                    >Cancelado por no autorizar reposición de items</span
                  >
                </div>

                <div class="card-content-block">
                  <button
                    @click="toTrackingView(orderDataShow)"
                    class="btn btn-primary btn-lg"
                  >
                    Ir al tracking
                  </button>
                </div>
              </div>

              <div
                id="collapseTwo"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <resumePurchaseOrder
                  v-bind:orderDataShow="orderDataShow"
                ></resumePurchaseOrder>
              </div>
            </div>
          </div>

          <div class="details-title-separator">
            <span>Información de la orden</span>
          </div>
          <span v-if="orderDataShow.attributes.type === 2">
            <!-- Start- si la orden es sendi o envios -->
            <div class="details-content">
              <div id="accordion">
                <div
                  class="details-content-title collapsed"
                  id="information1"
                  data-toggle="collapse"
                  data-target="#clientInformation1"
                  aria-expanded="false"
                  aria-controls="clientInformation1"
                >
                  <span>Detalle de la orden</span>

                  <div class="details-text up-arrow"></div>
                </div>

                <div
                  id="clientInformation1"
                  class="collapse"
                  aria-labelledby="information1"
                >
                  <!--data-parent="#accordion"-->
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">N° de orden:</span>
                      <span class="details-title-item">{{ orderDataShow.id }} </span>
                    </div>
                  </div>
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Estatus de orden:</span>

                      <span class="details-title-item">
                        <button
                          @click.prevent="updateOrderInformation('activa')"
                          :disabled="orderDataShow.attributes.status !== 10"
                          class="button"
                          :style="
                            orderDataShow.attributes.status !== 10
                              ? 'cursor: not-allowed;'
                              : 'cursor: pointer;'
                          "
                          :class="
                            orderDataShow.attributes.status !== 10
                              ? 'button-success'
                              : 'button-outline'
                          "
                        >
                          {{
                            orderDataShow.attributes.status !== 10
                              ? "Activado"
                              : "Activar"
                          }}
                          <img
                            v-if="orderDataShow.attributes.status !== 10"
                            src="/static/img/success.svg"
                            alt=""
                          />
                          <img v-else src="/static/img/required-icon.svg" alt="" />
                        </button>

                        <button
                          style="margin-left: 12px"
                          class="button"
                          :disabled="orderDataShow.attributes.status === 10"
                          @click.prevent="updateOrderInformation('cancelada')"
                          :style="
                            orderDataShow.attributes.status === 10
                              ? 'cursor: not-allowed;'
                              : 'cursor: pointer;'
                          "
                          :class="
                            orderDataShow.attributes.status === 10
                              ? 'button-success'
                              : 'button-outline'
                          "
                        >
                          {{
                            orderDataShow.attributes.status === 10
                              ? "Cancelado"
                              : "Cancelar"
                          }}
                          <img
                            v-if="orderDataShow.attributes.status === 10"
                            src="/static/img/success.svg"
                            alt=""
                          />
                          <img v-else src="/static/img/required-icon.svg" alt="" />
                        </button>
                      </span>
                    </div>
                  </div>

                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Canal de Venta:</span>
                      <span class="details-title-item">
                        {{
                          orderDataShow.attributes.client.attributes.profile.attributes
                            .userable.attributes.store_id === 1
                            ? "Sendi"
                            : "Envios"
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Servicio:</span>
                      <span
                        class="details-title-item"
                        v-if="
                          orderDataShow.attributes.client.attributes.profile.attributes
                            .userable.attributes.store_id === 1
                        "
                      >
                        {{
                          orderDataShow.attributes.direct_type === 1
                            ? "Courier"
                            : "Shopper"
                        }}
                      </span>
                      <span
                        class="details-title-item"
                        v-if="
                          orderDataShow.attributes.client.attributes.profile.attributes
                            .userable.attributes.store_id === 2
                        "
                      >
                        {{
                          orderDataShow.attributes.direct_type === 1 ? "Lite" : "Premium"
                        }}
                      </span>
                    </div>
                  </div>

                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Factura Comercial:</span>
                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.vouchers_usa.length === 0"
                      >
                        <ul>
                          <li>Sin Adjunto</li>
                          <li>
                            <input
                              type="file"
                              @change="factura"
                              ref="fileupload"
                              accept="image/*,.pdf"
                              :disabled="orderDataShow.attributes.status === 10"
                            />
                          </li>
                        </ul>
                      </span>
                      <span class="details-title-item" v-else>
                        <ul>
                          <li
                            v-for="(invoice, index) in orderDataShow.attributes
                              .vouchers_usa"
                            :key="invoice"
                          >
                            <a :href="invoice.url" target="_blank"
                              >Ver Adjunto - {{ index + 1 }}
                            </a>
                            <span
                              style="cursor: pointer"
                              :style="
                                invoice.status === 0 ? 'color:#DD5385' : 'color:#3BC73B'
                              "
                              @click.prevent="
                                statusInvoice(invoice.url, index + 1, invoice.status)
                              "
                              >-
                              {{ invoice.status === 0 ? "(Sin Aprobar)" : "(Aprobado)" }}
                              -</span
                            >
                            <span
                              style="cursor: pointer"
                              @click.prevent="deleteInvoice(invoice.url, index + 1)"
                              >(Eliminar)</span
                            >
                          </li>
                          <li>
                            <input
                              type="file"
                              @change="factura"
                              ref="fileupload"
                              accept="image/*,.pdf"
                              :disabled="orderDataShow.attributes.status === 10"
                            />
                          </li>
                        </ul>
                      </span>
                    </div>
                  </div>

                  <div
                    class="details-content-info"
                    v-if="
                      orderDataShow.attributes.client.attributes.profile.attributes
                        .userable.attributes.store_id === 1
                    "
                  >
                    <div class="details-title-block">
                      <span class="details-title-item">Manifiesto:</span>
                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.manifest.length === 0"
                      >
                        <ul>
                          <li>Sin Adjunto</li>
                          <li>
                            <input
                              type="file"
                              @change="manifiestoFile"
                              accept="image/*,.pdf"
                              :disabled="orderDataShow.attributes.status === 10"
                            />
                          </li>
                        </ul>
                      </span>
                      <span class="details-title-item" v-else>
                        <ul>
                          <li
                            v-for="(invoice, index) in orderDataShow.attributes.manifest"
                            :key="invoice"
                          >
                            <a :href="invoice.url" target="_blank"
                              >Ver Manifiesto - {{ index + 1 }}
                            </a>
                            <span
                              style="cursor: pointer"
                              :style="
                                invoice.status === 0 ? 'color:#DD5385' : 'color:#3BC73B'
                              "
                              @click.prevent="
                                statusManifiesto(invoice.url, index + 1, invoice.status)
                              "
                              >-
                              {{ invoice.status === 0 ? "(Sin Aprobar)" : "(Aprobado)" }}
                              -</span
                            >
                            <span
                              style="cursor: pointer"
                              @click.prevent="deleteManifiesto(invoice.url, index + 1)"
                              >(Eliminar)</span
                            >
                          </li>
                          <li>
                            <input
                              type="file"
                              @change="manifiestoFile"
                              accept="image/*,.pdf"
                              :disabled="orderDataShow.attributes.status === 10"
                            />
                          </li>
                        </ul>
                      </span>
                    </div>
                  </div>

                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Método:</span>
                      <span class="details-title-item">
                        <button
                          @click.prevent="updateOrderInformation('aduana')"
                          :disabled="
                            orderDataShow.attributes.courier_type === 1 ||
                            orderDataShow.attributes.status === 10
                          "
                          class="button"
                          :style="
                            orderDataShow.attributes.courier_type === 1
                              ? 'cursor: not-allowed;'
                              : 'cursor: pointer;'
                          "
                          :class="
                            orderDataShow.attributes.courier_type === 1
                              ? 'button-success'
                              : 'button-outline'
                          "
                        >
                          Aduana
                          <img
                            v-if="orderDataShow.attributes.courier_type === 1"
                            src="/static/img/success.svg"
                            alt=""
                          />
                          <img v-else src="/static/img/required-icon.svg" alt="" />
                        </button>

                        <button
                          style="margin-left: 12px"
                          class="button"
                          :disabled="
                            orderDataShow.attributes.courier_type === 2 ||
                            orderDataShow.attributes.status === 10
                          "
                          @click.prevent="updateOrderInformation('pasajero')"
                          :style="
                            orderDataShow.attributes.courier_type === 2
                              ? 'cursor: not-allowed;'
                              : 'cursor: pointer;'
                          "
                          :class="
                            orderDataShow.attributes.courier_type === 2
                              ? 'button-success'
                              : 'button-outline'
                          "
                        >
                          Pasajero
                          <img
                            v-if="orderDataShow.attributes.courier_type === 2"
                            src="/static/img/success.svg"
                            alt=""
                          />
                          <img v-else src="/static/img/required-icon.svg" alt="" />
                        </button>
                      </span>
                    </div>
                  </div>

                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Canal:</span>
                      <span class="details-title-item">
                        <button
                          @click.prevent="updateOrderInformation('A')"
                          :disabled="
                            orderDataShow.attributes.channel === 'A' ||
                            orderDataShow.attributes.status === 10
                          "
                          class="button"
                          :style="
                            orderDataShow.attributes.channel === 'A'
                              ? 'cursor: not-allowed;'
                              : 'cursor: pointer;'
                          "
                          :class="
                            orderDataShow.attributes.channel === 'A'
                              ? 'button-success'
                              : 'button-outline'
                          "
                        >
                          Verde
                          <img
                            v-if="orderDataShow.attributes.channel === 'A'"
                            src="/static/img/success.svg"
                            alt=""
                          />
                          <img v-else src="/static/img/required-icon.svg" alt="" />
                        </button>

                        <button
                          style="margin-left: 12px"
                          @click.prevent="updateOrderInformation('B')"
                          :disabled="
                            orderDataShow.attributes.channel === 'B' ||
                            orderDataShow.attributes.status === 10
                          "
                          class="button"
                          :style="
                            orderDataShow.attributes.channel === 'B'
                              ? 'cursor: not-allowed;'
                              : 'cursor: pointer;'
                          "
                          :class="
                            orderDataShow.attributes.channel === 'B'
                              ? 'button-error'
                              : 'button-outline'
                          "
                        >
                          Rojo
                          <img
                            v-if="orderDataShow.attributes.channel === 'B'"
                            src="/static/img/error-icon.svg"
                            alt=""
                          />
                          <img v-else src="/static/img/required-icon.svg" alt="" />
                        </button>
                      </span>
                    </div>
                  </div>
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Fecha de creación:</span>
                      <span class="details-title-item"
                        >{{ orderDataShow.attributes.order_create_date }}
                      </span>
                    </div>
                  </div>
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Entrega prometida:</span>
                      <span class="details-title-item"
                        >{{ orderDataShow.attributes.delivery_date }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End- si la orden es sendi o envios -->
            <!-- Start- si la orden es sendi o envios - detalle del cliente  -->
            <div class="details-content">
              <div id="accordion">
                <div
                  class="details-content-title collapsed"
                  id="information2"
                  data-toggle="collapse"
                  data-target="#clientInformation2"
                  aria-expanded="false"
                  aria-controls="clientInformation2"
                >
                  <span>Detalle de la cuenta</span>

                  <div class="details-text up-arrow"></div>
                </div>

                <div
                  id="clientInformation2"
                  class="collapse"
                  aria-labelledby="information2"
                >
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Nombre:</span>
                      <span class="details-title-item"
                        >{{
                          orderDataShow.attributes.client.attributes.profile.attributes
                            .name
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Apellido:</span>
                      <span class="details-title-item">
                        {{
                          orderDataShow.attributes.client.attributes.profile.attributes
                            .surnames
                        }}
                      </span>
                    </div>
                  </div>

                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Documento:</span>
                      <span class="details-title-item">
                        {{
                          orderDataShow.attributes.client.attributes.profile.attributes
                            .document_number
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Teléfono:</span>
                      <span class="details-title-item">
                        {{
                          orderDataShow.attributes.client.attributes.profile.attributes
                            .cellphone
                        }}
                      </span>
                    </div>
                  </div>

                  <span
                    v-if="orderDataShow.attributes.client.attributes.address !== null"
                  >
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Dirección:</span>
                        <span class="details-title-item">
                          {{ orderDataShow.attributes.client.attributes.address.address }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Piso u Oficina:</span>
                        <span class="details-title-item"
                          >{{ orderDataShow.attributes.client.attributes.address.inner }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Referencia:</span>
                        <span class="details-title-item"
                          >{{
                            orderDataShow.attributes.client.attributes.address.reference
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Departamento:</span>
                        <span class="details-title-item"
                          >{{
                            orderDataShow.attributes.client.attributes.address.department
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Provincia:</span>
                        <span class="details-title-item"
                          >{{ orderDataShow.attributes.client.attributes.address.city }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Distrito:</span>
                        <span class="details-title-item"
                          >{{
                            orderDataShow.attributes.client.attributes.address.district
                          }}
                        </span>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Dirección:</span>
                        <span class="details-title-item">Sin Dirección Registrada </span>
                      </div>
                    </div>
                  </span>

                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Correo electrónico:</span>
                      <span class="details-title-item">
                        {{
                          orderDataShow.attributes.client.attributes.profile.attributes
                            .userable.attributes.email
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Status:</span>
                      <span class="details-title-item">
                        {{
                          orderDataShow.attributes.client.attributes.validation.verified
                            ? "Verificado"
                            : "No Verificado"
                        }}
                      </span>
                    </div>
                  </div>

                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">DNI anterior:</span>
                      <span class="details-title-item"
                        >{{
                          orderDataShow.attributes.client.attributes
                            .document_face_state === 3
                            ? "Verificado "
                            : "No Verificado "
                        }}
                        <a
                          :href="
                            orderDataShow.attributes.client.attributes.document_face_url
                          "
                          target="Blank"
                          v-if="
                            orderDataShow.attributes.client.attributes
                              .document_face_url !== null
                          "
                        >
                          - Ver imagen</a
                        >
                      </span>
                    </div>
                  </div>
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">DNI posterior:</span>
                      <span class="details-title-item"
                        >{{
                          orderDataShow.attributes.client.attributes
                            .document_seal_state === 3
                            ? "Verificado "
                            : "No Verificado "
                        }}
                        <a
                          :href="
                            orderDataShow.attributes.client.attributes.document_seal_url
                          "
                          target="Blank"
                          v-if="
                            orderDataShow.attributes.client.attributes
                              .document_seal_url !== null
                          "
                        >
                          - Ver imagen</a
                        >
                      </span>
                    </div>
                  </div>
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Código de Usuario:</span>
                      <span class="details-title-item">
                        {{
                          orderDataShow.attributes.client.attributes.profile.attributes
                            .userable.client_code
                        }}
                        -
                        <router-link
                          :to="{
                            name: 'UserDetail',
                            params: { idUser: orderDataShow.attributes.client.id },
                          }"
                          target="_blank"
                          >Ver perfil</router-link
                        >
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End- si la orden es sendi o envios - detalle del cliente -->
            <!-- Start- si la orden es sendi o envios - detalle de la direcciòn -->
            <div class="details-content">
              <div id="accordion">
                <div
                  class="details-content-title collapsed"
                  id="information3"
                  data-toggle="collapse"
                  data-target="#clientInformation3"
                  aria-expanded="false"
                  aria-controls="clientInformation3"
                >
                  <span>Detalle de envío</span>

                  <div class="details-text up-arrow"></div>
                </div>

                <div
                  id="clientInformation3"
                  class="collapse"
                  aria-labelledby="information3"
                >
                  <span v-if="orderDataShow.attributes.shipping_address">
                    <!--data-parent="#accordion"-->
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Tipo:</span>
                        <span class="details-title-item"
                          >{{
                            orderDataShow.attributes.at_office_flag === 1
                              ? "Oficina"
                              : "Domicilio"
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Nombre:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.shipping_address.attributes
                              .owner_name
                          }}
                        </span>
                      </div>
                    </div>

                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Apellido:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.shipping_address.attributes
                              .owner_lastname
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Documento:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.shipping_address.attributes
                              .owner_document_number
                          }}
                        </span>
                      </div>
                    </div>

                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Teléfono:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.shipping_address.attributes
                              .telephone_number
                          }}</span
                        >
                      </div>
                    </div>

                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Dirección:</span>
                        <span class="details-title-item"
                          >{{
                            orderDataShow.attributes.shipping_address.attributes.address
                          }}
                        </span>
                      </div>
                    </div>

                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item"> Piso u Oficina:</span>
                        <span class="details-title-item"
                          >{{
                            orderDataShow.attributes.shipping_address.attributes.inner
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Referencia:</span>
                        <span class="details-title-item"
                          >{{
                            orderDataShow.attributes.shipping_address.attributes.reference
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Departamento:</span>
                        <span class="details-title-item"
                          >{{
                            orderDataShow.attributes.shipping_address.attributes
                              .department
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Provincia:</span>
                        <span class="details-title-item"
                          >{{ orderDataShow.attributes.shipping_address.attributes.city }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Distrito:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.shipping_address.attributes.district
                          }}
                        </span>
                      </div>
                    </div>
                  </span>
                  <span v-else>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Tipo:</span>
                        <span class="details-title-item"
                          >{{
                            orderDataShow.attributes.at_office_flag === 1
                              ? "Oficina"
                              : "Domicilio"
                          }}
                        </span>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <!-- End- si la orden es sendi o envios - detalle de la direcciòn -->
            <!-- Start- si la orden es sendi o envios - detalle del presupuesto -->
            <div class="details-content">
              <div id="accordion">
                <div
                  class="details-content-title collapsed"
                  id="information4"
                  data-toggle="collapse"
                  data-target="#clientInformation4"
                  aria-expanded="false"
                  aria-controls="clientInformation4"
                >
                  <span>Detalle del presupuesto</span>

                  <div class="details-text up-arrow"></div>
                </div>

                <div
                  id="clientInformation4"
                  class="collapse"
                  aria-labelledby="information4"
                >
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span
                        class="details-title-item"
                        :style="
                          orderDataShow.attributes.direct_type === 1 ? 'color:red;' : ''
                        "
                        >Precio del producto:</span
                      >
                      <span
                        class="details-title-item"
                        :style="
                          orderDataShow.attributes.direct_type === 1 ? 'color:red;' : ''
                        "
                        >USD
                        {{
                          (
                            orderDataShow.attributes.real_price *
                            orderDataShow.attributes.product_specimens
                          ).toFixed(2)
                        }}
                      </span>
                    </div>
                    <div class="details-title-block">
                      <span
                        class="details-title-item"
                        :style="
                          orderDataShow.attributes.direct_type === 1 ? 'color:red;' : ''
                        "
                        >Shipping:</span
                      >
                      <span
                        class="details-title-item"
                        :style="
                          orderDataShow.attributes.direct_type === 1 ? 'color:red;' : ''
                        "
                        >USD {{ orderDataShow.attributes.real_shipping.toFixed(2) }}
                      </span>
                    </div>
                    <div class="details-title-block">
                      <span
                        class="details-title-item"
                        :style="
                          orderDataShow.attributes.direct_type === 1 ? 'color:red;' : ''
                        "
                        >Tax:</span
                      >
                      <span
                        class="details-title-item"
                        :style="
                          orderDataShow.attributes.direct_type === 1 ? 'color:red;' : ''
                        "
                        >USD {{ orderDataShow.attributes.real_tax.toFixed(2) }}
                      </span>
                    </div>
                    <div class="details-title-block">
                      <span class="details-title-item">Seguro/Warehouse:</span>
                      <span class="details-title-item"
                        >USD {{ orderDataShow.attributes.warehouse }}
                      </span>
                    </div>
                    <div class="details-title-block">
                      <span class="details-title-item">Flete/Millas de vuelo:</span>
                      <span class="details-title-item"
                        >USD {{ orderDataShow.attributes.flete_cost.toFixed(2) }}
                      </span>
                    </div>
                    <div class="details-title-block">
                      <span class="details-title-item">Ad valorem/Recompensa:</span>
                      <span class="details-title-item"
                        >USD {{ orderDataShow.attributes.ad_valorem.toFixed(2) }}
                      </span>
                    </div>
                    <div class="details-title-block">
                      <span class="details-title-item">Igv/Recompensa:</span>
                      <span class="details-title-item"
                        >USD {{ orderDataShow.attributes.igv.toFixed(2) }}
                      </span>
                    </div>
                    <div class="details-title-block">
                      <span class="details-title-item">Ipm/Recompensa:</span>
                      <span class="details-title-item"
                        >USD {{ orderDataShow.attributes.ipm.toFixed(2) }}
                      </span>
                    </div>
                    <div class="details-title-block">
                      <span class="details-title-item"
                        >Tramite aduanero/Margen de servicio:</span
                      >
                      <span class="details-title-item"
                        >USD {{ orderDataShow.attributes.tramite_aduanero.toFixed(2) }}
                      </span>
                    </div>
                    <div class="details-title-block">
                      <span class="details-title-item">Envío nacional:</span>
                      <span class="details-title-item"
                        >USD {{ orderDataShow.attributes.national_shipping.toFixed(2) }}
                      </span>
                    </div>

                    <div
                      class="details-title-block"
                      v-if="
                        orderDataShow.attributes.coupon_discount !== null &&
                        orderDataShow.attributes.coupon_id !== null
                      "
                    >
                      <span class="details-title-item">Cupones:</span>
                      <span class="details-title-item"
                        >USD {{ orderDataShow.attributes.coupon_discount }} - "{{
                          orderDataShow.attributes.coupon.attributes.code
                        }}"
                      </span>
                    </div>

                    <div
                      class="details-title-block"
                      v-if="
                        orderDataShow.attributes.coupon_discount !== null &&
                        orderDataShow.attributes.coupon_id === null
                      "
                    >
                      <span class="details-title-item">Campaña: </span>
                      <span class="details-title-item"
                        >USD {{ orderDataShow.attributes.coupon_discount }} - "{{
                          orderDataShow.attributes.campaign.attributes.code
                        }}"
                      </span>
                    </div>

                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.balance_discount !== null"
                    >
                      <span class="details-title-item">Balance:</span>
                      <span class="details-title-item"
                        >USD {{ orderDataShow.attributes.balance_discount }}
                      </span>
                    </div>

                    <div class="details-title-block">
                      <span class="details-title-item">Servicios Extras :</span>
                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.services.length === 0"
                      >
                        Sin servicios extras
                      </span>
                      <span class="details-title-item" v-else>
                        <ul>
                          <li
                            v-for="data in orderDataShow.attributes.services"
                            :key="data"
                          >
                            {{ data.name }} - USD {{ data.pivot.amount }}
                          </li>
                        </ul>
                      </span>
                    </div>

                    <div class="details-title-block">
                      <span class="details-title-item">Total:</span>
                      <span class="details-title-item"
                        >USD
                        {{
                          orderDataShow.attributes.new_total_cost === null
                            ? orderDataShow.attributes.total_cost.toFixed(2)
                            : orderDataShow.attributes.new_total_cost.toFixed(2)
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- End- si la orden es sendi o envios - detalle del presupuesto -->
            <!-- Start- si la orden es sendi o envios - detalles de pago -->
            <div class="details-content">
              <div id="accordion">
                <div
                  class="details-content-title collapsed"
                  id="information5"
                  data-toggle="collapse"
                  data-target="#clientInformation5"
                  aria-expanded="false"
                  aria-controls="clientInformation5"
                >
                  <span>Detalle de Pago</span>

                  <div class="details-text up-arrow"></div>
                </div>

                <div
                  id="clientInformation5"
                  class="collapse"
                  aria-labelledby="information5"
                >
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Moneda:</span>
                      <span class="details-title-item"
                        >{{ orderDataShow.attributes.currency }}
                      </span>
                    </div>
                    <div class="details-title-block">
                      <span class="details-title-item">Monto Abonado:</span>
                      <span class="details-title-item"
                        >{{ orderDataShow.attributes.currency }}
                        {{
                          (
                            orderDataShow.attributes.total_cost *
                            orderDataShow.attributes.exchange
                          ).toFixed(2)
                        }}
                      </span>
                    </div>
                    <div class="details-title-block">
                      <span class="details-title-item">Status de pago:</span>

                      <span class="details-title-item">
                        <span v-for="status in statusPayment" :key="status">
                          <span v-if="orderDataShow.attributes.payed === status.id">
                            {{ status.text }}
                          </span>
                        </span>
                      </span>
                    </div>
                    <div class="details-title-block">
                      <span class="details-title-item">Método de pago:</span>
                      <span class="details-title-item"
                        ><span
                          class="details-title-item"
                          style="color: #212529"
                          v-if="orderDataShow.attributes.payment_method_flag === 4"
                          >Pago Efectivo - {{orderDataShow.attributes.atm_payment.payment_code}}
                        </span>
                        <span
                          class="details-title-item"
                          style="color: #212529"
                          v-if="orderDataShow.attributes.payment_method_flag === 6"
                          >Saldo
                        </span>
                        <span
                          class="details-title-item"
                          style="color: #212529"
                          v-if="orderDataShow.attributes.payment_method_flag === 5"
                          >Transferencia
                        </span>
                        <span
                          class="details-title-item"
                          style="color: #212529"
                          v-if="orderDataShow.attributes.payment_method_flag === 2"
                          >Paypal
                        </span>
                        <span
                          class="details-title-item"
                          style="color: #212529"
                          v-if="orderDataShow.attributes.payment_method_flag === 3"
                          >Tarjeta
                        </span>
                      </span>
                    </div>

                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.payment_method_flag === 4"
                    >
                      <span class="details-title-item">Código de referencia:</span>
                      <span class="details-title-item">
                        {{
                          orderDataShow.attributes.atm_payment.mp_payment_id
                            ? orderDataShow.attributes.atm_payment.mp_payment_id
                            : "Sin código"
                        }}
                      </span>
                    </div>

                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.payment_method_flag === 6"
                    >
                      <span class="details-title-item">Código de referencia:</span>
                      <span class="details-title-item">
                        Realizo el pago con su saldo
                      </span>
                    </div>

                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.payment_method_flag === 5"
                    >
                      <span class="details-title-item">Código de referencia:</span>
                      <span class="details-title-item">
                        <ul class="listStyle" style="padding: 0">
                          <ol>
                            {{
                              orderDataShow.attributes.payment_code
                                ? orderDataShow.attributes.payment_code
                                : "Sin código"
                            }}
                          </ol>
                          <br />

                          <ol>
                            <input
                              type="text"
                              class="form-control"
                              v-model="codigoTransferencia"
                              placeholder="Código de referencia"
                              :disabled="orderDataShow.attributes.status === 10"
                            />
                          </ol>
                          <br />
                          <ol>
                            <button
                              :disabled="orderDataShow.attributes.status === 10"
                              class="btn btn-primary"
                              @click.prevent="sendVaucherComprobante(1)"
                            >
                              Cambiar
                            </button>
                          </ol>
                        </ul>
                      </span>
                    </div>

                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.payment_method_flag === 2"
                    >
                      <span class="details-title-item">Código de referencia:</span>
                      <span class="details-title-item">
                        {{
                          orderDataShow.attributes.paypalPayment.attributes
                            .paypal_authorization_id
                            ? orderDataShow.attributes.paypalPayment.attributes
                                .paypal_authorization_id
                            : "Sin código"
                        }}
                      </span>
                    </div>

                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.payment_method_flag === 3"
                    >
                      <span class="details-title-item">Código de referencia:</span>
                      <span class="details-title-item">
                        {{
                          orderDataShow.attributes.mercadopagoPayment.attributes
                            .payment_id
                            ? orderDataShow.attributes.mercadopagoPayment.attributes
                                .payment_id
                            : "Sin código"
                        }}
                      </span>
                    </div>

                    <div class="details-title-block">
                      <span class="details-title-item">Comprobante de pago:</span>
                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.voucher_link === null"
                      >
                        <ul class="listStyle" style="padding: 0">
                          <ol>
                            Sin comprobante
                          </ol>
                          <br />
                          <ol>
                            <input
                              type="file"
                              @change="comprobante"
                              ref="fileuploadComprobante"
                              accept="image/*,.pdf"
                              :disabled="orderDataShow.attributes.status === 10"
                            />
                          </ol>
                        </ul>
                      </span>
                      <span class="details-title-item" v-else>
                        <ul class="listStyle" style="padding: 0">
                          <ol>
                            <a
                              :href="orderDataShow.attributes.voucher_link"
                              target="_blank"
                              >Ver comprobante</a
                            >
                          </ol>
                          <br />
                          <ol>
                            <input
                              type="file"
                              ref="fileuploadComprobante"
                              @change="comprobante"
                              accept="image/*,.pdf"
                              :disabled="orderDataShow.attributes.status === 10"
                            />
                          </ol>
                        </ul>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End- si la orden es sendi o envios - detalles de pago -->

            <!-- Start- si la orden es sendi o envios - detalles de tracking -->
            <div class="details-content">
              <div id="accordion">
                <div
                  class="details-content-title collapsed"
                  id="information6"
                  data-toggle="collapse"
                  data-target="#clientInformation6"
                  aria-expanded="false"
                  aria-controls="clientInformation6"
                >
                  <span>Detalle de Tracking</span>

                  <div class="details-text up-arrow"></div>
                </div>

                <div
                  id="clientInformation6"
                  class="collapse"
                  aria-labelledby="information6"
                >
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">N° de tracking:</span>
                      <span class="details-title-item"
                        >{{ orderDataShow.attributes.system_tracking_number }}
                      </span>
                    </div>
                    <div class="details-title-block">
                      <span class="details-title-item">Status del tracking:</span>
                      <span class="details-title-item">
                        {{
                          orderDataShow.attributes.order_tracking_details[
                            orderDataShow.attributes.order_tracking_details.length - 1
                          ].attributes.status
                        }}
                        -
                        <span v-for="tracking in statusTracking" :key="tracking">
                          <span
                            v-if="
                              tracking.id ===
                              orderDataShow.attributes.order_tracking_details[
                                orderDataShow.attributes.order_tracking_details.length - 1
                              ].attributes.status
                            "
                          >
                            {{ tracking.text }}</span
                          >
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End- si la orden es sendi o envios - detalles de tracking -->
          </span>
          <span v-if="orderDataShow.attributes.type !== 2">
            <div class="details-content">
              <div id="accordion">
                <div
                  class="details-content-title collapsed"
                  id="headingclient"
                  data-toggle="collapse"
                  data-target="#collapseclient"
                  aria-expanded="false"
                  aria-controls="collapseclient"
                >
                  <span>Datos del cliente</span>

                  <div class="details-text up-arrow"></div>
                </div>

                <div id="collapseclient" class="collapse" aria-labelledby="headingclient">
                  <!--data-parent="#accordion"-->

                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span
                        class="details-title-item"
                        v-if="
                          orderDataShow.attributes.is_from_grabr_flag &&
                          orderDataShow.attributes.grabrOrder.attributes
                            .client_grabr_id != null
                        "
                        >ID de cliente:</span
                      >

                      <span class="details-title-item" v-else>Código:</span>
                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.is_from_meli_flag"
                        >{{ orderDataShow.attributes.meliOrder.attributes.customer_id }}
                      </span>

                      <span
                        class="details-title-item"
                        v-else-if="
                          (orderDataShow.attributes.is_from_grabr_flag &&
                            orderDataShow.attributes.grabrOrder.attributes
                              .client_grabr_id == null) ||
                          orderDataShow.attributes.is_from_linio_flag
                        "
                        >{{
                          orderDataShow.attributes.external_client_dni != null
                            ? orderDataShow.attributes.external_client_dni
                            : "No definido"
                        }}
                      </span>

                      <span
                        class="details-title-item"
                        v-else-if="
                          !orderDataShow.attributes.is_from_grabr_flag &&
                          !orderDataShow.attributes.is_from_linio_flag &&
                          !orderDataShow.attributes.is_from_meli_flag
                        "
                      >
                        {{
                          orderDataShow.attributes.client.attributes.profile.attributes
                            .document_number
                        }}</span
                      >

                      <span
                        class="details-title-item"
                        v-else-if="
                          orderDataShow.attributes.is_from_grabr_flag &&
                          orderDataShow.attributes.grabrOrder.attributes
                            .client_grabr_id != null
                        "
                      >
                        <a
                          :href="
                            'https://grabr.io/es/users/' +
                            orderDataShow.attributes.grabrOrder.attributes.client_grabr_id
                          "
                          target="_blank"
                        >
                          {{
                            orderDataShow.attributes.grabrOrder.attributes.client_grabr_id
                          }}
                        </a>
                      </span>
                    </div>

                    <div class="details-title-block">
                      <span class="details-title-item">Nombres y apellidos:</span>

                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.is_from_grabr_flag"
                        >{{ orderDataShow.attributes.external_client_name }}</span
                      >

                      <span
                        class="details-title-item"
                        v-else-if="orderDataShow.attributes.is_from_linio_flag"
                        >{{
                          orderDataShow.attributes.linioOrder.attributes
                            .customer_first_name +
                          " " +
                          orderDataShow.attributes.linioOrder.attributes
                            .customer_last_name
                        }}</span
                      >

                      <span
                        class="details-title-item"
                        v-else-if="orderDataShow.attributes.is_from_meli_flag"
                        >{{
                          orderDataShow.attributes.meliOrder.attributes
                            .customer_first_name +
                          " " +
                          orderDataShow.attributes.meliOrder.attributes.customer_last_name
                        }}</span
                      >

                      <span class="details-title-item" v-else>{{
                        orderDataShow.attributes.client.attributes.profile.attributes
                          .name +
                        " " +
                        orderDataShow.attributes.client.attributes.profile.attributes
                          .surnames
                      }}</span>
                    </div>

                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.is_from_meli_flag"
                    >
                      <span class="details-title-item">Nickname:</span>
                      <span class="details-title-item">{{
                        orderDataShow.attributes.meliOrder.attributes.customer_nickname
                      }}</span>
                    </div>

                    <div class="details-title-block">
                      <span class="details-title-item">Número telefónico:</span>
                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.is_from_meli_flag"
                        >{{
                          orderDataShow.attributes.meliOrder.attributes.customer_phone
                        }}</span
                      >

                      <span
                        class="details-title-item"
                        v-else-if="
                          orderDataShow.attributes.is_from_grabr_flag ||
                          orderDataShow.attributes.is_from_linio_flag ||
                          orderDataShow.attributes.is_from_meli_flag
                        "
                      >
                        {{
                          orderDataShow.attributes.external_client_cellphone != null
                            ? orderDataShow.attributes.external_client_cellphone
                            : "No definido"
                        }}
                      </span>

                      <span class="details-title-item" v-else>{{
                        orderDataShow.attributes.client.attributes.profile.attributes
                          .cellphone
                      }}</span>
                    </div>
                    <!-- <div class="details-title-block">
                      <span class="details-title-item">Correo:</span>
                      <span class="details-title-item">{{
                        orderDataShow.attributes.client.attributes.profile.attributes
                          .userable.attributes.email

                          
                      }}</span>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>

            <div
              class="details-content"
              v-if="
                orderDataShow.attributes.is_from_linio_flag ||
                orderDataShow.attributes.is_from_meli_flag
              "
            >
              <div id="accordion">
                <div
                  class="details-content-title collapsed"
                  id="headingshipping"
                  data-toggle="collapse"
                  data-target="#collapseshipping"
                  aria-expanded="false"
                  aria-controls="collapseshipping"
                >
                  <span>Datos de envío</span>

                  <div class="details-text up-arrow"></div>
                </div>

                <div
                  id="collapseshipping"
                  class="collapse"
                  aria-labelledby="headingshipping"
                >
                  <!--data-parent="#accordion"-->

                  <div
                    class="details-content-info"
                    v-if="orderDataShow.attributes.hasshipping"
                  >
                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.is_from_meli_flag"
                    >
                      <span class="details-title-item">Código de envío: </span>
                      <span class="details-title-item">{{
                        orderDataShow.attributes.meliOrder.attributes.shipping_id
                      }}</span>
                    </div>

                    <div class="details-title-block">
                      <span class="details-title-item">Dirección 1: </span>

                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.is_from_meli_flag"
                        >{{
                          orderDataShow.attributes.meliOrder.attributes
                            .shipping_address != null
                            ? orderDataShow.attributes.meliOrder.attributes
                                .shipping_address
                            : "No definido"
                        }}</span
                      >
                      <span
                        class="details-title-item"
                        v-else-if="orderDataShow.attributes.is_from_linio_flag"
                        >{{
                          orderDataShow.attributes.linioOrder.attributes
                            .shipping_address != null
                            ? orderDataShow.attributes.linioOrder.attributes
                                .shipping_address
                            : "No definido"
                        }}</span
                      >
                    </div>

                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.is_from_meli_flag"
                    >
                      <span class="details-title-item">Dirección 2: </span>

                      <span class="details-title-item">{{
                        orderDataShow.attributes.meliOrder.attributes.shipping_comment !=
                        null
                          ? orderDataShow.attributes.meliOrder.attributes.shipping_comment
                          : "No definido"
                      }}</span>
                    </div>

                    <div class="details-title-block">
                      <span class="details-title-item">Distrito: </span>

                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.is_from_meli_flag"
                        >{{
                          orderDataShow.attributes.meliOrder.attributes
                            .shipping_neighborhood != null
                            ? orderDataShow.attributes.meliOrder.attributes
                                .shipping_neighborhood
                            : "No definido"
                        }}</span
                      >
                      <span
                        class="details-title-item"
                        v-else-if="orderDataShow.attributes.is_from_linio_flag"
                        >{{
                          orderDataShow.attributes.linioOrder.attributes
                            .shipping_neighborhood != null
                            ? orderDataShow.attributes.linioOrder.attributes
                                .shipping_neighborhood
                            : "No definido"
                        }}</span
                      >
                    </div>

                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.is_from_meli_flag"
                    >
                      <span class="details-title-item">Ciudad: </span>

                      <span class="details-title-item">{{
                        orderDataShow.attributes.meliOrder.attributes.shipping_city !=
                        null
                          ? orderDataShow.attributes.meliOrder.attributes.shipping_city
                          : "No definido"
                      }}</span>
                    </div>
                  </div>
                  <div class="details-content-info" v-else>
                    <div class="details-title-block">
                      <span class="details-title-item">Método de entrega: </span>
                      <span class="details-title-item">Recojo en oficina</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="details-content">
              <div id="accordion">
                <div
                  class="details-content-title collapsed"
                  id="headingorder"
                  data-toggle="collapse"
                  data-target="#collapseorder"
                  aria-expanded="false"
                  aria-controls="collapseorder"
                >
                  <span>Datos de compra</span>

                  <div class="details-text up-arrow"></div>
                </div>

                <div id="collapseorder" class="collapse" aria-labelledby="headingorder">
                  <!--data-parent="#accordion"-->

                  <div class="details-content-info">
                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.is_from_grabr_flag"
                    >
                      <span class="details-title-item">ID de chat en Grabr:</span>

                      <span class="details-title-item">{{
                        orderDataShow.attributes.is_from_grabr_flag
                          ? orderDataShow.attributes.grabrOrder.attributes.grabr_chat_link
                          : ""
                      }}</span>
                    </div>

                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.is_from_grabr_flag"
                    >
                      <span class="details-title-item">Sku Grabr:</span>
                      <a
                        v-if="orderDataShow.attributes.sku != null"
                        :href="orderDataShow.attributes.linksku"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span
                          id="order-code"
                          class="code-order grabr-code enlace color"
                          v-b-popover.hover.top="'Código SKU'"
                          >{{
                            orderDataShow.attributes.grabrOrder.attributes
                              .grabr_purchase_link !== null
                              ? orderDataShow.attributes.grabrOrder.attributes
                                  .grabr_purchase_link
                              : "No definido"
                          }}</span
                        >
                      </a>
                    </div>

                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.is_from_linio_flag"
                    >
                      <span class="details-title-item">Sku Linio:</span>
                      <a
                        v-if="orderDataShow.attributes.sku != null"
                        :href="orderDataShow.attributes.linksku"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span
                          id="order-code"
                          class="code-order grabr-code enlace color"
                          v-b-popover.hover.top="'Código SKU'"
                          >{{
                            orderDataShow.attributes.linioOrder.attributes
                              .linio_purchase_link !== null
                              ? orderDataShow.attributes.linioOrder.attributes
                                  .linio_purchase_link
                              : "No definido"
                          }}</span
                        >
                      </a>
                    </div>

                    <div
                      class="details-title-block"
                      v-else-if="orderDataShow.attributes.is_from_meli_flag"
                    >
                      <span class="details-title-item">Sku Mercado Libre:</span>
                      <!-- <span class="details-title-item">{{ orderDataShow.attributes.meliOrder.attributes.meli_purchase_link!==null?orderDataShow.attributes.meliOrder.attributes.meli_purchase_link:"No definido"}}</span> -->
                      <a
                        v-if="orderDataShow.attributes.sku != null"
                        :href="orderDataShow.attributes.linksku"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span
                          id="order-code"
                          class="code-order grabr-code enlace color"
                          v-b-popover.hover.top="'Código SKU'"
                          >{{
                            orderDataShow.attributes.meliOrder.attributes.seller_sku !==
                            null
                              ? orderDataShow.attributes.meliOrder.attributes.seller_sku
                              : "No de finido"
                          }}</span
                        >
                      </a>
                    </div>

                    <div class="details-title-block">
                      <span class="details-title-item">Link de compra final:</span>

                      <span class="details-title-item"
                        ><a
                          :href="
                            orderDataShow.attributes.real_purchase_link !== null
                              ? orderDataShow.attributes.real_purchase_link
                              : 'No definido'
                          "
                          target="_blank"
                          >{{
                            orderDataShow.attributes.real_purchase_link !== null
                              ? orderDataShow.attributes.real_purchase_link
                              : "No definido"
                          }}</a
                        ></span
                      >
                    </div>

                    <div
                      class="details-title-block"
                      v-if="
                        orderDataShow.attributes.is_from_grabr_flag &&
                        orderDataShow.attributes.grabrOrder.attributes.travel_number
                      "
                    >
                      <span class="details-title-item">ID de viaje en Grabr:</span>

                      <span class="details-title-item"
                        ><a
                          :href="
                            'https://grabr.io/es/trips/' +
                            orderDataShow.attributes.grabrOrder.attributes.travel_number
                          "
                          target="_blank"
                          >{{
                            orderDataShow.attributes.grabrOrder.attributes.travel_number
                          }}</a
                        ></span
                      >
                    </div>

                    <div
                      class="details-title-block"
                      v-if="
                        orderDataShow.attributes.is_from_grabr_flag &&
                        orderDataShow.attributes.grabrOrder.attributes.grabr_account
                      "
                    >
                      <span class="details-title-item">Cuenta de Grabr:</span>

                      <span class="details-title-item">{{
                        orderDataShow.attributes.grabrOrder.attributes.grabr_account
                      }}</span>
                    </div>

                    <div
                      class="details-title-block"
                      v-else-if="
                        orderDataShow.attributes.is_from_linio_flag &&
                        orderDataShow.attributes.linioOrder.attributes.linio_account
                      "
                    >
                      <span class="details-title-item">Cuenta de Linio:</span>

                      <span class="details-title-item">{{
                        orderDataShow.attributes.linioOrder.attributes.linio_account
                      }}</span>
                    </div>

                    <div
                      class="details-title-block"
                      v-else-if="
                        orderDataShow.attributes.is_from_meli_flag &&
                        orderDataShow.attributes.meliOrder.attributes.meli_account
                      "
                    >
                      <span class="details-title-item">Cuenta de Mercado Libre:</span>

                      <span class="details-title-item">{{
                        orderDataShow.attributes.meliOrder.attributes.meli_account
                      }}</span>
                    </div>

                    <div class="details-title-block">
                      <span class="details-title-item">Ciudad de origen:</span>

                      <span class="details-title-item">{{
                        orderDataShow.attributes.origin != undefined
                          ? orderDataShow.attributes.origin.attributes.name
                          : "No definido (*)"
                      }}</span>
                    </div>

                    <div class="details-title-block">
                      <span class="details-title-item">Ciudad de destino:</span>

                      <span class="details-title-item">{{
                        orderDataShow.attributes.destination != undefined
                          ? orderDataShow.attributes.destination.attributes.name
                          : "No definido (*)"
                      }}</span>
                    </div>

                    <div class="details-title-block">
                      <span class="details-title-item">Fecha de llegada al origen:</span>

                      <span
                        class="details-title-item"
                        v-if="
                          orderDataShow.attributes.promised_origin_arrival_date != null
                        "
                        >{{
                          orderDataShow.attributes.promised_origin_arrival_date
                            | spanishDate
                        }}</span
                      >

                      <span class="details-title-item" v-else>No definido</span>
                    </div>

                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.real_origin_arrival_date != null"
                    >
                      <span class="details-title-item"
                        >Fecha real de llegada al origen:</span
                      >

                      <span class="details-title-item">{{
                        orderDataShow.attributes.real_origin_arrival_date | spanishDate
                      }}</span>
                    </div>

                    <div class="details-title-block">
                      <span class="details-title-item">Entrega prometida:</span>

                      <span class="details-title-item">{{
                        orderDataShow.attributes.promised_delivery_date | spanishDate
                      }}</span>
                    </div>

                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.real_delivery_date != null"
                    >
                      <span class="details-title-item"
                        >Fecha real de llegada al cliente:</span
                      >

                      <span class="details-title-item">{{
                        orderDataShow.attributes.real_delivery_date | spanishDate
                      }}</span>
                    </div>

                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.carrier_name != null"
                    >
                      <span class="details-title-item">Transportista:</span>

                      <span class="details-title-item">{{
                        orderDataShow.attributes.carrier_name
                      }}</span>
                    </div>

                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.shopping_order_number != null"
                    >
                      <span class="details-title-item">Número de compra:</span>

                      <span class="details-title-item">{{
                        orderDataShow.attributes.shopping_order_number
                      }}</span>
                    </div>

                    <div class="details-title-block">
                      <span class="details-title-item">Código de tracking:</span>

                      <span class="details-title-item">{{
                        orderDataShow.attributes.tracking_number !== null
                          ? orderDataShow.attributes.tracking_number
                          : "No definido"
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="details-content">
              <div id="accordion">
                <div
                  class="details-content-title collapsed"
                  id="headingclient"
                  data-toggle="collapse"
                  data-target="#collapsePago"
                  aria-expanded="false"
                  aria-controls="collapseclient"
                >
                  <span>Datos de Pago</span>

                  <div class="details-text up-arrow"></div>
                </div>

                <div id="collapsePago" class="collapse" aria-labelledby="headingclient">
                  <!--data-parent="#accordion"-->

                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Fecha de aprobación:</span>
                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.is_from_meli_flag"
                        >{{
                          orderDataShow.attributes.meliOrder.attributes
                            .payment_date_approved
                        }}
                      </span>
                      <span
                        class="details-title-item"
                        v-else-if="orderDataShow.attributes.is_from_linio_flag"
                        >{{
                          orderDataShow.attributes.linioOrder.attributes.linio_offer_date
                        }}
                      </span>
                    </div>

                    <div class="details-title-block">
                      <span class="details-title-item">Método de pago:</span>
                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.is_from_meli_flag"
                        >{{
                          orderDataShow.attributes.meliOrder.attributes.payment_method
                        }}
                      </span>
                      <span
                        class="details-title-item"
                        v-else-if="orderDataShow.attributes.is_from_linio_flag"
                        >{{
                          orderDataShow.attributes.linioOrder.attributes.payment_method
                        }}
                      </span>
                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.payment_method_flag === 4"
                        >Pago Efectivo - {{orderDataShow.attributes.atm_payment.payment_code}}
                      </span>
                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.payment_method_flag === 6"
                        >Saldo
                      </span>
                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.payment_method_flag === 5"
                        >Transferencia
                      </span>
                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.payment_method_flag === 1"
                        >Paypal
                      </span>
                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.payment_method_flag === 3"
                        >Tarjeta
                      </span>
                    </div>

                    <div
                      class="details-title-block"
                      v-if="orderDataShow.attributes.is_from_meli_flag"
                    >
                      <span class="details-title-item">Tipo de pago:</span>
                      <span class="details-title-item"
                        >{{ orderDataShow.attributes.meliOrder.attributes.payment_type }}
                      </span>
                    </div>

                    <div class="details-title-block">
                      <span class="details-title-item">Monto de pago:</span>
                      <span
                        class="details-title-item"
                        v-if="orderDataShow.attributes.is_from_meli_flag"
                        >S/
                        {{ orderDataShow.attributes.meliOrder.attributes.meli_price }}
                      </span>
                      <span
                        class="details-title-item"
                        v-else-if="orderDataShow.attributes.is_from_linio_flag"
                        >S/
                        {{ orderDataShow.attributes.linioOrder.attributes.linio_price }}
                      </span>
                      <span class="details-title-item"
                        >{{ orderDataShow.attributes.currency === "USD" ? "$ " : "S/ " }}
                        {{
                          (
                            orderDataShow.attributes.total_cost *
                            orderDataShow.attributes.exchange
                          ).toFixed(2)
                        }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </span>

          <div class="details-title-separator">
            <span>Comentarios</span>
          </div>
          <div class="details-content" v-if="true">
            <div
              class="details-content-comments"
              v-if="
                !(
                  orderDataShow.attributes.cancelled == 1 &&
                  orderDataShow.attributes.status == 10
                )
              "
            >
              <textarea
                type="text"
                v-model="currentContent"
                aria-describedby="email"
                class="form-control"
                :maxlength="1000"
                :disabled="!createCommentFlag"
                rows="1"
                placeholder="Deja tu comentario..."
              >
              </textarea>

              <div class="text-right">
                <div class="btn-wrap" v-if="currentContent.length != 0">
                  <button
                    :disabled="orderDataShow.attributes.status === 10"
                    class="btn btn-primary btn-block btn-round"
                    @click="createComment"
                  >
                    Enviar
                  </button>
                </div>

                <div class="btn-wrap" v-else>
                  <button
                    :disabled="orderDataShow.attributes.status === 10"
                    class="btn btn-primary btn-block btn-round"
                  >
                    Enviar
                  </button>
                </div>
              </div>
            </div>
            <comment-component
              v-for="(comment, index) in comments"
              :key="index"
              v-bind:comment="comment"
              v-bind:orderCancelledFlag="
                orderDataShow.attributes.status == 10 &&
                orderDataShow.attributes.cancelled == 1
              "
              v-bind:order="orderDataShow"
              @in-edition="disableEditComments"
              @cancel-edition="enableEditComments"
              @display-comments="displayComments"
              @comment-deleted="displayComments"
            ></comment-component>
          </div>
        </div>

        <div class="nm n-2" id="fixedElement">
          <!-- <button
            class="btn btn-primary mb-4 d-block w-100"
            style="font-size: 18px"
            @click="openModal('modal-reasignar')"
          >
            Reasignar orden
          </button> -->

          <div class="details-content">
            <div class="details-title-container">
              <div class="details-title-block details-summary-item">
                <!-- //start-Cambios Marco Antonio -sendi y envios -->
                <div class="details-title-item">
                  <span>No Gravado</span>
                </div>
                <span class="details-title-item">$ {{ noGravado }}</span>
                <!-- //end-Cambios Marco Antonio -sendi y envios -->
              </div>
              <div class="details-title-block details-summary-item">
                <!-- //start-Cambios Marco Antonio -sendi y envios -->
                <div class="details-title-item">
                  <span> Gravado</span>
                </div>
                <span class="details-title-item">$ {{ gravado }}</span>
                <!-- //end-Cambios Marco Antonio -sendi y envios -->
              </div>
              <div class="details-title-block details-summary-item">
                <!-- //start-Cambios Marco Antonio -sendi y envios -->
                <div class="details-title-item">
                  <span>IGV</span>
                </div>
                <span class="details-title-item">$ {{ totalIgv }}</span>
                <!-- //end-Cambios Marco Antonio -sendi y envios -->
              </div>
              <!-- start-Comentando para la nueva vista de sendi y envios -->
              <!-- <div class="details-title-block details-summary-item">
                <div class="details-title-item">
                  <span v-if="orderDataShow.attributes.is_from_grabr_flag"
                    >Precio Grabr</span
                  >

                  <span v-else-if="orderDataShow.attributes.is_from_linio_flag"
                    >Precio linio</span
                  >

                  <span v-else-if="orderDataShow.attributes.is_from_meli_flag"
                    >Precio Mercado Libre</span
                  >

                  <span v-else>Precio</span>

                  <div class="dropdown show help-q">
                    <img
                      src="/static/img/info-q.svg"
                      alt=""
                      id="dropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    />

                    <div
                      class="dropdown-menu sendi-tool"
                      aria-labelledby="dropdownMenuLink"
                    >
                      <div class="sendi-tool-content">
                        <span class="link-tool">
                          <span class="link-tool-title">Precio</span>
                        </span>

                        <span class="link-tool">
                          <span class="link-tool-subtitle"
                            >This device is carrier-unlocked and should work fully with
                            the carriers</span
                          >
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <span
                  class="details-title-item"
                  v-if="orderDataShow.attributes.is_from_grabr_flag"
                  >$
                  {{
                    orderDataShow.attributes.grabrOrder.attributes.grabr_price | currency
                  }}</span
                >

                <span
                  class="details-title-item"
                  v-else-if="orderDataShow.attributes.is_from_linio_flag"
                  >S/
                  {{
                    orderDataShow.attributes.linioOrder.attributes.linio_price | currency
                  }}</span
                >

                <span
                  class="details-title-item"
                  v-else-if="orderDataShow.attributes.is_from_meli_flag"
                  >S/ +{{
                    orderDataShow.attributes.meliOrder.attributes.meli_price | currency
                  }}</span
                >

                <span class="details-title-item" v-else
                  >${{ totalPrice | currency }}</span
                >
              </div>

              <div
                v-if="orderDataShow.attributes.is_from_grabr_flag"
                class="details-title-block details-summary-item"
              >
                <div class="details-title-item">
                  <span>Impuesto Grabr</span>

                  <div class="dropdown show help-q">
                    <img
                      src="/static/img/info-q.svg"
                      alt=""
                      id="dropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    />

                    <div
                      class="dropdown-menu sendi-tool"
                      aria-labelledby="dropdownMenuLink"
                    >
                      <div class="sendi-tool-content">
                        <span class="link-tool">
                          <span class="link-tool-title">Impuesto</span>
                        </span>

                        <span class="link-tool">
                          <span class="link-tool-subtitle"
                            >This device is carrier-unlocked and should work fully with
                            the carriers</span
                          >
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <span class="details-title-item">{{
                  orderDataShow.attributes.grabrOrder.attributes.grabr_tax | currency
                }}</span>
              </div>

              <div
                v-else-if="isDirect && orderDataShow.attributes.real_tax != null"
                class="details-title-block details-summary-item"
              >
                <div class="details-title-item">
                  <span>Impuesto</span>

                  <div class="dropdown show help-q">
                    <img
                      src="/static/img/info-q.svg"
                      alt=""
                      id="dropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    />

                    <div
                      class="dropdown-menu sendi-tool"
                      aria-labelledby="dropdownMenuLink"
                    >
                      <div class="sendi-tool-content">
                        <span class="link-tool">
                          <span class="link-tool-title">Impuesto</span>
                        </span>

                        <span class="link-tool">
                          <span class="link-tool-subtitle"
                            >This device is carrier-unlocked and should work fully with
                            the carriers</span
                          >
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <span class="details-title-item"
                  >$ {{ orderDataShow.attributes.real_tax | currency }}</span
                >
              </div>

              <div
                v-if="orderDataShow.attributes.is_from_grabr_flag"
                class="details-title-block details-summary-item"
              >
                <div class="details-title-item">
                  <span>Recompensa Grabr</span>

                  <div class="dropdown show help-q">
                    <img
                      src="/static/img/info-q.svg"
                      alt=""
                      id="dropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    />

                    <div
                      class="dropdown-menu sendi-tool"
                      aria-labelledby="dropdownMenuLink"
                    >
                      <div class="sendi-tool-content">
                        <span class="link-tool">
                          <span class="link-tool-title">Recompensa Grabr</span>
                        </span>

                        <span class="link-tool">
                          <span class="link-tool-subtitle"
                            >This device is carrier-unlocked and should work fully with
                            the carriers</span
                          >
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <span
                  class="details-title-item"
                  v-if="orderDataShow.attributes.grabrOrder.attributes.grabr_fee === null"
                  >$ 0</span
                >
                <span class="details-title-item" v-else
                  >$
                  {{
                    orderDataShow.attributes.grabrOrder.attributes.grabr_fee | currency
                  }}</span
                >
              </div>

              <div
                v-else-if="isDirect && orderDataShow.attributes.real_shipping != null"
                class="details-title-block details-summary-item"
              >
                <div class="details-title-item">
                  <span>Costo de envío</span>

                  <div class="dropdown show help-q">
                    <img
                      src="/static/img/info-q.svg"
                      alt=""
                      id="dropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    />

                    <div
                      class="dropdown-menu sendi-tool"
                      aria-labelledby="dropdownMenuLink"
                    >
                      <div class="sendi-tool-content">
                        <span class="link-tool">
                          <span class="link-tool-title">Costo de envío</span>
                        </span>

                        <span class="link-tool">
                          <span class="link-tool-subtitle"
                            >This device is carrier-unlocked and should work fully with
                            the carriers</span
                          >
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <span class="details-title-item"
                  >$ {{ orderDataShow.attributes.real_shipping | currency }}</span
                >
              </div>

              <div
                class="details-title-block details-summary-item"
                v-if="
                  orderDataShow.attributes.is_from_grabr_flag &&
                  orderDataShow.attributes.grabrOrder.attributes.approved_flag
                "
              >
                <div class="details-title-item">
                  <span>Adeudo</span>

                  <div class="dropdown show help-q">
                    <img
                      src="/static/img/info-q.svg"
                      alt=""
                      id="dropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    />

                    <div
                      class="dropdown-menu sendi-tool"
                      aria-labelledby="dropdownMenuLink"
                    >
                      <div class="sendi-tool-content">
                        <span class="link-tool">
                          <span class="link-tool-title">Adeudo</span>
                        </span>

                        <span class="link-tool">
                          <span class="link-tool-subtitle"
                            >This device is carrier-unlocked and should work fully with
                            the carriers</span
                          >
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <span class="details-title-item"
                  >$
                  {{
                    orderDataShow.attributes.grabrOrder.attributes.debit | currency
                  }}</span
                >
              </div>

              <div
                class="details-title-block details-summary-item"
                v-if="
                  orderDataShow.attributes.is_from_grabr_flag &&
                  orderDataShow.attributes.grabrOrder.attributes.approved_flag
                "
              >
                <a
                  class="adeudo"
                  v-if="orderDataShow.attributes.grabrOrder.attributes.debit_url != null"
                  :href="orderDataShow.attributes.grabrOrder.attributes.debit_url"
                  target="_blank"
                >
                  <button class="btn btn-lg btn-block btn-adeudo">
                    Pagar con<img
                      class="paypal-img"
                      src="/static/img/paypal.svg"
                      height="30"
                      alt="USA flag"
                    />
                  </button>
                </a>
              </div>

              <div
                class="details-title-block details-summary-item"
                v-else-if="
                  orderDataShow.attributes.is_from_linio_flag &&
                  orderDataShow.attributes.linioOrder.attributes.approved_flag
                "
              >
                <a
                  class="adeudo"
                  v-if="orderDataShow.attributes.linioOrder.attributes.debit_url != null"
                  :href="orderDataShow.attributes.linioOrder.attributes.debit_url"
                  target="_blank"
                >
                  <button class="btn btn-lg btn-block btn-adeudo">
                    Pagar con<img
                      class="paypal-img"
                      src="/static/img/paypal.svg"
                      height="30"
                      alt="USA flag"
                    />
                  </button>
                </a>
              </div>
              <div
                class="details-title-block details-summary-item"
                v-else-if="orderDataShow.attributes.is_from_meli_flag"
              >
                <span class="details-title-item">Comisión (9%)</span>
                <span
                  v-if="orderDataShow.attributes.is_from_meli_flag"
                  class="details-title-item"
                  >S/ -{{ (0.09 * totalPrice) | currency }}</span
                >
              </div> -->
            </div>

            <!-- <div
              class="details-title-container"
              v-if="orderDataShow.attributes.is_from_meli_flag"
            >
              <div class="details-title-block details-summary-item">
                <span class="details-title-item">Rebate Bruto</span>
                <span
                  v-if="orderDataShow.attributes.is_from_meli_flag"
                  class="details-title-item"
                  >S/ +{{
                    orderDataShow.attributes.meliOrder.attributes.rebate != null
                      ? orderDataShow.attributes.meliOrder.attributes.rebate
                      : 0 | currency
                  }}</span
                >
              </div>
              <div class="details-title-block details-summary-item">
                <span class="details-title-item">Comisión Rebate (9%)</span>
                <span
                  v-if="orderDataShow.attributes.is_from_meli_flag"
                  class="details-title-item"
                  >S/ -{{
                    (0.09 * orderDataShow.attributes.meliOrder.attributes.rebate)
                      | currency
                  }}</span
                >
              </div>
              <div class="details-title-block details-summary-item">
                <span class="details-title-item">REBATE NETO</span>
                <span
                  v-if="
                    orderDataShow.attributes.is_from_linio_flag ||
                    orderDataShow.attributes.is_from_meli_flag
                  "
                  class="details-title-item"
                  >S/
                  {{
                    (orderDataShow.attributes.meliOrder.attributes.rebate -
                      0.09 * orderDataShow.attributes.meliOrder.attributes.rebate)
                      | currency
                  }}</span
                >
              </div>
            </div> -->

            <!-- <div class="details-title-container"> -->
            <!-- <div class="details-title-block details-summary-item">
                <div class="details-title-item">
                  <span v-if="orderDataShow.attributes.is_from_grabr_flag"
                    >Total Grabr</span
                  >
                  <span v-else-if="orderDataShow.attributes.is_from_linio_flag"
                    >Total Linio</span
                  >
                  <span v-else-if="orderDataShow.attributes.is_from_meli_flag"
                    >Total Mercado Libre</span
                  >
                  <span v-else>Total</span>
                  <div class="dropdown show help-q">
                    <img
                      src="/static/img/info-q.svg"
                      alt=""
                      id="dropdownMenuLink"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    />

                    <div
                      class="dropdown-menu sendi-tool"
                      aria-labelledby="dropdownMenuLink"
                    >
                      <div class="sendi-tool-content">
                        <span class="link-tool">
                          <span class="link-tool-title">Total</span>
                        </span>

                        <span class="link-tool">
                          <span class="link-tool-subtitle"
                            >This device is carrier-unlocked and should work fully with
                            the carriers</span
                          >
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <span
                  v-if="orderDataShow.attributes.is_from_linio_flag"
                  class="details-title-item"
                  >S/ {{ totalPrice | currency }}</span
                >
                <span
                  v-else-if="orderDataShow.attributes.is_from_meli_flag"
                  class="details-title-item"
                  >S/ {{ totalMeli | currency }}</span
                >
                <span v-else class="details-title-item"
                  >$
                  {{ (totalPrice + orderDataShow.attributes.real_tax) | currency }}</span
                >
              </div>

              <div
                class="details-title-block details-summary-item"
                v-if="orderDataShow.attributes.is_from_meli_flag"
              >
                <span class="details-title-item">Total comisiones</span>
                <span class="details-title-item"
                  >S/ {{ totalCommissions | currency }}</span
                >
              </div>

              <div
                class="details-title-block summary-block-total details-summary-item"
                v-if="
                  orderDataShow.attributes.is_from_grabr_flag &&
                  orderDataShow.attributes.grabrOrder.attributes.approved_flag
                "
              >
                <span class="details-title-item">Total</span>

                <span class="details-title-item"
                  >$
                  {{
                    (orderDataShow.attributes.grabrOrder.attributes.grabr_price +
                      orderDataShow.attributes.grabrOrder.attributes.grabr_tax +
                      orderDataShow.attributes.grabrOrder.attributes.grabr_fee +
                      orderDataShow.attributes.grabrOrder.attributes.debit)
                      | currency
                  }}</span
                >
              </div>

              <div
                class="details-title-block summary-block-total details-summary-item"
                v-else-if="
                  orderDataShow.attributes.is_from_linio_flag &&
                  orderDataShow.attributes.linioOrder.attributes.approved_flag
                "
              >
                <span class="details-title-item">Total</span>

                <span class="details-title-item"
                  >S/
                  {{
                    (orderDataShow.attributes.linioOrder.attributes.linio_price +
                      orderDataShow.attributes.linioOrder.attributes.debit)
                      | currency
                  }}</span
                >
              </div>

              <div
                class="details-title-block summary-block-total details-summary-item"
                v-else-if="orderDataShow.attributes.is_from_meli_flag"
              >
                <span class="details-title-item">Total</span>
                <span class="details-title-item">S/ {{ totalNeto | currency }}</span>
              </div> -->

            <!-- <div
                v-if="
                  orderDataShow.attributes.payed == 1 &&
                  orderDataShow.attributes.status <= 7
                "
                class="details-title-container"
              >
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="confirmPendientOrder()"
                >
                  Confirmar pago
                </button>
              </div>

              <div
                v-if="orderDataShow.attributes.status <= 7"
                class="details-title-container"
              >
                <button
                  type="button"
                  class="btn btn-light"
                  style="border-color: red"
                  @click="showModalConfirmation()"
                >
                  Cancelar orden
                </button>
              </div>
              <button
                type="button"
                class="btn btn-danger"
                style="margin-top: 8px"
                @click="showModalConfirmationDelete()"
              >
                Eliminar orden
              </button> -->
            <!-- </div> -->
          </div>

          <div class="details-content">
            <div class="details-title-container">
              <!-- //start-Cambios Marco Antonio -sendi y envios -->

              <div class="details-title-block">
                <span class="details-title-item">Status del Pago :</span>
                <span class="details-title-item"
                  ><select
                    class="form-control"
                    v-model="pagosStatus"
                    @change="changeStatusPayment(pagosStatus)"
                    :disabled="orderDataShow.attributes.status === 10"
                  >
                    <option
                      v-for="status in statusPayment"
                      :key="status"
                      :value="status.id"
                      :selected="orderDataShow.attributes.payed === status.id"
                    >
                      {{ status.text }}
                    </option>
                  </select>
                </span>
              </div>

              <div class="details-title-block">
                <span class="details-title-item">Status del Tracking :</span>
                <span class="details-title-item">
                  <select
                    class="form-control"
                    v-model="trakingStatus"
                    @change="changeStatusTracking(trakingStatus)"
                    :disabled="
                      pagosStatus !== 3 || orderDataShow.attributes.status === 10
                    "
                  >
                    <option
                      v-for="tracking in statusTracking"
                      :key="tracking"
                      :value="tracking.id"
                      :selected="
                        orderDataShow.attributes.order_tracking_details[
                          orderDataShow.attributes.order_tracking_details.length - 1
                        ].attributes.status === tracking.id
                      "
                    >
                      {{ tracking.text }}
                    </option>
                  </select>
                </span>
              </div>
            </div>
          </div>

          <div class="details-content">
            <div id="accordion">
              <div
                class="details-content-title collapsed"
                id="informationD1"
                data-toggle="collapse"
                data-target="#clientInformationD1"
                aria-expanded="false"
                aria-controls="clientInformationD1"
              >
                <span>Order Evaluation</span>

                <div class="details-text up-arrow"></div>
              </div>

              <div
                id="clientInformationD1"
                class="collapse"
                aria-labelledby="informationD1"
              >
                <!--data-parent="#accordion"-->
                <div class="details-content-info">
                  <div class="details-title-block">
                    <span class="details-title-item">Precio:</span>
                    <span class="details-title-item">
                      <input type="number" class="form-control" />
                    </span>
                  </div>
                </div>
                <div class="details-content-info">
                  <div class="details-title-block">
                    <span class="details-title-item">Cantidad:</span>
                    <span class="details-title-item">
                      <input type="number" class="form-control" />
                    </span>
                  </div>
                </div>
                <div class="details-content-info">
                  <div class="details-title-block">
                    <span class="details-title-item">Peso:</span>
                    <span class="details-title-item">
                      <input type="number" class="form-control" />
                    </span>
                  </div>
                </div>
                <div class="details-content-info">
                  <div class="details-title-block">
                    <span class="details-title-item">Calcular:</span>
                    <span class="details-title-item">
                      <button
                        :disabled="orderDataShow.attributes.status === 10"
                        type="button"
                        class="btn btn-primary"
                      >
                        Calcular
                      </button></span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- SERVICIO RETURN -->
          <template>
            <div
              class="details-content"
              v-if="
                servicioReturn &&
                (orderDataShow.attributes.order_tracking_details[
                  orderDataShow.attributes.order_tracking_details.length - 1
                ].attributes.status === 9 ||
                  orderDataShow.attributes.order_tracking_details[
                    orderDataShow.attributes.order_tracking_details.length - 1
                  ].attributes.status === 10) &&
                orderDataShow.attributes.payed === 3
              "
            >
              <div id="accordion">
                <div
                  class="details-content-title collapsed"
                  id="serviioReturn"
                  data-toggle="collapse"
                  data-target="#clientServicioReturn"
                  aria-expanded="false"
                  aria-controls="clientServicioReturn"
                >
                  <span>Servicio Return</span>
                  <span
                    class="phil-success"
                    v-if="servicioReturn && orderDataShow.attributes.payed === 3"
                    >Pagado</span
                  >
                  <div class="details-text up-arrow"></div>
                </div>

                <div
                  id="clientServicioReturn"
                  class="collapse"
                  aria-labelledby="serviioReturn"
                >
                  <!--data-parent="#accordion"-->
                  <div class="details-content-info">
                    <span class="details-title-item">Adjunto:</span>

                    <input type="file" @change="fileReturn" class="form-control" />
                  </div>
                  <div class="details-content-info">
                    <ul>
                      <li
                        v-for="(data, index) in orderDataShow.attributes.serviceReturn"
                        :key="data"
                      >
                        <a :href="data.url_return" target="_Blank">
                          {{ index === 0 ? "Etiqueta de devolución" : "Evidencia" }}
                          <span v-if="index !== 0">
                            -
                            {{ index }}
                          </span>
                          <span style="color: red" @click.prevent="deleteFileReturn(data)"
                            >Eliminar</span
                          >
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="details-content" v-else>
              <div id="accordion">
                <div
                  class="details-content-title collapsed"
                  id="serviioReturn"
                  data-toggle="collapse"
                  data-target="#clientServicioReturn"
                  aria-expanded="false"
                  aria-controls="clientServicioReturn"
                >
                  <span>Servicio Return</span>
                  <span
                    class="phil-success"
                    v-if="servicioReturn && orderDataShow.attributes.payed === 3"
                    >Pagado</span
                  >
                  <div class="details-text up-arrow"></div>
                </div>

                <div
                  id="clientServicioReturn"
                  class="collapse"
                  aria-labelledby="serviioReturn"
                >
                  <!--data-parent="#accordion"-->
                  <div class="details-content-info">
                    <span class="details-title-item">Adjunto:</span>
                    <div style="cursor: not-allowed">
                      <input
                        type="file"
                        class="form-control"
                        style="pointer-events: none"
                      />
                    </div>
                  </div>
                  <div class="details-content-info">
                    <ul>
                      <li
                        v-for="(data, index) in orderDataShow.attributes.serviceReturn"
                        :key="data"
                      >
                        <a :href="data.url_return" target="_Blank">
                          {{ index === 0 ? "Etiqueta de devolución" : "Evidencia" }}
                          <span v-if="index !== 0">
                            -
                            {{ index }}
                          </span>
                          <span style="color: red" @click.prevent="deleteFileReturn(data)"
                            >Eliminar</span
                          >
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <!--Servidio ceckout-->
          <template>
            <div
              class="details-content"
              v-if="servicioCheckup "
            >
              <div id="accordion">
                <div
                  class="details-content-title collapsed"
                  id="servicioCheckout"
                  data-toggle="collapse"
                  data-target="#clientServicioCheckout"
                  aria-expanded="false"
                  aria-controls="clientServicioCheckout"
                >
                  <span>Servicio Checkup</span>
                  <span
                    class="phil-success"
                    v-if="servicioCheckup && orderDataShow.attributes.payed === 3"
                    >Pagado</span
                  >
                  <div class="details-text up-arrow"></div>
                </div>
                <div
                  id="clientServicioCheckout"
                  class="collapse"
                  aria-labelledby="servicioCheckout"
                >
                  <!--data-parent="#accordion"-->
                  <div class="details-content-info"></div>
                </div>
              </div>
            </div>
          </template>

          <!-- SERVICIO REVIEW -->
          <template>
            <div
              class="details-content"
              v-if="servicioReview && orderDataShow.attributes.payed === 3"
            >
              <div id="accordion">
                <div
                  class="details-content-title collapsed"
                  id="servicioReview"
                  data-toggle="collapse"
                  data-target="#clientServicioReview"
                  aria-expanded="false"
                  aria-controls="clientServicioReview"
                >
                  <span>Servicio Review</span>
                  <span
                    class="phil-success"
                    v-if="servicioReview && orderDataShow.attributes.payed === 3"
                    >Pagado</span
                  >
                  <div class="details-text up-arrow"></div>
                </div>

                <div
                  id="clientServicioReview"
                  class="collapse"
                  aria-labelledby="servicioReview"
                >
                  <!--data-parent="#accordion"-->
                  <div class="details-content-info">
                    <span class="details-title-item">Review:</span>
                    <span
                      v-for="reviewD in orderDataShow.attributes.Reviews"
                      :key="reviewD"
                    >
                      {{ reviewD.from_admin === 0 ? reviewD.mesagge_review : "" }}</span
                    >
                  </div>
                  <div class="details-content-info">
                    <span class="details-title-item">Respuesta:</span>

                    <span
                      v-for="reviewD in orderDataShow.attributes.Reviews"
                      :key="reviewD"
                    >
                      <span v-if="reviewD.from_admin !== 0">
                        . {{ reviewD.mesagge_review }}
                        <span v-if="reviewD.url_review">
                          - <a :href="reviewD.url_review" target="_Blank">Documento</a>
                        </span>
                        <br />
                      </span>
                    </span>

                    <span class="details-title-item" style="margin-top: 25px"
                      >Responder:</span
                    >
                    <form @submit.prevent="RespuestaReview">
                      <input
                        style="margin-bottom: 20px"
                        type="text"
                        class="form-control"
                        placeholder="Ingresar respuesta"
                        v-model="formReviewSer.respuesta"
                        required
                      />
                      <input
                        type="file"
                        @change="subirArchivoReview"
                        style="margin-bottom: 20px"
                      />
                      <button type="submit" class="form-control btn-primary">
                        Mandar respuesta
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="details-content" v-else>
              <div id="accordion">
                <div
                  class="details-content-title collapsed"
                  id="servicioReview"
                  data-toggle="collapse"
                  data-target="#clientServicioReview"
                  aria-expanded="false"
                  aria-controls="clientServicioReview"
                >
                  <span>Servicio Review</span>
                  <span
                    class="phil-success"
                    v-if="servicioReview && orderDataShow.attributes.payed === 3"
                    >Pagado</span
                  >
                  <div class="details-text up-arrow"></div>
                </div>
                <div
                  id="clientServicioReview"
                  class="collapse"
                  aria-labelledby="servicioReview"
                >
                  <!--data-parent="#accordion"-->
                  <div class="details-content-info">
                    <span class="details-title-item">Review:</span>
                    <span
                      v-for="reviewD in orderDataShow.attributes.Reviews"
                      :key="reviewD"
                    >
                      {{ reviewD.from_admin === 0 ? reviewD.mesagge_review : "" }}</span
                    >
                  </div>
                  <div class="details-content-info">
                    <span class="details-title-item">Respuesta:</span>

                    <span
                      v-for="reviewD in orderDataShow.attributes.Reviews"
                      :key="reviewD"
                    >
                      <span v-if="reviewD.from_admin !== 0">
                        . {{ reviewD.mesagge_review }}
                        <span v-if="reviewD.url_review">
                          - <a :href="reviewD.url_review" target="_Blank">Documento</a>
                        </span>
                        <br />
                      </span>
                    </span>

                    <span class="details-title-item" style="margin-top: 25px"
                      >Responder:</span
                    >
                    <form>
                      <input
                        style="margin-bottom: 20px"
                        type="text"
                        class="form-control"
                        placeholder="Ingresar respuesta"
                        required
                        readonly
                      />
                      <div style="cursor: not-allowed">
                        <input
                          type="file"
                          style="margin-bottom: 20px; pointer-events: none"
                        />
                      </div>
                      <button
                        type="button"
                        class="form-control btn-primary"
                        style="cursor: not-allowed"
                      >
                        Mandar respuesta
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div class="details-content">
            <div id="accordion">
              <div
                class="details-content-title collapsed"
                id="reasignarOrden"
                data-toggle="collapse"
                data-target="#clientOrderReasign"
                aria-expanded="false"
                aria-controls="clientOrderReasign"
              >
                <span>Reasignar orden</span>
                <div class="details-text up-arrow"></div>
              </div>
              <div
                id="clientOrderReasign"
                class="collapse"
                aria-labelledby="Reasignar orden"
              >
                <form @submit.prevent="getUserSearch">
                  <div class="form-group mt-3 w-100">
                    <label>ID del usuario</label>
                    <div class="form-client">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control d-block w-100 mb-3"
                          v-model="search.dni"
                          maxlength="8"
                          required
                        />

                        <div class="input-group-append w-100" id="button-addon4">
                          <button
                            :disabled="orderDataShow.attributes.status === 10"
                            type="submit"
                            class="btn btn-primary btn-lg btn-edit btn-subir d-block w-100"
                          >
                            Validar cliente
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="search.result !== null">
                    <p class="mx-0">Resultado:</p>
                    <div>
                      <span
                        style="cursor: pointer"
                        class="d-flex align-items-center mb-3"
                        @click.prevent="changeUserOrder"
                      >
                        <i class="fas fa-user-circle mr-3" style="font-size: 28px"></i>
                        <span>
                          {{
                            search.result.attributes.profile.attributes.name +
                            " " +
                            search.result.attributes.profile.attributes.surnames
                          }}</span
                        >
                      </span>
                    </div>
                  </div>
                  <div v-if="search.error">Cliente no existe en el sistema</div>
                </form>

                <span v-if="historyUser.length !== 0">
                  <div
                    id="accordion"
                    class="mt-4"
                    v-for="history in historyUser"
                    :key="history.id"
                  >
                    <div
                      class="details-content-title collapsed pb-2 mb-3"
                      style="border-bottom: 1px solid #ccc"
                      :id="'informationHistory' + history.id"
                      data-toggle="collapse"
                      :data-target="'#clientInformationHistory' + history.id"
                      aria-expanded="false"
                      :aria-controls="'clientInformationHistory' + history.id"
                    >
                      <article class="p-0">
                        <p style="font-size: 14px" class="m-0 mb-2">
                          Old Client Code:{{ history.oldClientCode }} -
                          {{ history.created_at }}
                        </p>
                      </article>
                      <div class="details-text up-arrow"></div>
                    </div>

                    <div
                      :id="'clientInformationHistory' + history.id"
                      class="collapse"
                      :aria-labelledby="'informationHistory' + history.id"
                    >
                      <!-- details-content-info
                    details-title-item -->
                      <span>
                        <div class="">
                          <div class="cursorNot details-info-viajero mx-2">
                            <span class="">idOrder:</span>
                            <span class="">{{ history.idOrder }}</span>
                          </div>
                        </div>
                      </span>
                      <span>
                        <div class="details-content-info">
                          <div class="cursorPointer details-info-viajero mx-2">
                            <span class="">oldClientCode:</span>
                            <span class="">
                              <router-link
                                :to="{
                                  name: 'UserDetail',
                                  params: { idUser: history.oldClientCode },
                                }"
                                target="_Blank"
                                >{{ history.oldClientCode }}</router-link
                              >
                            </span>
                          </div>
                        </div>
                      </span>
                      <span>
                        <div class="details-content-info">
                          <div class="cursorPointer details-info-viajero mx-2">
                            <span class="">newClientCode:</span>
                            <span class="">
                              <router-link
                                :to="{
                                  name: 'UserDetail',
                                  params: { idUser: history.newClientCode },
                                }"
                                target="_Blank"
                                >{{ history.newClientCode }}</router-link
                              >
                            </span>
                          </div>
                        </div>
                      </span>
                      <span>
                        <div class="details-content-info">
                          <div class="cursorNot details-info-viajero mx-2">
                            <span class="">status:</span>
                            <span class="">{{ history.status }}</span>
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>

          <div class="details-content">
            <div id="accordion">
              <div
                class="details-content-title collapsed"
                id="warehouseAsociar"
                data-toggle="collapse"
                data-target="#asociarWarehouse"
                aria-expanded="false"
                aria-controls="asociarWarehouse"
              >
                <span>Asociar Warehouse</span>

                <div class="details-text up-arrow"></div>
              </div>
              <div id="asociarWarehouse" class="collapse" aria-labelledby="Warehouse">
                <header class="switch">
                  <a
                    class="switch__link"
                    @click="changeSiwtch(1)"
                    :class="switchWR === 1 && 'switch__link--active'"
                  >
                    Buscar WR
                  </a>
                  <a
                    class="switch__link"
                    @click="changeSiwtch(2)"
                    :class="switchWR === 2 && 'switch__link--active'"
                  >
                    Crear WR
                  </a>
                  <div
                    class="switch__bg--active"
                    :class="switchWR === 1 ? 'switch__bg--left' : 'switch__bg--right'"
                  ></div>
                </header>
                <!--data-parent="#accordion"-->
                <div class="details-content-info" v-if="switchWR === 1">
                  <label style="font-weight: bold" for="">Buscar WR</label>

                  <span class="details-title-item">
                    <form @submit.prevent="searchWrehouse()" class="w-100">
                      <input
                        type="text"
                        class="form-control mb-3"
                        placeholder="Ingrese código"
                        v-model="searchWR"
                        required
                      />

                      <button
                        :disabled="orderDataShow.attributes.status === 10"
                        type="submit"
                        class="btn btn-primary d-block w-100"
                      >
                        Buscar
                      </button>
                    </form>
                  </span>
                </div>

                <div id="accordion" class="d-block mt-3" v-if="resultSearchWr">
                  <div
                    class="d-flex justify-content-between w-100"
                    id="search"
                    style="float: none"
                    data-toggle="collapse"
                    data-target="#clientsearch5"
                    aria-expanded="false"
                    aria-controls="clientsearch5"
                  >
                    <span>
                      {{ resultSearchWr.attributes.code }} -
                      <a
                        @click.prevent="updatePaquete(resultSearchWr.id)"
                        style="color: blue"
                        >asignar</a
                      >
                    </span>
                    <div class="details-text up-arrow"></div>
                  </div>

                  <div id="clientsearch5" class="collapse" aria-labelledby="search">
                    <div class="details-content-info">
                      <ul style="margin-top: 20px">
                        <li>
                          {{
                            resultSearchWr.attributes.purchase_order_id
                              ? resultSearchWr.attributes.purchase_order_id
                              : "Sin orden asignada"
                          }}
                        </li>
                        <li>{{ resultSearchWr.attributes.consignee }}</li>
                        <li>{{ resultSearchWr.attributes.remitter }}</li>
                        <li>{{ resultSearchWr.attributes.carrier }}</li>
                        <li>{{ resultSearchWr.attributes.tracking }}</li>
                        <li>{{ resultSearchWr.attributes.comment }}</li>
                        <li>{{ resultSearchWr.attributes.weight }}</li>

                        <li>
                          {{ resultSearchWr.attributes.weight_unit.attributes.key_name }}
                        </li>
                        <li
                          v-for="(image, index) in resultSearchWr.attributes.images"
                          :key="image"
                        >
                          <a :href="image.url" target="_Blank"
                            >Imagen - {{ index + 1 }}</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <form @submit.prevent="createPaquete" v-if="switchWR === 2">
                  <div class="details-content-info">
                    <label style="font-weight: bold" for="">Crear WR</label>

                    <span class="details-title-item">Remitente:</span>
                    <span class="details-title-item">
                      <input
                        type="text"
                        v-model="formCreate.remitter"
                        class="form-control"
                        required
                      />
                    </span>
                  </div>
                  <div class="details-content-info">
                    <span class="details-title-item">Destinatario (Consignatario):</span>
                    <span class="details-title-item">
                      <input
                        type="text"
                        v-model="formCreate.consignee"
                        class="form-control"
                        required
                      />
                    </span>
                  </div>
                  <div class="details-content-info">
                    <span class="details-title-item">Carrier:</span>
                    <span class="details-title-item">
                      <input
                        type="text"
                        v-model="formCreate.carrier"
                        class="form-control"
                        required
                      />
                    </span>
                  </div>
                  <div class="details-content-info">
                    <span class="details-title-item">Tracking:</span>
                    <span class="details-title-item">
                      <input
                        type="text"
                        v-model="formCreate.tracking"
                        class="form-control"
                        required
                      />
                    </span>
                  </div>
                  <div class="details-content-info">
                    <span class="details-title-item">Peso:</span>
                    <span class="details-title-item">
                      <input
                        v-model="formCreate.weight"
                        class="form-control"
                        required
                        type="number"
                        name="numero"
                        step="0.1"
                      />
                    </span>
                  </div>
                  <div class="details-content-info">
                    <span class="details-title-item">Unidad de peso:</span>
                    <span class="details-title-item">
                      <select class="form-control" v-model="formCreate.unidad" required>
                        <option selected="selected" :value="12">Kg</option>
                        <option selected="selected" :value="2">Lb</option>
                        <option selected="selected" :value="22">Oz</option>
                      </select>
                    </span>
                  </div>
                  <div class="details-content-info">
                    <span class="details-title-item">Comentario:</span>
                    <span class="details-title-item">
                      <textarea
                        v-model="formCreate.comment"
                        type="text"
                        name=""
                        class="form-control input"
                        rows="6"
                        required
                      ></textarea>
                    </span>
                  </div>
                  <div class="details-content-info">
                    <span class="details-title-item">Fotos del paquete:</span>
                    <span class="details-title-item">
                      <input
                        type="file"
                        @change="handleFileInput"
                        multiple
                        class="form-control"
                        :disabled="orderDataShow.attributes.status === 10"
                        required
                      />
                    </span>
                  </div>
                  <div class="details-content-info">
                    <button
                      :disabled="
                        orderDataShow.attributes.status === 10 ||
                        orderDataShow.attributes.warehouse_flag == 1
                      "
                      type="submit"
                      class="btn btn-primary d-block w-100 mb-3"
                    >
                      Guardar
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="details-content">
            <div id="accordion">
              <div
                class="details-content-title collapsed"
                id="warehouse"
                data-toggle="collapse"
                data-target="#clientWarehouse"
                aria-expanded="false"
                aria-controls="clientWarehouse"
              >
                <span>Warehouse</span>

                <div class="details-text up-arrow"></div>
              </div>
              <div id="clientWarehouse" class="collapse" aria-labelledby="Warehouse">
                <form @submit.prevent="createPaquete">
                  <div class="details-content-info">
                    <button
                      @click.prevent="limitchangePaquete()"
                      :disabled="
                        orderDataShow.attributes.status === 10 ||
                        listWarehouse.length === 0
                      "
                      class="btn d-block w-100"
                      :class="
                        orderDataShow.attributes.warehouse_flag == 0
                          ? 'btn-primary'
                          : 'btn-success'
                      "
                    >
                      <i
                        v-if="orderDataShow.attributes.warehouse_flag !== 0"
                        class="fas fa-check pr-2 pt-1"
                      ></i>
                      {{
                        orderDataShow.attributes.warehouse_flag == 0
                          ? "Items incompletos"
                          : "Items completos"
                      }}
                    </button>
                  </div>
                </form>
                <div
                  id="accordion"
                  style="margin-top: 25px"
                  v-for="data in listWarehouse"
                  :key="data"
                >
                  <div
                    class="details-content-title collapsed"
                    :id="'warehouse' + data.id"
                    data-toggle="collapse"
                    :data-target="'#clientwarehouse' + data.id"
                    aria-expanded="false"
                    :aria-controls="'clientwarehouse' + data.id"
                  >
                    <span>
                      {{ data.attributes.code }}
                      <a
                        @click.prevent="liberarWR(data.attributes.code)"
                        style="cursor: pointer; color: blue"
                      >
                        Liberar
                      </a></span
                    >

                    <div class="details-text up-arrow"></div>
                  </div>

                  <div
                    :id="'clientwarehouse' + data.id"
                    class="collapse"
                    :aria-labelledby="'warehouse' + data.id"
                  >
                    <ul>
                      <li>{{ data.attributes.purchase_order_id }}</li>
                      <li>{{ data.attributes.consignee }}</li>
                      <li>{{ data.attributes.remitter }}</li>
                      <li>{{ data.attributes.carrier }}</li>
                      <li>{{ data.attributes.tracking }}</li>
                      <li>{{ data.attributes.comment }}</li>
                      <li>{{ data.attributes.weight }}</li>
                      <li>{{ data.attributes.weight_unit.attributes.key_name }}</li>
                      <li v-for="(image, index) in data.attributes.images" :key="image">
                        <a :href="image.url" target="_Blank">Imagen - {{ index + 1 }}</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="details-content">
            <div id="accordion">
              <div
                class="details-content-title collapsed"
                id="informationEntregaDeSendi"
                data-toggle="collapse"
                data-target="#clientInformationEntregaDeSendi"
                aria-expanded="false"
                aria-controls="clientInformationEntregaDeSendi"
              >
                <span>Entrega de Sendi</span>

                <div class="details-text up-arrow"></div>
              </div>

              <div
                id="clientInformationEntregaDeSendi"
                class="collapse"
                aria-labelledby="informationEntregaDeSendi"
              >
                <!--data-parent="#accordion"-->
                <div class="details-content-info">
                  <span>
                    <form action="" @submit.prevent="saveEntregaSendi">
                      <div class="details-title-block">
                        <span class="details-title-item">Entrega :</span>
                        <span class="details-title-item"> </span>
                      </div>

                      <div class="details-content-info">
                        <span class="details-title-item">
                          <select
                            v-model="entregaSendi.entrega"
                            class="form-control"
                            required
                          >
                            <option value="Oficina">Oficina</option>
                            <option value="Dirección">Dirección</option>
                          </select>
                        </span>
                      </div>
                      <div class="details-content-info">
                        <div class="details-title-block">
                          <span class="details-title-item">Descripción :</span>
                          <span class="details-title-item"> </span>
                        </div>
                      </div>
                      <div class="details-content-info">
                        <span class="details-title-item">
                          <textarea
                            v-model="entregaSendi.desciption"
                            required
                            class="form-control"
                            name=""
                            id=""
                            cols="30"
                            rows="10"
                          ></textarea>
                        </span>
                      </div>
                      <div class="details-content-info">
                        <div class="details-title-block">
                          <span class="details-title-item">Evidencia :</span>
                          <span class="details-title-item"> </span>
                        </div>
                      </div>
                      <div class="details-content-info">
                        <span class="details-title-item">
                          <input
                            @change="evidenciaSendi"
                            type="file"
                            class="form-control"
                            :disabled="orderDataShow.attributes.status === 10"
                            required
                          />
                        </span>
                      </div>
                      <div class="details-content-info">
                        <span class="details-title-item">
                          <button
                            :disabled="orderDataShow.attributes.status === 10"
                            type="submit"
                            class="btn btn-primary form-control"
                          >
                            Guardar
                          </button>
                        </span>
                      </div>
                    </form>

                    <div
                      id="accordion"
                      style="margin-top: 25px"
                      v-for="(data, index) in entregaSendiList"
                      :key="data"
                    >
                      <div
                        class="details-content-title collapsed"
                        :id="'entregaSendi' + data.id"
                        data-toggle="collapse"
                        :data-target="'#cliententregaSendi' + data.id"
                        aria-expanded="false"
                        :aria-controls="'cliententregaSendi' + data.id"
                      >
                        <span>
                          <center>
                            Evidencias - {{ index + 1 }} -
                            <span
                              style="color: red; cursor: pointer"
                              @click.prevent="deleteEntregaSendi(data.id)"
                              >Eliminar</span
                            >
                          </center></span
                        >

                        <div class="details-text up-arrow"></div>
                      </div>

                      <div
                        :id="'cliententregaSendi' + data.id"
                        class="collapse"
                        :aria-labelledby="'entregaSendi' + data.id"
                      >
                        <ul>
                          <li>{{ data.delivery }}</li>
                          <li>{{ data.description }}</li>
                          <li>
                            <a :href="data.evidence" target="_Blank">Ver imagen</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="details-content">
            <div id="accordion">
              <div
                class="details-content-title collapsed"
                id="informationD31223"
                data-toggle="collapse"
                data-target="#clientInformationD31223"
                aria-expanded="false"
                aria-controls="clientInformationD31223"
              >
                <span>Tracking</span>

                <div class="details-text up-arrow"></div>
              </div>

              <div
                id="clientInformationD31223"
                class="collapse"
                aria-labelledby="informationD31223"
              >
                <form style="margin-bottom: 20px">
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Código :</span>
                      <span class="details-title-item"> </span>
                    </div>
                  </div>

                  <div class="details-content-info">
                    <span class="details-title-item">
                      <input
                        v-model="localInternacionalTracking.codigo"
                        type="text"
                        class="form-control"
                        required
                        minlength="5"
                      />
                    </span>
                  </div>

                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Ruta :</span>
                      <span class="details-title-item"> </span>
                    </div>
                  </div>
                  <div class="details-content-info">
                    <span class="details-title-item">
                      <select
                        v-model="localInternacionalTracking.type"
                        class="form-control"
                        required
                      >
                        <option value="1">
                          {{ orderDataShow.attributes.origin.attributes.name }} -
                          {{ orderDataShow.attributes.destination.attributes.name }}
                        </option>
                        <option value="0">
                          {{ orderDataShow.attributes.destination.attributes.name }} -
                          {{ orderDataShow.attributes.origin.attributes.name }}
                        </option>
                      </select>
                    </span>
                  </div>

                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Tipo :</span>
                      <span class="details-title-item"> </span>
                    </div>
                  </div>
                  <div>
                    <select v-model="selectTracking" class="form-control" name="" id="">
                      <option value="L">Nacional Tracking</option>
                      <option value="I">International Tracking</option>
                    </select>
                  </div>

                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item"></span>
                      <span class="details-title-item">
                        <button
                          :disabled="orderDataShow.attributes.status === 10"
                          @click.prevent="
                            selectTracking === 'L'
                              ? createdLocalTracking()
                              : createdInternationalTracking()
                          "
                          type="submit"
                          class="btn btn-primary"
                        >
                          Guardar
                        </button></span
                      >
                    </div>
                  </div>
                </form>
                <span v-if="dataLocalTracking.length !== 0">NACIONAL</span>
                <!-- LocalInfo -->
                <div
                  id="accordion"
                  v-for="(data, index) in dataLocalTracking"
                  :key="data"
                  style="margin-bottom: 25px; margin-top: 12px"
                >
                  <div
                    class="details-content-title collapsed"
                    :id="'informationLocal' + index"
                    data-toggle="collapse"
                    :data-target="'#clientInformationLocal' + index"
                    aria-expanded="false"
                    :aria-controls="'clientInformationLocal' + index"
                  >
                    <span>
                      <img src="/static/img/olva.png" width="20" alt="" />
                      {{ data.data.general.remito }}-
                      {{ data.data.type === 1 ? "Ida" : "Vuelta" }} -
                      {{ data.data.details[0].estado_tracking }}<br />
                      <a
                        v-if="orderDataShow.attributes.status !== 10"
                        style="cursor: pointer; color: red"
                        @click.prevent="deleteTrackingLocal(data.data.general.remito)"
                        >Eliminar</a
                      >-<a
                        v-if="orderDataShow.attributes.status !== 10"
                        style="cursor: pointer; color: #5974bb"
                        @click.prevent="
                          changeHiddenLocal(data.data.general.remito, data.data.hide)
                        "
                      >
                        {{
                          data.data.hide === 1 || data.data.hide === true
                            ? "Ocultar"
                            : "Mostrar"
                        }}</a
                      >
                    </span>

                    <div class="details-text up-arrow"></div>
                  </div>

                  <div
                    :id="'clientInformationLocal' + index"
                    class="collapse"
                    :aria-labelledby="'informationLocal' + index"
                  >
                    <div v-for="items in data.data.details" :key="items">
                      <img
                        v-if="items.estado_tracking == 'ENTREGADO'"
                        src="https://www.tracktry.com/section/tracktry/images/Artboard-6.svg"
                        style="width: 10%"
                      />
                      <img
                        v-else-if="items.estado_tracking == 'REGISTRADO'"
                        src="https://www.tracktry.com/section/tracktry/images/Artboard-5.svg"
                        style="width: 10%"
                      />
                      <img
                        v-else
                        src="https://www.tracktry.com/section/tracktry/images/Artboard-1.svg"
                        style="width: 10%"
                      />
                      {{ items.fecha_creacion }}
                      <p>
                        <strong>{{ items.estado_tracking }}</strong
                        >, {{ items.obs }}
                      </p>
                    </div>

                    <div v-for="(images, index) in data.data.imagenes" :key="images">
                      <a :href="images.url" target="_Blank">Imagen - {{ index + 1 }}</a>
                    </div>
                  </div>
                </div>
                <!-- <span >INTERNACIONAL</span> -->
                <!-- InternationalInfo -->
                <!-- <div
                    id="accordion"
                    v-for="data in dataNationalTracking"
                    :key="data"
                    style="margin-bottom: 25px"
                  >
                    <div
                      class="details-content-title collapsed"
                      :id="
                        'information' +
                        data.data.trackings[0].shipment.trackingNumbers[0].tn
                      "
                      data-toggle="collapse"
                      :data-target="
                        '#clientInformation' +
                        data.data.trackings[0].shipment.trackingNumbers[0].tn
                      "
                      aria-expanded="false"
                      :aria-controls="
                        'clientInformation' +
                        data.data.trackings[0].shipment.trackingNumbers[0].tn
                      "
                    >
                      <span
                        >{{ data.data.trackings[0].shipment.trackingNumbers[0].tn }} -
                        {{ data.data.type === 1 ? "Ida" : "Vuelta" }} <br /><a
                          v-if="orderDataShow.attributes.status !== 10"
                          style="cursor: pointer; color: red"
                          @click.prevent="
                            deleteTracking(
                              data.data.trackings[0].shipment.trackingNumbers[0].tn
                            )
                          "
                          >Eliminar</a
                        >-<a
                          v-if="orderDataShow.attributes.status !== 10"
                          style="cursor: pointer; color: #5974bb"
                          @click.prevent="
                            changeHidden(
                              data.data.trackings[0].shipment.trackingNumbers[0].tn,
                              data.data.hide
                            )
                          "
                        >
                          {{
                            data.data.hide === 1 || data.data.hide === true
                              ? "Ocultar"
                              : "Mostrar"
                          }}</a
                        >
                      </span>

                      <div class="details-text up-arrow"></div>
                    </div>

                    <div
                      :id="
                        'clientInformation' +
                        data.data.trackings[0].shipment.trackingNumbers[0].tn
                      "
                      class="collapse"
                      :aria-labelledby="
                        'information' +
                        data.data.trackings[0].shipment.trackingNumbers[0].tn
                      "
                    >
                      <div
                        v-for="trac in data.data.trackings[0].events"
                        :key="trac.eventId"
                      >
                        <img
                          v-if="trac.status == 'DELIVERED'"
                          src="https://www.tracktry.com/section/tracktry/images/Artboard-6.svg"
                          style="width: 10%"
                        />
                        <img
                          v-else-if="trac.status == 'Processing at UPS Facility'"
                          src="https://www.tracktry.com/section/tracktry/images/Artboard-5.svg"
                          style="width: 10%"
                        />
                        <img
                          v-else
                          src="https://www.tracktry.com/section/tracktry/images/Artboard-1.svg"
                          style="width: 10%"
                        />
                        {{ new Date(trac.datetime).toDateString() }}
                        <p>
                          <strong>{{ trac.status }}</strong
                          >, {{ trac.location }}
                        </p>
                      </div>
                    </div>
                  </div> -->
              </div>
            </div>
          </div>

          <div class="details-content">
            <div id="accordion">
              <div
                class="details-content-title collapsed"
                id="informationD512"
                data-toggle="collapse"
                data-target="#clientInformationD512"
                aria-expanded="false"
                aria-controls="clientInformationD512"
              >
                <span>Historial de tracking</span>

                <div class="details-text up-arrow"></div>
              </div>

              <div
                id="clientInformationD512"
                class="collapse"
                aria-labelledby="informationD512"
              >
                <!--data-parent="#accordion"-->
                <div
                  class="details-content-info"
                  v-if="orderDataShow.attributes.status !== 10"
                >
                  <span
                    v-for="histTracking in orderDataShow.attributes
                      .order_tracking_details"
                    :key="histTracking"
                    style="cursor: pointer"
                    @click.prevent="
                      deleteTackingStatus(histTracking.id, histTracking.attributes.status)
                    "
                  >
                    {{ histTracking.attributes.status }} -
                    <span v-for="tracking in statusTracking" :key="tracking">
                      <span v-if="tracking.id === histTracking.attributes.status">
                        {{ tracking.text }}
                        <ul>
                          <li>{{ histTracking.attributes.date_time }}</li>
                          <li>{{ histTracking.attributes.admin_name }}</li>
                        </ul>
                      </span> </span
                    ><br />
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="details-content">
            <div id="accordion">
              <div
                class="details-content-title collapsed"
                id="informationD5"
                data-toggle="collapse"
                data-target="#clientInformationD5"
                aria-expanded="false"
                aria-controls="clientInformationD5"
              >
                <span>Asignar Viajero</span>

                <div class="details-text up-arrow"></div>
              </div>

              <div
                id="clientInformationD5"
                class="collapse"
                aria-labelledby="informationD5"
              >
                <!--data-parent="#accordion"-->
                <form @submit.prevent="buscarViajero">
                  <div class="details-content-info">
                    <input
                      v-model="dataInputViajero"
                      type="text"
                      class="form-control"
                      placeholder="Ingresar los datos del viajero a buscar"
                      required
                    />
                  </div>
                  <div class="details-content-info">
                    <select v-model="buscarViajeroCampo" class="form-control" required>
                      <option value="1">Buscar por nombre del viajero</option>
                      <option value="2">Buscar por còdigo del viajero</option>
                    </select>
                  </div>

                  <div class="details-content-info">
                    <button
                      :disabled="orderDataShow.attributes.status === 10"
                      type="submit"
                      class="btn btn-primary form-control"
                    >
                      Buscar Viajero
                    </button>
                  </div>
                </form>
                <!-- Error usuario no encontrado -->
                <!-- <div class="validacion-cliente validacion-cliente-no-encontrado">
                  Viajero no existe en el sistema
                </div> -->

                <!-- usuario si la orden tiene un viajero -->
                <div
                  id="accordion"
                  style="margin-top: 30px"
                  v-if="orderDataShow.attributes.client_travel !== null"
                >
                  <div
                    class="details-content-title collapsed"
                    :id="
                      'information' +
                      orderDataShow.attributes.client_travel.attributes.client_id
                    "
                    data-toggle="collapse"
                    :data-target="
                      '#clientInformation' +
                      orderDataShow.attributes.client_travel.attributes.client_id
                    "
                    aria-expanded="false"
                    :aria-controls="
                      'clientInformation' +
                      orderDataShow.attributes.client_travel.attributes.client_id
                    "
                  >
                    <span
                      >{{
                        orderDataShow.attributes.client_travel.attributes.client
                          .attributes.profile.attributes.name +
                        orderDataShow.attributes.client_travel.attributes.client
                          .attributes.profile.attributes.surnames +
                        " - " +
                        orderDataShow.attributes.client_travel.attributes.client
                          .attributes.profile.attributes.userable.client_code
                      }}
                      <br />
                      "Viajero Elejido"
                    </span>

                    <div class="details-text up-arrow"></div>
                  </div>

                  <div
                    :id="
                      'clientInformation' +
                      orderDataShow.attributes.client_travel.attributes.client_id
                    "
                    class="collapse"
                    :aria-labelledby="
                      'information' +
                      orderDataShow.attributes.client_travel.attributes.client_id
                    "
                  >
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Código:</span>
                        <span class="details-title-item">{{
                          orderDataShow.attributes.client_travel.attributes.client
                            .attributes.profile.id
                        }}</span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Nombre:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.name
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Apellido:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.surnames
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Documento:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.document_number
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Teléfono:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.cellphone
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Dirección:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.userable.attributes
                              .address !== null
                              ? orderDataShow.attributes.client_travel.attributes.client
                                  .attributes.profile.attributes.userable.attributes
                                  .address.address
                              : ""
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Piso u Oficina:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.userable.attributes
                              .address !== null
                              ? orderDataShow.attributes.client_travel.attributes.client
                                  .attributes.profile.attributes.userable.attributes
                                  .address.inner
                              : ""
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Referencia:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.userable.attributes
                              .address !== null
                              ? orderDataShow.attributes.client_travel.attributes.client
                                  .attributes.profile.attributes.userable.attributes
                                  .address.reference
                              : ""
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Departamento:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.userable.attributes
                              .address !== null
                              ? orderDataShow.attributes.client_travel.attributes.client
                                  .attributes.profile.attributes.userable.attributes
                                  .address.department
                              : ""
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Provincia:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.userable.attributes
                              .address !== null
                              ? orderDataShow.attributes.client_travel.attributes.client
                                  .attributes.profile.attributes.userable.attributes
                                  .address.city
                              : ""
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Distrito:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.userable.attributes
                              .address !== null
                              ? orderDataShow.attributes.client_travel.attributes.client
                                  .attributes.profile.attributes.userable.attributes
                                  .address.istrict
                              : ""
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Corro electrónico:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.userable.attributes.email
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Status:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.userable.attributes
                              .validation.miss === "none"
                              ? "Verificado"
                              : "No Verificado"
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Credencial Frontal:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.userable.attributes
                              .validation.miss === "none" ||
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.userable.attributes
                              .validation.miss === "seal"
                              ? "Verificado"
                              : "No Verificado"
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Credencial trasera:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.userable.attributes
                              .validation.miss === "none" ||
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.userable.attributes
                              .validation.miss === "face"
                              ? "Verificado"
                              : "No Verificado"
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Código de usuario:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.client
                              .attributes.profile.attributes.userable.client_code
                          }}
                        </span>
                      </div>
                    </div>

                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Origen :</span>
                        <span class="details-title-item">
                          {{ orderDataShow.attributes.client_travel.attributes.origin }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Destino:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.destination
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Fecha de llegada:</span>
                        <span class="details-title-item">
                          {{
                            orderDataShow.attributes.client_travel.attributes.arrival_date
                          }}
                        </span>
                      </div>
                    </div>

                    <div class="details-content-info">
                      <button
                        :disabled="orderDataShow.attributes.status === 10"
                        @click.prevent="quitarViajero()"
                        type="button"
                        class="btn btn-danger"
                        style="width: 100%"
                      >
                        Quitar de la orden
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Viajeros par aseleccionar -->
                <span v-if="dataViajeros.length !== 0">
                  <div
                    id="accordion"
                    class="mt-4"
                    v-for="viajes in dataViajeros"
                    :key="viajes.id"
                  >
                    <div
                      class="details-content-title collapsed pb-2 mb-3"
                      style="border-bottom: 1px solid #ccc"
                      :id="'information' + viajes.id"
                      data-toggle="collapse"
                      :data-target="'#clientInformation' + viajes.id"
                      aria-expanded="false"
                      :aria-controls="'clientInformation' + viajes.id"
                    >
                      <article class="p-0">
                        <p style="font-size: 14px" class="m-0 mb-2">
                          {{
                            viajes.attributes.client.attributes.profile.attributes.name
                          }}
                        </p>
                        <p style="font-size: 14px" class="m-0 mb-2">
                          {{
                            viajes.attributes.client.attributes.profile.attributes
                              .surnames
                          }}
                        </p>
                        <p style="font-size: 14px" class="m-0 mb-2">
                          {{ viajes.attributes.client.client_code }}
                        </p>
                        <p style="font-size: 14px" class="m-0 mb-2">
                          Viaje Origen : {{ viajes.attributes.origin }}
                        </p>
                        <p style="font-size: 14px" class="m-0 mb-2">
                          Viaje Destino : {{ viajes.attributes.destination }}
                        </p>
                        <p style="font-size: 14px" class="m-0">
                          Fecha Llegada : {{ viajes.attributes.arrival_date }}
                        </p>
                      </article>
                      <div class="details-text up-arrow"></div>
                    </div>

                    <div
                      :id="'clientInformation' + viajes.id"
                      class="collapse"
                      :aria-labelledby="'information' + viajes.id"
                    >
                      <span>
                        <div class="details-content-info">
                          <div class="details-info-viajero mx-2">
                            <span class="details-title-item">Código:</span>
                            <span class="details-title-item">{{
                              viajes.attributes.client.id
                            }}</span>
                          </div>
                        </div>
                        <div class="details-content-info">
                          <div class="details-info-viajero mx-2">
                            <span class="details-title-item">Nombre:</span>
                            <span class="details-title-item">
                              {{
                                viajes.attributes.client.attributes.profile.attributes
                                  .name
                              }}
                            </span>
                          </div>
                        </div>
                        <div class="details-content-info">
                          <div class="details-info-viajero mx-2">
                            <span class="details-title-item">Apellido:</span>
                            <span class="details-title-item">
                              {{
                                viajes.attributes.client.attributes.profile.attributes
                                  .surnames
                              }}
                            </span>
                          </div>
                        </div>
                        <div class="details-content-info">
                          <div class="details-info-viajero mx-2">
                            <span class="details-title-item">Documento:</span>
                            <span class="details-title-item">
                              {{
                                viajes.attributes.client.attributes.profile.attributes
                                  .document_number
                              }}
                            </span>
                          </div>
                        </div>
                        <div class="details-content-info">
                          <div class="details-info-viajero mx-2">
                            <span class="details-title-item">Teléfono:</span>
                            <span class="details-title-item">
                              {{
                                viajes.attributes.client.attributes.profile.attributes
                                  .cellphone
                              }}
                            </span>
                          </div>
                        </div>
                        <div class="details-content-info">
                          <div class="details-info-viajero mx-2">
                            <span class="details-title-item">Dirección:</span>
                            <span class="details-title-item">
                              {{
                                viajes.attributes.client.attributes.address !== null
                                  ? viajes.attributes.client.attributes.address.address
                                  : ""
                              }}
                            </span>
                          </div>
                        </div>
                        <div class="details-content-info">
                          <div class="details-info-viajero mx-2">
                            <span class="details-title-item">Piso u Oficina:</span>
                            <span class="details-title-item">
                              {{
                                viajes.attributes.client.attributes.address !== null
                                  ? viajes.attributes.client.attributes.address.inner
                                  : ""
                              }}
                            </span>
                          </div>
                        </div>
                        <div class="details-content-info">
                          <div class="details-info-viajero mx-2">
                            <span class="details-title-item">Referencia:</span>
                            <span class="details-title-item">
                              {{
                                viajes.attributes.client.attributes.address !== null
                                  ? viajes.attributes.client.attributes.address.reference
                                  : ""
                              }}
                            </span>
                          </div>
                        </div>
                        <div class="details-content-info">
                          <div class="details-info-viajero mx-2">
                            <span class="details-title-item">Departamento:</span>
                            <span class="details-title-item">
                              {{
                                viajes.attributes.client.attributes.address !== null
                                  ? viajes.attributes.client.attributes.address.department
                                  : ""
                              }}
                            </span>
                          </div>
                        </div>
                        <div class="details-content-info">
                          <div class="details-info-viajero mx-2">
                            <span class="details-title-item">Provincia:</span>
                            <span class="details-title-item">
                              {{
                                viajes.attributes.client.attributes.address !== null
                                  ? viajes.attributes.client.attributes.address.city
                                  : ""
                              }}
                            </span>
                          </div>
                        </div>
                        <div class="details-content-info">
                          <div class="details-info-viajero mx-2">
                            <span class="details-title-item">Distrito:</span>
                            <span class="details-title-item">
                              {{
                                viajes.attributes.client.attributes.address !== null
                                  ? viajes.attributes.client.attributes.address.district
                                  : ""
                              }}
                            </span>
                          </div>
                        </div>
                        <div class="details-content-info">
                          <div class="details-info-viajero mx-2">
                            <span class="details-title-item">Corro electrónico:</span>
                            <span class="details-title-item">
                              {{ viajes.attributes.client.attributes.email }}
                            </span>
                          </div>
                        </div>
                        <div class="details-content-info">
                          <div class="details-info-viajero mx-2">
                            <span class="details-title-item">Status:</span>
                            <span class="details-title-item">
                              {{
                                viajes.attributes.client.attributes.validation.miss ===
                                "none"
                                  ? "Verificado"
                                  : "No Verificado"
                              }}
                            </span>
                          </div>
                        </div>
                        <div class="details-content-info">
                          <div class="details-info-viajero mx-2">
                            <span class="details-title-item">Credencial Frontal:</span>
                            <span class="details-title-item">
                              {{
                                viajes.attributes.client.attributes.validation.miss ===
                                  "none" ||
                                viajes.attributes.client.attributes.validation.miss ===
                                  "seal"
                                  ? "Verificado"
                                  : "No Verificado"
                              }}
                            </span>
                          </div>
                        </div>
                        <div class="details-content-info">
                          <div class="details-info-viajero mx-2">
                            <span class="details-title-item">Credencial trasera:</span>
                            <span class="details-title-item">
                              {{
                                viajes.attributes.client.attributes.validation.miss ===
                                  "none" ||
                                viajes.attributes.client.attributes.validation.miss ===
                                  "face"
                                  ? "Verificado"
                                  : "No Verificado"
                              }}
                            </span>
                          </div>
                        </div>
                        <div class="details-content-info">
                          <div class="details-info-viajero mx-2">
                            <span class="details-title-item">Código de usuario:</span>
                            <span class="details-title-item">
                              {{
                                viajes.attributes.client.attributes.profile.attributes
                                  .userable.client_code
                              }}
                            </span>
                          </div>
                        </div>

                        <div class="details-content-info">
                          <button
                            :disabled="orderDataShow.attributes.status === 10"
                            @click.prevent="
                              asignarViajeroOrder(
                                viajes.id,
                                viajes.attributes.client.attributes.profile.attributes
                                  .userable.client_code
                              )
                            "
                            class="btn btn-primary form-control"
                          >
                            Asignar VIajero
                          </button>
                        </div>
                      </span>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>

          <div class="details-content">
            <div id="accordion">
              <div
                class="details-content-title collapsed"
                id="informationD3"
                data-toggle="collapse"
                data-target="#clientInformationD3"
                aria-expanded="false"
                aria-controls="clientInformationD3"
              >
                <span>International Shopper</span>

                <div class="details-text up-arrow"></div>
              </div>

              <div
                id="clientInformationD3"
                class="collapse"
                aria-labelledby="informationD3"
              >
                <!--data-parent="#accordion"-->
                <form @submit.prevent="addInternationalShooper">
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Tienda de compra :</span>
                      <span class="details-title-item">
                        <input
                          type="text"
                          v-model="interShooper.tienda"
                          class="form-control"
                          required
                        />
                      </span>
                    </div>
                  </div>
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Enlace:</span>
                      <span class="details-title-item">
                        <input
                          type="text"
                          v-model="interShooper.enlace"
                          class="form-control"
                          required
                        />
                      </span>
                    </div>
                  </div>
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Precio:</span>
                      <span class="details-title-item">
                        <input
                          type="text"
                          v-model="interShooper.precio"
                          class="form-control"
                          required
                        />
                      </span>
                    </div>
                  </div>
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Cantidad:</span>
                      <span class="details-title-item">
                        <input
                          type="text"
                          v-model="interShooper.cantidad"
                          class="form-control"
                          required
                        />
                      </span>
                    </div>
                  </div>
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Peso:</span>
                      <span class="details-title-item">
                        <input
                          type="text"
                          v-model="interShooper.peso"
                          class="form-control"
                          required
                        />
                      </span>
                    </div>
                  </div>
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Order number:</span>
                      <span class="details-title-item">
                        <input
                          type="text"
                          v-model="interShooper.order"
                          class="form-control"
                          required
                        />
                      </span>
                    </div>
                  </div>
                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item">Invoice Details:</span>
                      <span class="details-title-item">
                        <input
                          :disabled="orderDataShow.attributes.status === 10"
                          type="file"
                          ref="invoice"
                          @change="invoice"
                        />
                      </span>
                    </div>
                  </div>

                  <div class="details-content-info">
                    <div class="details-title-block">
                      <span class="details-title-item"></span>
                      <span class="details-title-item">
                        <button
                          :disabled="orderDataShow.attributes.status === 10"
                          type="submit"
                          class="btn btn-primary form-control"
                        >
                          Recopilar
                        </button></span
                      >
                    </div>
                  </div>
                </form>

                <div
                  id="accordion"
                  style="margin-top: 20px"
                  v-for="data in dataInternationalShooper"
                  :key="data"
                >
                  <div
                    class="details-content-title collapsed"
                    :id="'informationD3' + data.id"
                    data-toggle="collapse"
                    :data-target="'#clientInformationD3' + data.id"
                    aria-expanded="false"
                    :aria-controls="'clientInformationD3' + data.id"
                  >
                    <span
                      >International Shopper - {{ data.tiendaCompra }} <br />
                      <a
                        v-if="orderDataShow.attributes.status !== 10"
                        style="cursor: pointer; color: red"
                        @click.prevent="deleteInternationalShooper(data.id)"
                        >Eliminar</a
                      >
                    </span>

                    <div class="details-text up-arrow"></div>
                  </div>

                  <div
                    :id="'clientInformationD3' + data.id"
                    class="collapse"
                    :aria-labelledby="'informationD3' + data.id"
                  >
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Tienda de compra :</span>
                        <span class="details-title-item">
                          {{ data.tiendaCompra }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Enlace:</span>
                        <span class="details-title-item">
                          {{ data.enlace }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Precio:</span>
                        <span class="details-title-item">
                          {{ data.precio }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Cantidad:</span>
                        <span class="details-title-item">
                          {{ data.cantidad }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Peso:</span>
                        <span class="details-title-item">
                          {{ data.peso }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Order number:</span>
                        <span class="details-title-item">
                          {{ data.orderNumber }}
                        </span>
                      </div>
                    </div>
                    <div class="details-content-info">
                      <div class="details-title-block">
                        <span class="details-title-item">Invoice Details:</span>
                        <span class="details-title-item">
                          <span v-if="data.invoiceDetails === null"> Sin Invoice </span>
                          <span v-else>
                            <a :href="data.invoiceDetails" target="Blank">Ver Invoice</a>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="details-content">
            <div class="details-title-container">
              <div
                class="details-title-block details-summary-item"
                data-toggle="collapse"
                data-target="#seguimiento"
                aria-expanded="false"
                aria-controls="seguimiento"
              >
                <h6 style="text-align: center">Seguimiento del Paquete</h6>
                <div class="details-text up-arrow"></div>
              </div>

              <div id="seguimiento" class="slider">
                <div
                  v-for="trac in seguimientoTrackin"
                  :key="trac.eventId"
                  class="slider_content"
                >
                  <img
                    v-if="trac.status == 'DELIVERED'"
                    src="https://www.tracktry.com/section/tracktry/images/Artboard-6.svg"
                    style="width: 10%"
                  />
                  <img
                    v-else-if="trac.status == 'Processing at UPS Facility'"
                    src="https://www.tracktry.com/section/tracktry/images/Artboard-5.svg"
                    style="width: 10%"
                  />
                  <img
                    v-else
                    src="https://www.tracktry.com/section/tracktry/images/Artboard-1.svg"
                    style="width: 10%"
                  />
                  {{ new Date(trac.datetime).toDateString() }}
                  <p>
                    <strong>{{ trac.status }}</strong
                    >, {{ trac.location }}
                  </p>
                </div>
              </div>
            </div>
          </div> -->
          <div class="details-title-container">
            <button
              :disabled="orderDataShow.attributes.status === 10"
              type="button"
              class="btn btn-danger"
              style="margin-top: 8px"
              @click="showModalConfirmationDelete()"
            >
              Eliminar orden
            </button>
          </div>
          <!--<div class="details-content" v-if="orderDataShow.attributes.is_from_meli_flag">
            <div class="details-title-container" v-if="orderDataShow.attributes.is_from_meli_flag">
              <div class="details-title-block details-summary-item">
                <span class="details-title-item">Precio Mercado Libre</span>
                <span v-if="orderDataShow.attributes.is_from_linio_flag || orderDataShow.attributes.is_from_meli_flag" class="details-title-item">S/ +{{totalPrice|currency}}</span>
              </div>
              <div class="details-title-block details-summary-item">
                <span class="details-title-item">Comisión (9%)</span>
                <span v-if="orderDataShow.attributes.is_from_linio_flag || orderDataShow.attributes.is_from_meli_flag" class="details-title-item">S/ -{{0.09 * totalPrice|currency}}</span>
              </div>
            </div>

            <div class="details-title-container" v-if="orderDataShow.attributes.is_from_meli_flag">
              <div class="details-title-block details-summary-item">
                <span class="details-title-item">Rebate Bruto</span>
                <span v-if="orderDataShow.attributes.is_from_linio_flag || orderDataShow.attributes.is_from_meli_flag" class="details-title-item">S/ +{{orderDataShow.attributes.meliOrder.attributes.rebate!=null?orderDataShow.attributes.meliOrder.attributes.rebate:0|currency}}</span>
              </div>
              <div class="details-title-block details-summary-item">
                <span class="details-title-item">Comisión Rebate (9%)</span>
                <span v-if="orderDataShow.attributes.is_from_linio_flag || orderDataShow.attributes.is_from_meli_flag" class="details-title-item">S/ -{{0.09 * orderDataShow.attributes.meliOrder.attributes.rebate|currency}}</span>
              </div>
              <div class="details-title-block details-summary-item">
                <span class="details-title-item">REBATE NETO</span>
                <span v-if="orderDataShow.attributes.is_from_linio_flag || orderDataShow.attributes.is_from_meli_flag" class="details-title-item">S/ {{orderDataShow.attributes.meliOrder.attributes.rebate - (0.09 * orderDataShow.attributes.meliOrder.attributes.rebate)|currency}}</span>
              </div>
            </div>

            <div class="details-title-container" v-if="orderDataShow.attributes.is_from_meli_flag">
              <div class="details-title-block details-summary-item">
                <span class="details-title-item">Total Mercado Libre</span>
                <span v-if="orderDataShow.attributes.is_from_linio_flag || orderDataShow.attributes.is_from_meli_flag" class="details-title-item">S/ {{totalMeli|currency}}</span>
              </div>
              <div class="details-title-block details-summary-item">
                <span class="details-title-item">Total comisiones</span>
                <span v-if="orderDataShow.attributes.is_from_linio_flag || orderDataShow.attributes.is_from_meli_flag" class="details-title-item">S/ {{totalCommissions|currency}}</span>
              </div>
              <div class="details-title-block summary-block-total details-summary-item">
                <span class="details-title-item">TOTAL</span>
                <span v-if="orderDataShow.attributes.is_from_linio_flag || orderDataShow.attributes.is_from_meli_flag" class="details-title-item">S/ {{totalNeto|currency}}</span>
              </div>
            </div>
          </div>-->
        </div>
      </div>

      <b-modal
        hide-footer
        hide-header
        centered
        id="modalAuthorizeReposition"
        ref="modalAuthorizeReposition"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Autorización de reposición del paquete
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              block
              @click="hideModalAuthorizeReposition"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body" id="modal-body">
            <label for class="float-left">
              ¿Desea autorizar la reposición de ejemplares de un paquete a otro en la
              presente orden de compra?
            </label>
            <input type="radio" id="one" value="1" v-model="authorizationOption" />
            <label for="one">Sí</label>

            <input type="radio" id="two" value="2" v-model="authorizationOption" />
            <label for="two">No</label>
            <br /><br />
            <span>Opción elegida: {{ authorizationOption }}</span>
            <button @click="authorizeReposition">Enviar decisión</button>
          </div>
        </div>
      </b-modal>

      <b-modal
        v-if="
          orderDataShow.attributes.reposition.attributes.used_items != null &&
          orderDataShow.attributes.reposition.attributes.used_items > 0
        "
        hide-footer
        hide-header
        id="modalRepositionDetail"
        ref="modalRepositionDetail"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Detalle de reposición</h5>
          </div>

          <div class="modal-body modal-scroll" id="modal-body">
            <span>
              <b
                >Items totales en la reposición:
                {{ orderDataShow.attributes.reposition.attributes.used_items }}</b
              >
            </span>
            <br />
            <span
              >Items pendientes de reposición:
              {{ orderDataShow.attributes.reposition.attributes.pendient_items }}</span
            >
            <br />
            <span
              >Items repuestos:
              {{
                orderDataShow.attributes.reposition.attributes.used_items -
                orderDataShow.attributes.reposition.attributes.pendient_items
              }}</span
            >
            <br />
            <p v-if="orderDataShow.attributes.reposition.attributes.child_id != null">
              Ver reposición de items nuevamente incidentados en reposición de ID:
              {{ orderDataShow.attributes.reposition.attributes.child_id }}
            </p>
            <hr />
            <span>Incidencias por cantidades menores a lo solicitado:</span>

            <ul>
              <li v-for="packageRepo of packageRepositions" :key="packageRepo.id">
                <span>ID Paquete</span>
                <p>{{ packageRepo.package_id }}</p>

                <span>ID Incidente</span>
                <p>
                  {{
                    packageRepo.attributes.different_quantity_incident.attributes
                      .packageIncident.id
                  }}
                </p>
                <span>Items que debieron ser correctos</span>
                <p>
                  {{
                    packageRepo.attributes.quantity +
                    packageRepo.attributes.different_quantity_incident.attributes
                      .correct_items
                  }}
                </p>
                <span>Items realmente correctos</span>
                <p>
                  {{
                    packageRepo.attributes.different_quantity_incident.attributes
                      .correct_items
                  }}
                </p>
                <span>Items en déficit</span>
                <p>{{ packageRepo.attributes.quantity }}</p>
                <span>Enlace a embarque que perteneció el paquete:</span>
                <p>
                  Enlace a embarque de ID
                  {{
                    packageRepo.attributes.different_quantity_incident.attributes
                      .packageIncident.attributes.package.attributes.boarding_id
                  }}
                </p>
              </li>
            </ul>
          </div>
        </div>
      </b-modal>

      <b-modal
        hide-footer
        hide-header
        centered
        id="modalConfirmationReposition"
        ref="modalConfirmationReposition"
      >
        <div class="modal-Content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Confirmar acción:</h5>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="hideModalConfirmationReposition"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" id="modal-body">
            <div class="text-center">
              <p>¿Estás seguro que deseas completar esta acción?</p>
            </div>
          </div>

          <div class="modal-footer text-center">
            <button
              type="button"
              class="btn btn-primary btn-lg"
              @click="authorizeReposition()"
            >
              Aceptar
            </button>
            <button
              type="button"
              class="btn btn-primary btn-lg"
              @click="hideModalConfirmationReposition()"
            >
              Cancelar
            </button>
          </div>
        </div>
      </b-modal>

      <b-modal
        hide-footer
        hide-header
        centered
        id="modalReevaluation"
        ref="modalReevaluation"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Evaluación de la orden de compra
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="hideModalReevaluetion"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-tab">
            <ul class="nav nav-pills nav-fill" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  v-if="flagFormEvaluetionPurchaseOrder != 'toFill'"
                  class="nav-link"
                  :class="{ active: controllSwithPurchaseOrder == 1 }"
                  @click="modalControllPurchaseOrder(2)"
                  >Datos web</a
                >
                <p
                  v-if="flagFormEvaluetionPurchaseOrder == 'toFill'"
                  class="nav-link active"
                >
                  Datos web
                </p>
              </li>

              <li class="nav-item">
                <a
                  v-if="flagFormEvaluetionPurchaseOrder != 'toFill'"
                  class="nav-link"
                  :class="{ active: controllSwithPurchaseOrder == 2 }"
                  @click="modalControllPurchaseOrder(2)"
                  >Datos reales</a
                >
                <p
                  v-if="flagFormEvaluetionPurchaseOrder == 'toFill'"
                  class="nav-link inactive"
                >
                  Datos reales
                </p>
              </li>
            </ul>
          </div>

          <div class="modal-body modal-scroll modal-tabs" id="modal-body">
            <div class="form-login">
              <div class="tab-content" id="myTabContent">
                <div v-if="controllSwithPurchaseOrder == 1">
                  <div v-if="flagFormEvaluetionPurchaseOrder == 'toFill'">
                    <div class="form-group">
                      <label
                        v-if="
                          !orderDataShow.attributes.is_from_linio_flag ||
                          !orderDataShow.attributes.is_from_meli_flag
                        "
                        for
                        class="float-left"
                        >Precio de la web (USD)</label
                      >
                      <label v-else for class="float-left">Precio de la web (USD)</label>
                      <input
                        class="form-control null sen-form-input-with-tooltip"
                        name="precio_web"
                        v-model="costGrabr"
                        @keyup="setTaxGrabr()"
                        v-validate="{
                          required:
                            controllSwithPurchaseOrder == 1 &&
                            flagFormEvaluetionPurchaseOrder == 'toFill' &&
                            readyToProcessIncompleteData != true &&
                            this.orderDataShow.attributes.status != 3,
                        }"
                        v-floatonly
                        :maxlength="7"
                      />

                      <div class="sen-tooltip sen-tooltip-modal">
                        <span
                          >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                          Voluptates quod ut, aperiam laboriosa</span
                        >
                      </div>

                      <span v-show="errors.has('precio_web')" class="text-danger">{{
                        errors.first("precio_web")
                      }}</span>
                    </div>

                    <div class="form-group">
                      <div style="display: flex; width: 390px">
                        <label
                          v-if="
                            !orderDataShow.attributes.is_from_linio_flag ||
                            !orderDataShow.attributes.is_from_meli_flag
                          "
                          for
                          class="float-left"
                          >Impuesto de la web (USD)</label
                        >
                        <label v-else for class="float-left"
                          >Impuesto de la web (USD)</label
                        >
                        <label
                          style="
                            font-style: italic;
                            font-size: 12px;
                            cursor: pointer;
                            color: cornflowerblue;
                            text-decoration: underline;
                          "
                          @click="resetImpuestoWeb"
                          >(Limpiar campos)</label
                        >
                      </div>
                      <input
                        type="text"
                        aria-describedby="email"
                        name="impuesto_web"
                        class="form-control null sen-form-input-with-tooltip"
                        v-validate="{
                          required:
                            this.controllSwithPurchaseOrder == 1 &&
                            this.flagFormEvaluetionPurchaseOrder == 'toFill' &&
                            this.readyToProcessIncompleteData != true &&
                            this.orderDataShow.attributes.status != 3,
                        }"
                        v-model="taxGrabr"
                        v-floatonly
                        :maxlength="7"
                      />

                      <div class="sen-tooltip sen-tooltip-modal">
                        <span
                          >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                          Voluptates quod ut, aperiam laboriosa</span
                        >
                      </div>

                      <span v-show="errors.has('impuesto_web')" class="text-danger">{{
                        errors.first("impuesto_web")
                      }}</span>
                    </div>

                    <div class="form-group">
                      <label
                        v-if="
                          !orderDataShow.attributes.is_from_linio_flag ||
                          !orderDataShow.attributes.is_from_meli_flag
                        "
                        for
                        class="float-left"
                        >Costo de envío de la web (USD)</label
                      >
                      <label v-else for class="float-left"
                        >Costo de envío de la web (USD)</label
                      >
                      <input
                        type="text"
                        aria-describedby="email"
                        name="costo_envio_web"
                        class="form-control null sen-form-input-with-tooltip"
                        v-validate="{
                          required:
                            controllSwithPurchaseOrder == 1 &&
                            flagFormEvaluetionPurchaseOrder == 'toFill' &&
                            readyToProcessIncompleteData != true &&
                            this.orderDataShow.attributes.status != 3,
                        }"
                        v-model="shippingGrabr"
                        v-floatonly
                      />

                      <div class="sen-tooltip sen-tooltip-modal">
                        <span
                          >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                          Voluptates quod ut, aperiam laboriosa</span
                        >
                      </div>

                      <span v-show="errors.has('costo_envio_web')" class="text-danger">{{
                        errors.first("costo_envio_web")
                      }}</span>
                    </div>

                    <div
                      class="form-group adeudo-cal"
                      v-if="orderDataShow.attributes.is_from_grabr_flag"
                    >
                      <label for class="float-left">
                        <a
                          class="adeudo-link"
                          :href="
                            'http://paypal.me/EnviosDeUsa/' +
                            Number(
                              Math.round(parseFloat(debitCalculated * 1.07) + 'e2') +
                                'e-2'
                            )
                              .toFixed(2)
                              .toString()
                          "
                          target="_blank"
                          >Adeudo calculado (USD) :
                          {{
                            Number(
                              Math.round(parseFloat(debitCalculated) + "e2") + "e-2"
                            ).toFixed(2)
                          }}</a
                        >
                      </label>
                    </div>
                    <!--<div class="form-group adeudo-cal" v-else-if="orderDataShow.attributes.is_from_linio_flag">
                      <label for class="float-left">

                        <a
                          class="adeudo-link"
                          :href="'http://paypal.me/EnviosDeUsa/'+Number(Math.round( parseFloat(debitCalculated*1.07) +'e2')+'e-2').toFixed(2).toString()"
                          target="_blank"
                        >Adeudo calculado (S/) : {{Number(Math.round( parseFloat(debitCalculated) +'e2')+'e-2').toFixed(2)}}</a>
                      </label>

                    </div>-->

                    <div class="form-group">
                      <label for class="float-left">Unidades de peso</label>
                      <select
                        class="form-control form-control-lg sen-form-input-with-tooltip"
                        name="unidad_peso"
                        v-validate="{
                          required:
                            controllSwithPurchaseOrder == 1 &&
                            flagFormEvaluetionPurchaseOrder == 'toFill' &&
                            readyToProcessIncompleteData != true &&
                            this.orderDataShow.attributes.status != 3,
                        }"
                        v-model="unitWeight"
                      >
                        <option value="" disabled>Selecciona la unidad</option>
                        <option :value="units" v-for="units of listUnits" :key="units.id">
                          {{ units.attributes.name }}
                        </option>
                      </select>

                      <div class="sen-tooltip sen-tooltip-modal">
                        <span
                          >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                          Voluptates quod ut, aperiam laboriosa</span
                        >
                      </div>

                      <span v-show="errors.has('unidad_peso')" class="text-danger">{{
                        errors.first("unidad_peso")
                      }}</span>
                    </div>

                    <div class="form-group">
                      <label for class="float-left">Peso de la orden</label>
                      <input
                        aria-describedby="email"
                        name="peso_orden"
                        class="form-control null sen-form-input-with-tooltip"
                        v-validate="{
                          required:
                            controllSwithPurchaseOrder == 1 &&
                            flagFormEvaluetionPurchaseOrder == 'toFill' &&
                            readyToProcessIncompleteData != true &&
                            this.orderDataShow.attributes.status != 3,
                        }"
                        v-model="weightGrabr"
                        v-floatonly
                        :maxlength="8"
                      />

                      <div class="sen-tooltip sen-tooltip-modal">
                        <span
                          >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                          Voluptates quod ut, aperiam laboriosa</span
                        >
                      </div>
                      <span v-show="errors.has('peso_orden')" class="text-danger">{{
                        errors.first("peso_orden")
                      }}</span>
                    </div>
                  </div>
                  <div v-if="flagFormEvaluetionPurchaseOrder == 'toShow'">
                    <div class="form-group">
                      <label
                        v-if="
                          !orderDataShow.attributes.is_from_linio_flag ||
                          !orderDataShow.attributes.is_from_meli_flag
                        "
                        for
                        class="float-left"
                        >Precio de la web (USD)</label
                      >
                      <label v-else for class="float-left">Precio de la web (USD)</label>
                      <input class="form-control null" v-model="costGrabr" disabled />
                    </div>

                    <div class="form-group">
                      <label
                        v-if="
                          !orderDataShow.attributes.is_from_linio_flag ||
                          !orderDataShow.attributes.is_from_meli_flag
                        "
                        for
                        class="float-left"
                        >Impuesto de la web (USD)</label
                      >
                      <label v-else for class="float-left"
                        >Impuesto de la web (USD)</label
                      >
                      <input
                        type="text"
                        class="form-control null"
                        v-model="taxGrabr"
                        disabled
                      />
                    </div>

                    <div class="form-group">
                      <label
                        v-if="
                          !orderDataShow.attributes.is_from_linio_flag ||
                          !orderDataShow.attributes.is_from_meli_flag
                        "
                        for
                        class="float-left"
                        >Costo de envío de la web (USD)</label
                      >
                      <label v-else for class="float-left"
                        >Costo de envío de la web (USD)</label
                      >

                      <input
                        type="text"
                        class="form-control null"
                        v-model="shippingGrabr"
                        disabled
                      />
                    </div>

                    <!--<div class="form-group">
                      <label
                        v-if="!orderDataShow.attributes.is_from_linio_flag"
                        for
                        class="float-left"
                      >Adeudo calculado (USD) : {{Number(Math.round( parseFloat(debitCalculated) +'e2')+'e-2').toFixed(2)}}</label>
                      <label
                        v-else
                        for
                        class="float-left"
                      >Adeudo calculado (S/) : {{Number(Math.round( parseFloat(debitCalculated) +'e2')+'e-2').toFixed(2)}}</label>
                    </div>-->

                    <div class="form-group">
                      <label for class="float-left">Unidades de peso</label>
                      <select
                        class="form-control form-control-lg sen-form-input-with-tooltip"
                        v-model="unitWeight.attributes.name"
                        disabled
                      >
                        <option selected>
                          {{ unitWeight.attributes.name }}
                        </option>
                      </select>

                      <div class="sen-tooltip sen-tooltip-modal">
                        <span
                          >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                          Voluptates quod ut, aperiam laboriosa</span
                        >
                      </div>
                    </div>

                    <div class="form-group">
                      <label for class="float-left">Peso de la orden</label>
                      <input class="form-control null" v-model="weightGrabr" disabled />
                    </div>
                  </div>
                </div>

                <div v-if="controllSwithPurchaseOrder == 2">
                  <div class="form-group">
                    <label
                      v-if="
                        !orderDataShow.attributes.is_from_linio_flag ||
                        !orderDataShow.attributes.is_from_meli_flag
                      "
                      for
                      class="float-left"
                      >Precio real (USD)</label
                    >
                    <label v-else for class="float-left">Precio real (USD)</label>
                    <input
                      aria-describedby="email"
                      name="costo_real"
                      class="form-control null sen-form-input-with-tooltip"
                      v-validate="{
                        required:
                          controllSwithPurchaseOrder == 2 &&
                          flagFormEvaluetionPurchaseOrder == 'toShow',
                      }"
                      @keyup="setTaxReal()"
                      v-model="CostReal"
                      v-floatonly
                      :maxlength="7"
                    />

                    <div class="sen-tooltip sen-tooltip-modal">
                      <span
                        >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                        Voluptates quod ut, aperiam laboriosa</span
                      >
                    </div>

                    <span v-show="errors.has('costo_real')" class="text-danger">{{
                      errors.first("costo_real")
                    }}</span>
                  </div>

                  <div class="form-group">
                    <input
                      type="checkbox"
                      id="rewardFlag"
                      v-model="rewardFlag"
                      v-on:click="cambiarReward()"
                    />

                    <label for class="reward-label">Ingresar Reward / Discount</label>

                    <div class="sen-tooltip sen-tooltip-modal">
                      <span
                        >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                        Voluptates quod ut, aperiam laboriosa</span
                      >
                    </div>
                  </div>

                  <div class="form-group" v-if="rewardFlag">
                    <label
                      v-if="
                        !orderDataShow.attributes.is_from_linio_flag ||
                        !orderDataShow.attributes.is_from_meli_flag
                      "
                      for
                      class="float-left"
                      >Reward / Discount (USD)</label
                    >
                    <label v-else for class="float-left">Reward / Discount (S/)</label>
                    <input
                      id="email"
                      name="rewardDiscount"
                      v-validate="{
                        required:
                          controllSwithPurchaseOrder == 2 &&
                          flagFormEvaluetionPurchaseOrder == 'toShow',
                      }"
                      aria-describedby="email"
                      class="form-control null sen-form-input-with-tooltip"
                      v-model="rewardDiscount"
                      v-floatonly
                      :maxlength="7"
                      @keyup="setTaxReal()"
                    />

                    <div class="sen-tooltip sen-tooltip-modal">
                      <span
                        >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                        Voluptates quod ut, aperiam laboriosa</span
                      >
                    </div>
                  </div>

                  <div class="form-group">
                    <div style="display: flex; width: 310px">
                      <label
                        v-if="
                          !orderDataShow.attributes.is_from_linio_flag ||
                          !orderDataShow.attributes.is_from_meli_flag
                        "
                        for
                        class="float-left"
                        >Impuesto real (USD)</label
                      >
                      <label v-else for class="float-left">Impuesto real (USD)</label>
                      <label
                        style="
                          font-style: italic;
                          font-size: 12px;
                          cursor: pointer;
                          color: cornflowerblue;
                          text-decoration: underline;
                        "
                        @click="resetImpuestoReal"
                        >(Limpiar campos)</label
                      >
                    </div>
                    <input
                      id="email"
                      name="real_tax"
                      v-validate="{
                        required:
                          controllSwithPurchaseOrder == 2 &&
                          flagFormEvaluetionPurchaseOrder == 'toShow',
                      }"
                      aria-describedby="email"
                      class="form-control null sen-form-input-with-tooltip"
                      v-model="TaxReal"
                      v-floatonly
                      :maxlength="7"
                    />

                    <div class="sen-tooltip sen-tooltip-modal">
                      <span
                        >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                        Voluptates quod ut, aperiam laboriosa</span
                      >
                    </div>

                    <span v-show="errors.has('real_tax')" class="text-danger">{{
                      errors.first("real_tax")
                    }}</span>
                  </div>

                  <div class="form-group">
                    <label
                      v-if="
                        !orderDataShow.attributes.is_from_linio_flag ||
                        !orderDataShow.attributes.is_from_meli_flag
                      "
                      for
                      class="float-left"
                      >Costos de envío real (USD)</label
                    >
                    <label v-else for class="float-left"
                      >Costos de envío real (USD)</label
                    >
                    <input
                      id="email"
                      name="real_delivery_cost"
                      v-validate="{
                        required:
                          controllSwithPurchaseOrder == 2 &&
                          flagFormEvaluetionPurchaseOrder == 'toShow',
                      }"
                      aria-describedby="email"
                      class="form-control null sen-form-input-with-tooltip"
                      v-model="shippingReal"
                      v-floatonly
                      :maxlength="7"
                    />

                    <div class="sen-tooltip sen-tooltip-modal">
                      <span
                        >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                        Voluptates quod ut, aperiam laboriosa</span
                      >
                    </div>

                    <span v-show="errors.has('real_delivery_cost')" class="text-danger">{{
                      errors.first("real_delivery_cost")
                    }}</span>
                  </div>

                  <div class="form-group">
                    <label for class="float-left">Link de compra final</label>
                    <input
                      type="text"
                      aria-describedby="email"
                      name="link_compra_final"
                      v-validate="{
                        required:
                          this.orderDataShow.attributes.status === 3 &&
                          orderDataShow.attributes.is_from_grabr_flag,
                        url: true,
                      }"
                      class="form-control null sen-form-input-with-tooltip"
                      :maxlength="200"
                      v-model="finalBuyingLink"
                    />

                    <div class="sen-tooltip sen-tooltip-modal">
                      <span
                        >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                        Voluptates quod ut, aperiam laboriosa</span
                      >
                    </div>

                    <!-- <span
                      v-show="errors.has('real_delivery_cost')"
                      class="text-danger"
                    >{{ errors.first('real_delivery_cost') }}</span>-->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer text-right">
            <a
              v-if="orderDataShow.attributes.is_from_grabr_flag"
              :href="
                'https://grabr.io/account/conversations/' +
                orderDataShow.attributes.grabrOrder.attributes.grabr_chat_link
              "
              target="_blank"
            >
              <span
                v-b-popover.hover.top="'Link chat de compra'"
                class="hiper-eva btn-primary"
              >
                <i class="far fa-comment-dots"></i>
              </span>
            </a>

            <a
              v-if="orderDataShow.attributes.is_from_grabr_flag"
              :href="
                'https://grabr.io/es/grabs/' +
                orderDataShow.attributes.grabrOrder.attributes.grabr_order_number
              "
              target="_blank"
            >
              <span
                v-b-popover.hover.top="'Link orden de compra'"
                class="hiper-eva btn-primary"
              >
                <i class="fas fa-shopping-cart"></i>
              </span>
            </a>
            <!--<a
              v-else-if="orderDataShow.attributes.is_from_linio_flag"
              :href="'https://grabr.io/es/grabs/'+orderDataShow.attributes.linioOrder.attributes.linio_order_link"
              target="_blank"
            >
              <span v-b-popover.hover.top="'Link orden de compra'" class="hiper-eva btn-primary">
                <i class="fas fa-shopping-cart"></i>
              </span>
            </a>-->

            <button
              v-if="controllSwithPurchaseOrder == 1"
              class="btn btn-primary btn-lg"
              @click="updateEvaluation"
            >
              Guardar cambios
            </button>

            <button
              v-if="controllSwithPurchaseOrder == 2"
              type="button"
              class="btn btn-primary btn-lg"
              @click="sendEvaluation(id)"
            >
              Evaluar
            </button>
            <button
              v-if="controllSwithPurchaseOrder == 1"
              class="btn btn-primary btn-lg"
              @click="modalControllPurchaseOrder(1)"
            >
              Continuar
            </button>
          </div>
        </div>
      </b-modal>

      <b-modal hide-footer hide-header centered id="modalProcess" ref="modalProcess">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              v-if="orderDataShow.attributes.is_from_grabr_flag"
              class="modal-title"
              id="exampleModalLongTitle"
            >
              Datos de compra adicional de orden Grabr
            </h5>
            <h5
              v-else-if="orderDataShow.attributes.is_from_linio_flag"
              class="modal-title"
              id="exampleModalLongTitle"
            >
              Datos de compra adicional de orden Linio
            </h5>
            <h5
              v-else-if="orderDataShow.attributes.is_from_meli_flag"
              class="modal-title"
              id="exampleModalLongTitle"
            >
              Datos de compra adicional de orden Mercado Libre
            </h5>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="hideModalProcess"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body modal-scroll" id="modal-body">
            <div class="form-login" id="infoextra">
              <div class="form-group">
                <label for class="float-left">Link de compra final</label>
                <input
                  type="text"
                  aria-describedby="email"
                  name="link_compra_final"
                  v-validate="{
                    required:
                      this.orderDataShow.attributes.status === 3 &&
                      orderDataShow.attributes.is_from_grabr_flag &&
                      sendProcessFlag,
                    url:
                      this.orderDataShow.attributes.status === 3 &&
                      orderDataShow.attributes.is_from_grabr_flag &&
                      sendProcessFlag,
                  }"
                  class="form-control null sen-form-input-with-tooltip"
                  :maxlength="200"
                  v-model="finalBuyingLink"
                />

                <div class="sen-tooltip sen-tooltip-modal">
                  <span
                    >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates
                    quod ut, aperiam laboriosa</span
                  >
                </div>

                <span v-show="errors.has('link_compra_final')" class="text-danger">{{
                  errors.first("link_compra_final")
                }}</span>
              </div>

              <div class="form-group">
                <label for class="float-left">Código de compra</label>
                <input
                  type="text"
                  aria-describedby="email"
                  name="codigo_compra"
                  v-validate="{
                    required:
                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,
                  }"
                  class="form-control null sen-form-input-with-tooltip"
                  :maxlength="20"
                  v-model="finalBuyingCode"
                />

                <div class="sen-tooltip sen-tooltip-modal">
                  <span
                    >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates
                    quod ut, aperiam laboriosa</span
                  >
                </div>

                <span v-show="errors.has('codigo_compra')" class="text-danger">{{
                  errors.first("codigo_compra")
                }}</span>
              </div>

              <div class="form-group">
                <div v-if="!otherCarrierFlag">
                  <label for class="float-left">Seleccionar Carrier</label>

                  <select
                    class="form-control form-control-lg sen-form-input-with-tooltip"
                    name="transportista"
                    v-validate="{
                      required:
                        this.orderDataShow.attributes.status === 3 && sendProcessFlag,
                    }"
                    v-model="carrier"
                  >
                    <option :value="''">Selecciona</option>

                    <option
                      :value="`${index}`"
                      v-for="(carrier, index) in carrier_list"
                      :key="`${index}`"
                    >
                      {{ carrier.name }}
                    </option>
                  </select>

                  <div class="sen-tooltip sen-tooltip-modal">
                    <span
                      >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Voluptates quod ut, aperiam laboriosa</span
                    >
                  </div>

                  <a
                    class="link-trans"
                    v-if="false && carrier != '' && carrier_list[carrier].url != ''"
                    :href="carrier_list[carrier].url"
                    >{{ carrier_list[carrier].name }}</a
                  >
                </div>

                <div v-else>
                  <label for class="float-left"
                    >Ingresa el nombre del transportista</label
                  >

                  <input
                    type="text"
                    aria-describedby="email"
                    name="other_carrier_name"
                    v-validate="{
                      required:
                        this.orderDataShow.attributes.status === 3 && sendProcessFlag,
                    }"
                    class="form-control null sen-form-input-with-tooltip"
                    :maxlength="20"
                    v-model="otherCarrierName"
                  />

                  <div class="sen-tooltip sen-tooltip-modal">
                    <span
                      >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Voluptates quod ut, aperiam laboriosa</span
                    >
                  </div>
                </div>
              </div>

              <div class="form-group">
                <input
                  type="checkbox"
                  class="checkbox-style"
                  id="otherCarrierFlag"
                  v-model="otherCarrierFlag"
                />

                <span class="reward-label">Otro transportista</span>

                <span v-show="errors.has('transportista')" class="text-danger">{{
                  errors.first("transportista")
                }}</span>
              </div>

              <div class="form-group">
                <label for class="float-left">Número de tracking</label>
                <input
                  type="text"
                  aria-describedby="email"
                  name="numero_tracking"
                  v-validate="{
                    required:
                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,
                  }"
                  class="form-control null sen-form-input-with-tooltip"
                  :maxlength="30"
                  v-model="numberTracking"
                />

                <div class="sen-tooltip sen-tooltip-modal">
                  <span
                    >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates
                    quod ut, aperiam laboriosa</span
                  >
                </div>

                <span v-show="errors.has('numero_tracking')" class="text-danger">{{
                  errors.first("numero_tracking")
                }}</span>
              </div>

              <div class="form-group">
                <label for class="float-left">Fecha de llegada al origen</label>
                <input
                  type="date"
                  aria-describedby="email"
                  name="fecha_llegada_origen"
                  v-validate="{
                    required:
                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,
                  }"
                  class="form-control null sen-form-input-with-tooltip"
                  v-model="postingDate"
                  max="2100-01-01"
                  min="1900-01-01"
                />

                <div class="sen-tooltip sen-tooltip-modal">
                  <span
                    >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates
                    quod ut, aperiam laboriosa</span
                  >
                </div>

                <span v-show="errors.has('fecha_llegada_origen')" class="text-danger">{{
                  errors.first("fecha_llegada_origen")
                }}</span>
              </div>

              <div class="form-group">
                <label for class="float-left">Seleccionar operador de envío</label>
                <select
                  class="form-control form-control-lg sen-form-input-with-tooltip"
                  name="operador_envio"
                  v-validate="{
                    required:
                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,
                  }"
                  v-model="operatorOrigin"
                >
                  <option :value="''">Selecciona</option>
                  <!-- <option
                    :value="operator.id"
                    v-for="operator of listOperators"
                    :key="operator.id"
                  >
                    {{ operator.attributes.username }}
                  </option> -->
                </select>

                <div class="sen-tooltip sen-tooltip-modal">
                  <span
                    >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates
                    quod ut, aperiam laboriosa</span
                  >
                </div>

                <span v-show="errors.has('operador_envio')" class="text-danger">{{
                  errors.first("operador_envio")
                }}</span>
              </div>
            </div>
          </div>

          <div class="modal-footer text-right">
            <button
              class="btn btn-primary btn-lg"
              @click="updateIncompleOrderData"
              :disabled="!readyToSaveIncompleteData"
            >
              Guardar cambios
            </button>

            <button
              type="button"
              class="btn btn-primary btn-lg"
              :disabled="!readyToProcessIncompleteData"
              @click="sendProcess(id)"
            >
              Procesar
            </button>
          </div>
        </div>
      </b-modal>

      <b-modal
        hide-footer
        hide-header
        centered
        id="modalProcessNoGrabr"
        ref="modalProcessNoGrabr"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Datos de compra adicional de orden Direct
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="hideModalProcessNoGrabr"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body modal-scroll" id="modal-body">
            <div class="form-login" id="infoextra">
              <div class="form-group">
                <label for class="float-left">Código de compra</label>
                <input
                  type="text"
                  aria-describedby="email"
                  class="form-control null sen-form-input-with-tooltip"
                  name="codigo_compra"
                  v-validate="{
                    required:
                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,
                  }"
                  v-model="finalBuyingCode"
                />

                <div class="sen-tooltip sen-tooltip-modal">
                  <span
                    >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates
                    quod ut, aperiam laboriosa</span
                  >
                </div>

                <span v-show="errors.has('codigo_compra')" class="text-danger">{{
                  errors.first("codigo_compra")
                }}</span>
              </div>

              <div class="form-group">
                <div v-if="!otherCarrierFlag">
                  <label for class="float-left">Seleccionar transportista</label>

                  <select
                    class="form-control form-control-lg sen-form-input-with-tooltip"
                    name="transportista"
                    v-validate="{
                      required:
                        this.orderDataShow.attributes.status === 3 && sendProcessFlag,
                    }"
                    v-model="carrier"
                  >
                    <option :value="''">Selecciona</option>

                    <option
                      :value="`${index}`"
                      v-for="(carrier, index) in carrier_list"
                      :key="`${index}`"
                    >
                      {{ carrier.name }}
                    </option>
                  </select>

                  <div class="sen-tooltip sen-tooltip-modal">
                    <span
                      >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Voluptates quod ut, aperiam laboriosa</span
                    >
                  </div>

                  <a
                    class="link-trans"
                    v-if="carrier != ''"
                    :href="carrier_list[carrier].url"
                    target="_blank"
                    >Enlace a {{ carrier_list[carrier].name }}</a
                  >
                </div>

                <div v-else>
                  <label for class="float-left"
                    >Ingresa el nombre del transportista</label
                  >

                  <input
                    type="text"
                    aria-describedby="email"
                    name="other_carrier_name"
                    v-validate="{
                      required:
                        this.orderDataShow.attributes.status === 3 && sendProcessFlag,
                    }"
                    class="form-control null sen-form-input-with-tooltip"
                    :maxlength="20"
                    v-model="otherCarrierName"
                  />

                  <div class="sen-tooltip sen-tooltip-modal">
                    <span
                      >Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                      Voluptates quod ut, aperiam laboriosa</span
                    >
                  </div>
                </div>
              </div>

              <div class="form-group">
                <input
                  type="checkbox"
                  class="checkbox-style"
                  id="otherCarrierFlag"
                  v-model="otherCarrierFlag"
                />

                <span class="reward-label">Otro transportista</span>

                <span v-show="errors.has('transportista')" class="text-danger">{{
                  errors.first("transportista")
                }}</span>
              </div>

              <div class="form-group">
                <!-- Acá debería ir el autocompletado o no del tracking  -->
                <label for class="float-left">Número de tracking</label>
                <input
                  type="text"
                  aria-describedby="email"
                  name="numero_tracking"
                  v-validate="{
                    required:
                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,
                  }"
                  class="form-control null sen-form-input-with-tooltip"
                  :maxlength="30"
                  v-model="numberTracking"
                />

                <div class="sen-tooltip sen-tooltip-modal">
                  <span
                    >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates
                    quod ut, aperiam laboriosa</span
                  >
                </div>

                <span v-show="errors.has('numero_tracking')" class="text-danger">{{
                  errors.first("numero_tracking")
                }}</span>
              </div>

              <div class="form-group">
                <label for class="float-left">Fecha de llegada al origen</label>
                <input
                  type="date"
                  aria-describedby="email"
                  name="fecha_llegada_origen"
                  v-validate="{
                    required:
                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,
                  }"
                  class="form-control null sen-form-input-with-tooltip"
                  max="2100-01-01"
                  min="1900-01-01"
                  v-model="postingDate"
                />

                <div class="sen-tooltip sen-tooltip-modal">
                  <span
                    >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates
                    quod ut, aperiam laboriosa</span
                  >
                </div>

                <span v-show="errors.has('fecha_llegada_origen')" class="text-danger">{{
                  errors.first("fecha_llegada_origen")
                }}</span>
              </div>

              <div class="form-group">
                <label for class="float-left">Entrega prometida</label>
                <input
                  type="date"
                  aria-describedby="email"
                  name="fecha_llegada_cliente"
                  v-validate="{
                    required:
                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,
                  }"
                  class="form-control null sen-form-input-with-tooltip"
                  v-model="sendingDate"
                  max="2100-01-01"
                  min="1900-01-01"
                  @change="validar"
                />

                <div class="sen-tooltip sen-tooltip-modal">
                  <span
                    >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates
                    quod ut, aperiam laboriosa</span
                  >
                </div>

                <span v-show="errors.has('fecha_llegada_cliente')" class="text-danger">{{
                  errors.first("fecha_llegada_cliente")
                }}</span>
              </div>

              <div class="form-group">
                <label for class="float-left">Seleccionar operador de envío</label>
                <select
                  class="form-control form-control-lg sen-form-input-with-tooltip"
                  name="operador_envio"
                  v-validate="{
                    required:
                      this.orderDataShow.attributes.status === 3 && sendProcessFlag,
                  }"
                  v-model="operatorOrigin"
                >
                  <option :value="''">Selecciona</option>
                  <!-- <option
                    :value="operator.id"
                    v-for="operator of listOperators"
                    :key="operator.id"
                  >
                    {{ operator.attributes.username }}
                  </option> -->
                </select>

                <div class="sen-tooltip sen-tooltip-modal">
                  <span
                    >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates
                    quod ut, aperiam laboriosa</span
                  >
                </div>

                <span v-show="errors.has('operador_envio')" class="text-danger">{{
                  errors.first("operador_envio")
                }}</span>
              </div>
            </div>
          </div>

          <div class="modal-footer text-right">
            <button
              class="btn btn-primary btn-lg"
              @click="updateIncompleOrderData"
              :disabled="!readyToSaveIncompleteData"
            >
              Guardar cambios
            </button>
            <button
              type="button"
              class="btn btn-primary btn-lg"
              :disabled="!readyToProcessIncompleteData"
              @click="sendProcess(id)"
            >
              Procesar
            </button>
          </div>
        </div>
      </b-modal>

      <b-modal hide-footer hide-header id="validacionmodal" ref="validacionmodal">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle"></h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              block
              @click="hideModalValidation"
              centered
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body modal-scroll modal-correcto text-center">
            <div class="validacion-body">
              <h1></h1>
            </div>
          </div>
          <div class="modal-footer text-center">
            <button
              type="button"
              class="btn btn-success"
              block
              @click="hideModalValidation"
            >
              Continuar
            </button>
          </div>
        </div>
      </b-modal>

      <b-modal
        hide-footer
        hide-header
        centered
        id="cancelOrdermodal"
        ref="cancelOrdermodal"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle"></h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              block
              @click="hideCancelValidation"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body modal-scroll modal-no-correcto text-center">
            <div class="validacion-body">
              <h1></h1>
            </div>
          </div>
        </div>
      </b-modal>

      <b-modal
        hide-footer
        hide-header
        centered
        id="modalConfirmation"
        ref="modalConfirmation"
      >
        <div class="modal-Content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Confirmar acción:</h5>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="hideModalConfirmation"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body modal-scroll" id="modal-body">
            <div class="text-center">
              <p>
                Se cambiará el estado de la orden a cancelado, esta acción no es
                reversible. ¿Estas seguro de completar esta acción?
              </p>
            </div>
          </div>

          <div class="modal-footer text-center">
            <button
              type="button"
              class="btn btn-primary btn-lg"
              @click="cancelatePurchaseOrder(id)"
            >
              Confirmar
            </button>
            <button
              type="button"
              class="btn btn-primary btn-lg"
              @click="hideModalConfirmation()"
            >
              Cancelar
            </button>
          </div>
        </div>
      </b-modal>

      <b-modal
        hide-footer
        hide-header
        centered
        id="modalConfirmationDelete"
        ref="modalConfirmationDelete"
      >
        <div class="modal-Content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Confirmar acción:</h5>
            <button
              type="button"
              class="close"
              aria-label="Close"
              @click="hideModalConfirmationDelete"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body modal-scroll" id="modal-body">
            <div class="text-center">
              <p>
                Se eliminará la orden de forma física, esta acción no es reversible.
                ¿Estas seguro de completar esta acción?
              </p>
            </div>
          </div>

          <div class="modal-footer text-center">
            <button
              type="button"
              class="btn btn-primary btn-lg"
              @click="deletePurchaseOrder(id)"
            >
              Confirmar
            </button>
            <button
              type="button"
              class="btn btn-primary btn-lg"
              @click="hideModalConfirmationDelete()"
            >
              Cancelar
            </button>
          </div>
        </div>
      </b-modal>
      <!-- ZONA DE TRABAJO -->
      <!-- <b-modal hide-footer hide-header centered id="modalCompleteLinio" ref="modalCompleteLinio">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" >Completar Orden de Coompra Linio </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hideModalCompleteLinio">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body modal-scroll" id="modal-body">
            <div class="form-login" id="infoextra">
              <div class="form-group">
                <label for class="float-left">Impuesto linio</label>
                <input
                  type="text"
                  aria-describedby="email"
                  name="linio_tax"
                  v-validate="{required: noEvaluationFlag}"
                  class="form-control null sen-form-input-with-tooltip"
                  v-model="taxLinio"
                >
                <span
                  v-show="errors.has('linio_tax')"
                  class="text-danger"
                >{{ errors.first('linio_tax') }}</span>
              </div>
              <div class="form-group">
                <label for class="float-left">Recompensa linio</label>
                <input
                  type="text"
                  aria-describedby="email"
                  name="linio_reward"
                  v-validate="{required: noEvaluationFlag}"
                  class="form-control null sen-form-input-with-tooltip"
                  v-model="rewardLinio"
                >
                <span
                  v-show="errors.has('linio_reward')"
                  class="text-danger"
                >{{ errors.first('linio_reward') }}</span>
              </div>
              <div class="input-group">



                <select class="form-control form-control-lg sen-form-input-with-tooltip" name="linio_origin_city" v-validate="{required: noEvaluationFlag}" v-model="LinioCityOrigin">
                  <option disabled value>Selecciona</option>
                  <option :value="cityOrigin" v-for="cityOrigin of listCities">{{cityOrigin.attributes.name}}</option>
                </select>

                <div class="sen-tooltip">
                  <span>Es la ciudad origen del embarque</span>
                </div>

                <span v-show="errors.has('linio_origin_city')" class="text-danger">{{ errors.first('linio_origin_city') }}</span>

              </div>
              <div class="input-group">



                <select class="form-control form-control-lg sen-form-input-with-tooltip" name="linio_destiny_city" v-validate="{required: noEvaluationFlag}" v-model="LinioCityDestiny">
                  <option disabled value>Selecciona</option>
                  <option :value="cityDestiny" v-for="cityDestiny of listCities">{{cityDestiny.attributes.name}}</option>
                </select>

                <div class="sen-tooltip">
                  <span>Es la ciudad destino del embarque</span>
                </div>

                <span v-show="errors.has('linio_destiny_city')" class="text-danger">{{ errors.first('linio_destiny_city') }}</span>

              </div>
            </div>
          </div>
          <div class="modal-footer text-right">

          </div>
        </div>
      </b-modal> -->
      <!-- <dialog id="modal-reasignar">
        <article class="u-modal">
          <form
            @submit.prevent="getUserSearch"
            class="u-modal-content"
            style="max-width: 70vw; width: 70vw"
          >
            <div class="form-block-text d-flex justify-content-between">
              <span>Reasignar orden</span>
              <span style="cursor: pointer" @click="closeModal('modal-reasignar')">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  style="fill: rgba(0, 0, 0, 1); transform: ; msfilter: "
                >
                  <path
                    d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                  ></path>
                </svg>
              </span>
            </div>
            <div class="form-group">
              <label>Número de documento</label>
              <div class="form-client">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="search.dni"
                    v-digitsonly
                    maxlength="8"
                    required
                  />

                  <div class="input-group-append" id="button-addon4">
                    <button
                      type="submit"
                      class="btn btn-primary btn-lg btn-edit btn-subir"
                    >
                      Validar cliente
                    </button>
                  </div>
                </div>
              </div>

              <div
                v-if="search.result !== null"
                class="validacion-cliente validacion-cliente-encontrado"
              >
                Cliente encontrado:
                {{
                  search.result.attributes.profile.attributes.name +
                  " " +
                  search.result.attributes.profile.attributes.surnames
                }}
              </div>
              <div
                v-if="search.error"
                class="validacion-cliente validacion-cliente-no-encontrado"
              >
                Cliente no existe en el sistema
              </div>
              <div class="form-group">
                <button
                  v-if="search.result !== null"
                  @click.prevent="changeUserOrder"
                  class="btn btn-primary btn-lg btn-edit"
                >
                  Asignar orden
                </button>
              </div>
            </div>
          </form>
        </article>
      </dialog> -->
      <div></div>
    </div>
  </div>
</template>
<script>
import breadcrumb from "@/components/prefab/structures/breadcrumb.vue";
import spanish from "vee-validate/dist/locale/es";
import axios from "axios";
import resumePurchaseOrder from "@/components/prefab/elements/resume-purchase-order";
import cardEvaluateOrders from "@/components/prefab/items/card-evaluate-orders.vue";
import { ordersService } from "@/services/orders.service";
import { commentsService } from "@/services/comments.service";
import { packagesService } from "@/services/packages.service";
import orderImportantInfo from "@/components/prefab/elements/order-important-info";
import commentComponent from "@/components/prefab/items/comment-component";
import moment from "moment";

export default {
  components: {
    resumePurchaseOrder,
    breadcrumb,
    orderImportantInfo,
    commentComponent,
    cardEvaluateOrders,
  },
  props: ["id", "orderData"],
  data() {
    return {
      formReviewSer: {
        respuesta: null,
        fileformReview: null,
      },
      imageManifiesto: "",
      historyUser: null,
      search: {
        dni: null,
        result: null,
        error: false,
      },
      resultSearchWr: null,
      searchWR: null,
      listWarehouse: null,
      formCreate: {
        purchase_order_id: null,
        consignee: null,
        remitter: null,
        carrier: null,
        tracking: null,
        comment: null,
        unidad: 12,
        weight: null,
        images: [],
      },
      entregaSendiList: [],
      entregaSendi: {
        entrega: "Oficina",
        desciption: "",
        evidencia: "",
      },
      selectTracking: "I",
      localInternacionalTracking: {
        codigo: "",
        type: "1",
      },
      imageComprobante: "",
      codigoTransferencia: "",
      imageVaucher: "",
      dataViajeros: [],
      dataInputViajero: "",
      buscarViajeroCampo: "1",
      dataInternationalShooper: [],
      interShooper: {
        tienda: "",
        enlace: "",
        precio: "",
        cantidad: "",
        peso: "",
        order: "",
        invoice: "",
      },
      statusTracking: [
        { id: 1, text: "EN REVISIÓN" },
        { id: 2, text: "COMPRADO" },
        { id: 3, text: "PREPARANDO PARA ENVIAR" },
        { id: 4, text: "LISTO PARA ENVIAR" },
        { id: 5, text: "ENVIADO" },
        { id: 6, text: "LISTO PARA ENTREGAR" },
        { id: 7, text: "ENTREGADO" },
        { id: 8, text: "SINIESTRADO" },
        { id: 9, text: "EN PROCESO DE DEVOLUCIÓN" },
        { id: 10, text: "RETORNADO AL PROVEEDOR" },
      ],

      dataNationalTracking: [],
      dataLocalTracking: [],

      statusPayment: [
        { id: 1, text: "PENDIENTE" },
        { id: 2, text: "EN PROCESO" },
        { id: 3, text: "CONFIRMADO" },
        { id: 10, text: "RECHAZADO" },
        { id: 11, text: "RECLAMADO" },
        { id: 12, text: "RETORNADO" },
      ],
      trackingNumber: "",
      seguimientoTrackin: "",
      locale: "en",
      sendProcessFlag: false,
      currentContent: "",
      orderDataShow: null,
      unitWeight: "",
      weightGrabr: "",
      costGrabr: "",
      taxGrabr: "",
      shippingGrabr: "",
      CostReal: "",
      TaxReal: "",
      shippingReal: "",
      finalBuyingLink: "",
      finalBuyingCode: "",
      numberTracking: "",
      postingDate: "",
      sendingDate: "",
      operatorOrigin: "",
      carrier: "",
      otherCarrierName: "",
      listUnits: [],
      listOperators: [],
      flagFormEvaluetionPurchaseOrder: "toFill",
      controllSwithPurchaseOrder: 1,
      rewardDiscount: "",
      rewardFlag: false,
      packaged: 1,
      otherCarrierFlag: false,
      editPackagedFlag: false,
      packageRepositions: [],
      createCommentFlag: true,
      authorizationOption: null,

      carrier_list: [
        { name: "FedEx", url: "https://www.fedex.com/en-us/home.html" },
        {
          name: "USPS",
          url: "https://tools.usps.com/go/TrackConfirmAction_input",
        },
        { name: "UPS", url: "https://www.ups.com/us/en/Home.page" },
        { name: "DHL", url: "https://www.dhl.com/en/express/tracking.html" },
        { name: "AMAZON_US", url: "" },
      ],
      nameSection: "Visualizar orden de compra",
      listRoutes: [{ nameRoute: "Orders", titleRoute: "Órdenes de compra" }],
      activeRoute: "",
      comments: [],
      packages: [],
      // listCities: [],
      // taxLinio: '0',
      // rewardLinio: '0',
      // LinioCityOrigin: '',
      // LinioCityDestiny : ''
      pagosStatus: null,
      trakingStatus: null,
      switchWR: 1,
    };
  },
  created() {
    this.$validator.localize("es", {
      messages: spanish.messages,
      attributes: {
        fullname: "nombre completo",
        document_number: "número de documento",
        phone_number: "número de celular",
        price: "precio",
        tax: "impuesto",
        product_image: "imagen del artículo",
        purchase_order_number: "número de orden de compra",
        product_information: "información del producto",
        purchase_order_link: "link de orden de compra",
        purchase_chat_link: "link de chat de compra",
        purchase_order_date: "fecha de asignación al viajero",
        origin_city: "ciudad de origen",
        destination_city: "ciudad de destino",
        possible_delivery_date: "fecha posible de entrega",
        precio_web: "precio de la web",
        impuesto_web: " impuesto de la web",
        costo_envio_web: "costo de envío de la web",
        peso_orden: "peso de la orden",
        unidad_peso: "unidad de peso",
        costo_real: "precio real",
        real_tax: "impuesto real",
        real_delivery_cost: "costo de envío real",
        link_compra_final: "link de compra final",
        codigo_compra: "código de compra",
        numero_tracking: "número de tracking",
        fecha_llegada_origen: "fecha de llegada al origen",
        operador_envio: "operador de envío",
        transportista: "transportista",
        fecha_llegada_cliente: "Entrega prometida",
        // linio_tax: 'taza linio',
        // linio_reward: 'recompensa linio'
      },
    });

    // start with spanish locale.
    this.$validator.localize("es");
    // this.orderDataShow = this.orderData

    console.log("obtendremos de nuevo la data");
    this.inicializeData(this.id, this.setData);
    this.displayComments();

    this.getInternationalTracking();
    this.getInternationalShooper();
    this.getLocalTracking();
    this.getEntregaSendi();
    this.getWarehouse();
    this.getHistoryUser();
  },

  methods: {
    subirArchivoReview(e) {
      const file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (file) => {
        this.formReviewSer.fileformReview = file.target.result;
      };
      reader.readAsDataURL(file);
    },
    RespuestaReview() {
      let url = process.env.API_URL + "/api/purchaseOrder/new-review/" + this.id;
      axios
        .post(url, {
          review_mensaje: this.formReviewSer.respuesta,
          review_archivo: this.formReviewSer.fileformReview,
          from_admin: "1",
        })
        .then(() => {
          location.reload();
        })
        .catch((error) => {
          if (error) {
            //----------component--------//
            alert("Error al enviar la respuesta ");
            //--------------------------//
          }
        });
    },
    liberarWR(code) {
      let url = process.env.API_URL + "/api/warehouse/unnasignByCode/" + code;
      axios
        .get(url)
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          alert("Error al liberar el WR ");
        });
    },
    changeSiwtch(id) {
      this.switchWR = id;
    },
    //Historial de la orden
    getHistoryUser() {
      let url = process.env.API_URL + "/api/admin/list/historialOrder/" + this.id;
      axios
        .get(url)
        .then((response) => {
          this.historyUser = response.data.body;
        })
        .catch(() => {
          alert("Error al obtener el historial del pedido");
        });
    },
    //metodo para reasignar una oprden
    changeUserOrder() {
      var answer = window.confirm("¿Desea reasignar orden?");

      if (this.search.dni && this.search.result && answer) {
        let url = process.env.API_URL + "/api/admin/changeOrder/" + this.id;
        axios
          .post(url, {
            newIdUser: this.search.result.id,
            oldUser: this.orderDataShow.attributes.client.id,
          })
          .then(() => {
            location.reload();
          })
          .catch(() => {
            this.search.result = null;
            this.search.dni = null;
            alert("Error al reasignar orden");
          });
      }
    },
    //metodo para buscar usuario
    getUserSearch() {
      let url = process.env.API_URL + "/api/client/getByClientCode/" + this.search.dni;
      axios
        .post(url, {
          clientCodeOld: this.orderDataShow.attributes.client.attributes.profile
            .attributes.userable.client_code,
          store: this.orderDataShow.attributes.client.attributes.profile.attributes
            .userable.attributes.store_id,
        })
        .then((response) => {
          this.search.result = response.data.body;
          this.search.error = false;
        })
        .catch(() => {
          this.search.result = null;
          this.search.error = true;
          this.search.dni = null;
        });
    },
    openModal(id) {
      const modal = document.getElementById(id);
      modal.showModal();
    },
    closeModal(id) {
      if (id === "modal-reasignar") {
        this.search.result = null;
        this.search.dni = null;
        this.search.error = false;
      }
      const modal = document.getElementById(id);
      modal.close();
    },
    updatePaquete(idWarehouse) {
      let url = process.env.API_URL + "/api/warehouse/update/" + idWarehouse;
      axios
        .post(url, {
          purchase_order_id: this.id,
        })
        .then(() => {
          location.reload();
        })
        .catch(() => {
          alert("Error actualizar paquete");
        });
    },
    async changeStatusTracking(data) {
      if (
        data !==
        this.orderDataShow.attributes.order_tracking_details[
          this.orderDataShow.attributes.order_tracking_details.length - 1
        ].attributes.status
      ) {
        var text = "";
        if (data === 1) {
          text = "Desea agregar el estado 'IN_EVALUATION'";
        }
        if (data === 2) {
          text = "Desea agregar el estado 'WAITING_EVALUATION_CONFIRMATION'";
        }
        if (data === 3) {
          text = "Desea agregar el estado 'COMPLETING_PURCHASE_INFO'";
        }
        if (data === 4) {
          text = "Desea agregar el estado 'READY_TO_BOARDING'";
        }
        if (data === 5) {
          text = "Desea agregar el estado 'IN_BOARDING'";
        }
        if (data === 6) {
          text = "Desea agregar el estado 'READY_TO_PICKUP'";
        }
        if (data === 7) {
          text = "Desea agregar el estado 'DELIVERY_SUCCESS'";
        }
        if (data === 8) {
          text = "Desea agregar el estado 'SINISTER'";
        }
        if (data === 9) {
          text = "Desea agregar el estado 'RETURN'";
        }
        if (data === 10) {
          text = "Desea agregar el estado 'RETURN_TO_SUPPLIER'";
        }

        var answer = window.confirm(text);
        if (answer) {
          let url =
            process.env.API_URL +
            "/api/purchaseOrder/" +
            this.orderDataShow.id +
            "/addTracking";
          await axios
            .post(url, { status: data, admin: this.$store.state.user.id })
            .then(() => {
              location.reload();
            })
            .catch(() => {
              alert("Hubo un error");
              this.trakingStatus = this.orderDataShow.attributes.order_tracking_details[
                this.orderDataShow.attributes.order_tracking_details.length - 1
              ].attributes.status;
            });
        } else {
          this.trakingStatus = this.orderDataShow.attributes.order_tracking_details[
            this.orderDataShow.attributes.order_tracking_details.length - 1
          ].attributes.status;
        }
      }
    },
    getWarehouse() {
      let url =
        process.env.API_URL + "/api/warehouse/list-packages-by-order-id/" + this.id;
      axios
        .get(url)
        .then((response) => {
          this.listWarehouse = response.data.data;
        })
        .catch(() => {
          alert("Error al obtener la lista de WR");
        });
    },
    searchWrehouse() {
      let url = process.env.API_URL + "/api/warehouse/getByCode/" + this.searchWR;
      axios
        .get(url)
        .then((response) => {
          this.resultSearchWr = response.data.body;
        })
        .catch(() => {
          alert("Error al buscar warehouse");
        });
    },
    limitchangePaquete() {
      this.is_loading = true;
      let url = process.env.API_URL + "/api/warehouse/changeWarehouseStatus/" + this.id;
      axios
        .get(url)
        .then(() => {
          location.reload();
        })
        .catch(() => {
          alert("Error al cambiar el estado");
          this.is_loading = false;
        });
    },
    handleFileInput(event) {
      const files = event.target.files;
      const images = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (!file.type.match("image.*")) {
          continue;
        }
        const reader = new FileReader();

        reader.onload = (function (file) {
          return function (event) {
            images.push(event.target.result);
          };
        })(file);
        reader.readAsDataURL(file);
        this.formCreate.images = images;
      }
    },
    createPaquete() {
      this.is_loading = true;
      let url = process.env.API_URL + "/api/warehouse/save-package";
      axios
        .post(url, {
          purchase_order_id: this.id,
          consignee: this.formCreate.consignee,
          carrier: this.formCreate.carrier,
          remitter: this.formCreate.remitter,
          tracking: this.formCreate.tracking,
          comment: this.formCreate.comment,
          weight_unit_id: this.formCreate.unidad,
          weight: this.formCreate.weight,
          images: this.formCreate.images,
        })
        .then(() => {
          location.reload();
        })
        .catch(() => {
          alert("Error al asignar el paquete");
          this.is_loading = false;
        });
    },
    async changeStatusPayment(data) {
      if (data !== this.orderDataShow.attributes.payed) {
        let url =
          process.env.API_URL +
          "/api/purchaseOrder/update-order-no-grabr/" +
          this.orderDataShow.id;
        var text = "";
        if (data === 1) {
          text = "desea cambiar el estado a  'PENDIENT'";
        }
        if (data === 2) {
          text = "desea cambiar el estado a  'SOFT_PAYED'";
        }
        if (data === 3) {
          text = "desea cambiar el estado a  'HARD_PAYED'";
        }
        if (data === 4) {
          text = "desea cambiar el estado a  'CONFIRMED'";
        }
        if (data === 10) {
          text = "desea cambiar el estado a  'REJECTED'";
        }
        if (data === 11) {
          text = "desea cambiar el estado a  'RECLAIMED'";
        }
        if (data === 12) {
          text = "desea cambiar el estado a  'RETURNED'";
        }
        var answer = window.confirm(text);
        if (answer) {
          await axios
            .put(url, {
              payed: data,
              writer_id: this.$store.state.user.attributes.profile.id,
            })
            .then(() => {
              location.reload();
            })
            .catch(() => {
              alert("Hubo un error");
              this.pagosStatus = this.orderDataShow.attributes.payed;
            });
        } else {
          this.pagosStatus = this.orderDataShow.attributes.payed;
        }
      }
    },
    deleteEntregaSendi(value) {
      var answer = window.confirm("Desea eliminar");

      if (answer) {
        let url =
          process.env.API_URL + "/api/deleteDeliverySendi/" + value + "/" + this.id;
        axios
          .get(url)
          .then(() => {
            location.reload();
          })
          .catch((error) => {
            if (error) {
              alert("Sucedió un error");
            }
          });
      }
    },
    getEntregaSendi() {
      let url = process.env.API_URL + "/api/listDeliverySendi/" + this.id;
      axios
        .get(url)
        .then((response) => {
          this.entregaSendiList = response.data.body;
        })
        .catch((error) => {
          if (error) {
            alert("Sucedió un error");
          }
        });
    },
    evidenciaSendi(e) {
      const file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (file) => {
        this.entregaSendi.evidencia = file.target.result;
      };
      reader.readAsDataURL(file);
    },
    saveEntregaSendi(e) {
      let url = process.env.API_URL + "/api/addDeliverySendi";
      axios
        .post(url, {
          delivery: this.entregaSendi.entrega,
          description: this.entregaSendi.desciption,
          evidence: this.entregaSendi.evidencia,
          codeOrder: this.id,
        })
        .then(() => {
          location.reload();
        })
        .catch((error) => {
          if (error) {
            alert("Sucedió un error");
          }
        });
    },
    fileReturn(e) {
      const file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (file) => {
        this.cargarFileReturn(file.target.result);
      };
      reader.readAsDataURL(file);
    },
    cargarFileReturn(file) {
      let url =
        process.env.API_URL + "/api/purchaseOrder/update-order-no-grabr/" + this.id;
      axios
        .put(url, {
          serviceReturn: {
            serviceReturn: file,
            isFromAdmin: true,
          },
          writer_id: this.$store.state.user.attributes.profile.id,
        })
        .then(() => {
          location.reload();
        })
        .catch(() => {
          alert("Sucedió un error al cargar file de return");
        });
    },
    deleteFileReturn(data) {
      var answer = window.confirm("Desea eliminar el documento");
      if (answer) {
        let url =
          process.env.API_URL + "/api/purchaseOrder/deleteServiceReturn/" + this.id;
        axios
          .delete(url, {
            data: {
              serviceReturn_path: data.url_return,
            },
          })
          .then(() => {
            location.reload();
          })
          .catch(() => {
            alert("Sucedió un error");
          });
      }
    },
    deleteInvoice(data, index) {
      var answer = window.confirm("Desea eliminar el invoice - " + index);
      if (answer) {
        let url = process.env.API_URL + "/api/purchaseOrder/deleteinvoice/" + this.id;
        axios
          .delete(url, {
            data: {
              invoice_path: data,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              location.reload();
            }
          })
          .catch((error) => {
            if (error) {
              alert("Sucedió un error");
            }
          });
      }
    },
    deleteManifiesto(data, index) {
      var answer = window.confirm("Desea eliminar el Manifiesto - " + index);

      if (answer) {
        let url = process.env.API_URL + "/api/purchaseOrder/deleteManifest/" + this.id;
        axios
          .delete(url, {
            data: {
              manifest_path: data,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              location.reload();
            }
          })
          .catch((error) => {
            if (error) {
              alert("Sucedió un error");
            }
          });
      }
    },

    statusInvoice(data, index, status) {
      var answer = window.confirm(
        status === 0
          ? "cambiar a aprobar el adjunto " + index
          : "cambiar a sin aprobar el adjunto " + index
      );
      if (answer) {
        let url = process.env.API_URL + "/api/purchaseOrder/approveinvoice/" + this.id;
        axios
          .get(url, {
            params: {
              invoice_path: data,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              location.reload();
            }
          })
          .catch((error) => {
            if (error) {
              alert("Sucedió un error");
            }
          });
      }
    },
    statusManifiesto(data, index, status) {
      var answer = window.confirm(
        status === 0
          ? "cambiar a aprobar el Manifiesto " + index
          : "cambiar a sin aprobar el Manifiesto " + index
      );
      if (answer) {
        let url = process.env.API_URL + "/api/purchaseOrder/approvemanifest/" + this.id;
        axios
          .post(url, {
            manifest_path: data,
          })
          .then((response) => {
            if (response.status === 200) {
              location.reload();
            }
          })
          .catch((error) => {
            if (error) {
              alert("Sucedió un error");
            }
          });
      }
    },

    invoice(e) {
      const file2 = e.target.files[0];
      this.cargarInvoice(file2);
    },
    cargarInvoice(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.interShooper.invoice = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    comprobante(e) {
      const file2 = e.target.files[0];
      this.cargarImagenComprobante(file2);
    },
    cargarImagenComprobante(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.imageComprobante = e.target.result;
        var answer = window.confirm("Desea cambiar el vaucher?");
        if (answer) {
          this.sendVaucherComprobante(0);
        } else {
          this.$refs.fileuploadComprobante.value = null;
          this.codigoTransferencia = "";
          this.imageComprobante = "";
        }
      };
      reader.readAsDataURL(file);
    },

    sendVaucherComprobante(type) {
      var objectVaucher = new Object();
      if (type === 1) {
        objectVaucher.payment_code = this.codigoTransferencia;
      } else if (type === 0) {
        objectVaucher.voucher = { voucher: this.imageComprobante, isFromAdmin: true };
      }
      objectVaucher.writer_id = this.$store.state.user.attributes.profile.id;
      if (type === 1) {
        var answer = window.confirm("Desea cambiar el código?");
      }

      if (type === 0 || (type === 1 && answer)) {
        let url =
          process.env.API_URL + "/api/purchaseOrder/update-order-no-grabr/" + this.id;
        axios
          .put(url, objectVaucher)
          .then((response) => {
            if (response.status === 200) {
              this.$refs.fileuploadComprobante.value = null;
              this.codigoTransferencia = "";
              this.imageComprobante = "";
              location.reload();
            }
          })
          .catch((error) => {
            if (error) {
              this.codigoTransferencia = "";
              this.imageComprobante = "";
              this.$refs.fileuploadComprobante.value = null;
              alert("Sucedió un error");
            }
          });
      }
    },
    manifiestoFile(e) {
      const file = e.target.files[0];
      this.cargarManifiesto(file);
    },
    cargarManifiesto(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.imageManifiesto = e.target.result;
        this.sendManifiesto();
      };
      reader.readAsDataURL(file);
    },
    sendManifiesto() {
      let url = process.env.API_URL + "/api/purchaseOrder/createmanifest/" + this.id;
      axios
        .post(url, {
          from_admin: 1,
          manifest_archivo: this.imageManifiesto,
        })
        .then(() => {
          location.reload();
        })
        .catch((error) => {
          if (error) {
            alert("Sucedió un error");
          }
        });
    },
    factura(e) {
      const file = e.target.files[0];
      this.cargarImagen(file);
    },
    cargarImagen(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.imageVaucher = e.target.result;
        this.sendVaucher();
      };
      reader.readAsDataURL(file);
    },
    sendVaucher() {
      let url =
        process.env.API_URL + "/api/purchaseOrder/update-order-no-grabr/" + this.id;
      axios
        .put(url, {
          voucher_usa: this.imageVaucher,
          from_admin: 1,
          writer_id: this.$store.state.user.attributes.profile.id,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$refs.fileupload.value = null;
            this.imageVaucher = "";
            location.reload();
          }
        })
        .catch((error) => {
          if (error) {
            this.imageVaucher = "";
            this.$refs.fileupload.value = null;
            alert("Sucedió un error");
          }
        });
    },
    async quitarViajero() {
      var answer = window.confirm("Desea quitar al viajero de la orden?");
      if (answer) {
        let url =
          process.env.API_URL + "/api/purchaseOrder/" + this.id + "/unassignClientTravel";
        await axios
          .post(url, {
            reason: "Administrativo",
          })
          .then(() => {
            location.reload();
          })
          .catch(() => {
            alert("Hubo un error");
          });
      }
    },
    async asignarViajeroOrder(data, user) {
      var answer = window.confirm(
        "Desea Asignar al Viajero con código de usuario : " +
          user +
          " a la orden: " +
          this.id +
          " ?"
      );
      if (answer) {
        let url =
          process.env.API_URL + "/api/purchaseOrder/" + this.id + "/addClientTravel";
        await axios
          .post(url, {
            travel_client_id: data,
          })
          .then(() => {
            location.reload();
          })
          .catch(() => {
            alert("Hubo un error");
          });
      }
    },
    async buscarViajero() {
      var store = 2;
      var length = 10;
      var orderBy = "fullname";
      var dir = "asc";

      var filterBy = "";
      if (this.buscarViajeroCampo === "1") {
        filterBy = "fullname";
      }
      if (this.buscarViajeroCampo === "2") {
        filterBy = "code";
      }
      var filterValue = this.dataInputViajero;
      let url =
        process.env.API_URL +
        "/api/client/getTravelers?store=" +
        store +
        "&length=" +
        length +
        "&orderBy=" +
        orderBy +
        "&dir=" +
        dir +
        "&filterBy=" +
        filterBy +
        "&filterValue=" +
        filterValue +
        "&orderId=" +
        this.id +
        "&destination=" +
        this.orderDataShow.attributes.destination.attributes.name;
      await axios
        .get(url)
        .then((response) => {
          this.dataInputViajero = "";
          if (response.data.data.travels_list.length != 0) {
            this.dataViajeros = response.data.data.travels_list;
          } else {
            alert("No se encontro resultados");
          }
        })
        .catch(() => {
          this.dataInputViajero = "";
          alert("Sucedio un error");
        });
    },
    async deleteInternationalShooper(data) {
      let url =
        process.env.API_URL + "/api/deleteInternationalShopper/" + data + "/" + this.id;
      var answer = window.confirm("Desea Eliminarlo?");
      if (answer) {
        await axios
          .get(url)
          .then((response) => {
            this.dataInternationalShooper =
              response.data.body === null ? [] : response.data.body;
          })
          .catch(() => {
            alert("Hubo un error");
          });
      }
    },
    async getInternationalShooper() {
      let url = process.env.API_URL + "/api/listInternationalShopper/" + this.id;
      await axios
        .get(url)
        .then((response) => {
          this.dataInternationalShooper =
            response.data.body === null ? [] : response.data.body;
        })
        .catch(() => {
          alert("Hubo un error");
        });
    },
    async addInternationalShooper() {
      let url = process.env.API_URL + "/api/createInternationalShopper/" + this.id;
      var answer = window.confirm("Desea Agregarlo?");
      if (answer) {
        await axios
          .post(url, {
            tiendaCompra: this.interShooper.tienda,
            enlace: this.interShooper.enlace,
            precio: this.interShooper.precio,
            cantidad: this.interShooper.cantidad,
            peso: this.interShooper.peso,
            orderNumber: this.interShooper.order,
            invoiceDetails: this.interShooper.invoice,
          })
          .then((response) => {
            this.dataInternationalShooper = response.data.body;
            this.interShooper.tienda = "";
            this.interShooper.enlace = "";
            this.interShooper.precio = "";
            this.interShooper.cantidad = "";
            this.interShooper.peso = "";
            this.interShooper.order = "";
            this.interShooper.invoice = "";

            this.$refs.invoice.value = null;
          })
          .catch(() => {
            alert("Hubo un error");
            this.$refs.invoice.value = null;
            this.interShooper.tienda = "";
            this.interShooper.enlace = "";
            this.interShooper.precio = "";
            this.interShooper.cantidad = "";
            this.interShooper.peso = "";
            this.interShooper.order = "";
            this.interShooper.invoice = "";
          });
      }
    },
    async changeHidden(data, type) {
      console.log(data, "data");
      console.log(type, "type");
      let url = process.env.API_URL + "/api/updateHideTracking/" + data + "/" + this.id;
      var text = "";
      var typeHidden = null;
      if (type === 1 || type === true) {
        text = "Desea Ocultar el Tracking : " + data;
        typeHidden = false;
      }
      if (type === 0 || type === false) {
        text = "Desea Mostrar el Tracking : " + data;
        typeHidden = true;
      }
      var answer = window.confirm(text);
      if (answer) {
        await axios
          .post(url, { hide: typeHidden })
          .then((response) => {
            this.dataNationalTracking = [];
            this.dataNationalTracking =
              response.data.body === null ? [] : response.data.body;
          })
          .catch(() => {
            alert("Hubo un error");
          });
      }
    },
    async deleteTackingStatus(id, data) {
      var answer = window.confirm("Desea eliminar el estado de tracking " + data);
      if (answer) {
        let url = process.env.API_URL + "/api/tracking/" + id + "/delete";
        await axios
          .delete(url)
          .then(() => {
            location.reload();
          })
          .catch(() => {
            alert("Hubo un error");
          });
      }
    },
    async deleteTracking(data) {
      var answer = window.confirm("Desea eliminar el Tracking " + data);
      if (answer) {
        let url =
          process.env.API_URL + "/api/deleteTrackingForCodePro/" + data + "/" + this.id;
        await axios
          .get(url)
          .then(() => {
            this.dataNationalTracking = this.dataNationalTracking.filter(
              (trackingDelete) =>
                trackingDelete.data.trackings[0].shipment.trackingNumbers[0].tn !== data
            );
          })
          .catch(() => {
            alert("Hubo un error");
          });
      }
    },
    async getInternationalTracking() {
      let url = process.env.API_URL + "/api/listTrackingforCodeProd/" + this.id;

      await axios
        .get(url)
        .then((response) => {
          console.log(response, "international tracking");
          this.dataNationalTracking =
            response.data.body === null ? [] : response.data.body;
        })
        .catch(() => {
          alert("Hubo un error");
        });
    },
    //Almacenar nuevo codigo tracking
    async createdInternationalTracking() {
      let url = process.env.API_URL + "/api/addTracking";
      if (this.localInternacionalTracking.codigo.length !== 0) {
        await axios
          .post(url, {
            numTracking: this.localInternacionalTracking.codigo,
            codeOrder: this.id,
            type: parseInt(this.localInternacionalTracking.type),
            hide: true,
          })
          .then(() => {
            location.reload();
          })
          .catch(() => {
            alert("Hubo un error");
          });
      }
    },
    async createdLocalTracking() {
      let url = process.env.API_URL + "/api/addTrackingLocal";
      if (this.localInternacionalTracking.codigo.length !== 0) {
        await axios
          .post(url, {
            trackingNumber: this.localInternacionalTracking.codigo,
            codeOrder: this.id,
            type: parseInt(this.localInternacionalTracking.type),
            hide: true,
          })
          .then(() => {
            location.reload();
          })
          .catch(() => {
            alert("Hubo un error");
          });
      }
    },
    async getLocalTracking() {
      let url = process.env.API_URL + "/api/listTrackingforCodeProdLocal/" + this.id;
      await axios
        .get(url)
        .then((response) => {
          this.dataLocalTracking = response.data.body === null ? [] : response.data.body;
        })
        .catch(() => {
          alert("Hubo un error");
        });
    },
    async deleteTrackingLocal(data) {
      var answer = window.confirm("Desea eliminar el Tracking " + data);
      if (answer) {
        let url =
          process.env.API_URL +
          "/api/deleteTrackingForCodeProLocal/" +
          data +
          "/" +
          this.id;
        await axios
          .get(url)
          .then(() => {
            location.reload();
          })
          .catch(() => {
            alert("Hubo un error");
          });
      }
    },
    async changeHiddenLocal(data, type) {
      let url =
        process.env.API_URL + "/api/updateHideTrackingLocal/" + data + "/" + this.id;
      var text = "";
      var typeHidden = null;
      if (type === 1 || type === true) {
        text = "Desea Ocultar el Tracking : " + data;
        typeHidden = false;
      }
      if (type === 0 || type === false) {
        text = "Desea Mostrar el Tracking : " + data;
        typeHidden = true;
      }
      var answer = window.confirm(text);
      if (answer) {
        await axios
          .post(url, { hide: typeHidden })
          .then((response) => {
            location.reload();
            // this.dataNationalTracking = [];
            // this.dataNationalTracking =
            //   response.data.body === null ? [] : response.data.body;
          })
          .catch(() => {
            alert("Hubo un error");
          });
      }
    },
    //Cambios-Marco-Funcionabildiad-Activa cancelada
    async updateOrderInformation(type) {
      let url =
        process.env.API_URL + "/api/purchaseOrder/update-order-no-grabr/" + this.id;
      const objUpdateOrder = new Object();
      var text = "";
      if (type === "cancelada") {
        objUpdateOrder.status = 10;
        text = "Desea cancelar la orden?";
      } else if (type === "activa") {
        objUpdateOrder.status = 3;
        text = "Desea activar la orden?";
      } else if (type === "A") {
        objUpdateOrder.channel = "A";
        text = "Desea cambiar el canal verde?";
      } else if (type === "B") {
        objUpdateOrder.channel = "B";
        text = "Desea cambiar el canal rojo?";
      } else if (type === "aduana") {
        objUpdateOrder.courier_type = 1;
        text = "Desea cambiar el método a aduana?";
      } else if (type === "pasajero") {
        objUpdateOrder.courier_type = 2;
        text = "Desea cambiar el método a pasajero?";
      }
      objUpdateOrder.writer_id = this.$store.state.user.attributes.profile.id;
      var answer = window.confirm(text);

      if (answer) {
        await axios
          .put(url, objUpdateOrder)
          .then(() => {
            location.reload();
          })
          .catch(() => {
            alert("Hubo un error");
          });
      }
    },
    async authorizeReposition() {
      let data = new Object();
      data.authorized = parseInt(this.authorizationOption) == 1;

      this.responseEvaluation = await ordersService.authorizeReposition(
        this.orderDataShow.id,
        data
      );

      this.hideModalConfirmationReposition();
      this.hideModalAuthorizeReposition();

      if (!this.responseEvaluation) {
        alert("no se pudo enviar la solicitud");
      } else {
        this.inicializeData(this.id, this.setData);
        // this.refreshPackageSection()
      }
    },
    refreshPackageSection() {
      var accordionElement = document.getElementById("collapseEight");
      console.log(accordionElement);

      accordionElement.setAttribute("class", "collapse show");
      packagesService.getPackagesByOrderId(this.id, this.setPackages);
    },
    disablingEvaluationButton() {
      console.log("Vamos a deshabilitar el botón de evaluar");
    },
    getPackages() {
      console.log("entro");

      var accordionElement = document.getElementById("collapseEight");
      console.log(accordionElement);

      var accordionClass = accordionElement.getAttribute("class");
      var isExpanded = accordionClass == "collapse show";
      if (!isExpanded) {
        console.log("get packages");
        packagesService.getPackagesByOrderId(this.id, this.setPackages);
      }
    },
    // getListCities(list) {
    //   this.listCities = list
    //
    // },
    inicializeDataFromImportantInfo() {
      this.inicializeData(this.id, this.setData);
    },
    setPackages(retrievedPackages) {
      console.log("set packages");

      this.packages = retrievedPackages;
    },

    disableEditComments(exceptId) {
      console.log("No se pueden editar otros comentarios");
      console.log(exceptId);
      this.createCommentFlag = false;

      this.comments.forEach((comment) => {
        if (comment.id != exceptId) {
          comment.enable = false;
        }
      });
    },

    enableEditComments() {
      this.createCommentFlag = true;
      this.comments.forEach((comment) => {
        comment.enable = true;
      });
    },

    displayComments() {
      console.log("En display comments");

      commentsService.listCommentsByOrderId(this.id, this.setComments);
    },
    async createComment(cancelled = 0) {
      let commentData = {};
      if (this.currentContent != "") {
        commentData.content = this.currentContent;
        commentData.purchaseorder_id = parseInt(this.id);
        console.log(this.$store.state.user);

        commentData.writer_id = this.$store.state.user.attributes.profile.id;
        console.log(commentData);
        if (cancelled == 1) commentData.cancelled = 1;

        let res = await commentsService.createComment(commentData);

        if (res) {
          this.currentContent = "";
          this.displayComments();
        }
      }
    },
    setComments(comments) {
      console.log("Estamos en set comments");
      console.log(comments);

      comments.forEach((comment) => {
        comment.enable = true;
      });
      this.comments = comments;
    },
    editPackaged() {
      this.packaged = this.packagedRealValue;
      this.editPackagedFlag = true;
    },
    cancelEditPackaged() {
      console.log("cancelEditPackaged");

      this.editPackagedFlag = false;
    },
    async updatePackaged() {
      console.log("updatePackaged");
      let auxObject = new Object();
      auxObject.packaged = this.packaged == 1 ? null : this.packaged == 2 ? 1 : 0;

      let resp = await ordersService.updateBuyingOrderNoGrabr(
        this.orderDataShow.attributes.order_code,
        auxObject
      );
      this.inicializeData(this.id, this.setData);
      this.editPackagedFlag = false;
    },

    showRepositionDetail() {},
    setTaxGrabr() {
      console.log("Ok");
      this.taxGrabr = Number(
        Math.round(parseFloat(0.07 * parseFloat(this.costGrabr)) + "e2") + "e-2"
      )
        .toFixed(2)
        .toString();
      console.log(this.taxGrabr);
    },
    setTaxReal() {
      console.log("Ok");
      let rewardDiscount;
      if (this.rewardDiscount == "") {
        rewardDiscount = 0;
      } else rewardDiscount = this.rewardDiscount;
      this.TaxReal = Number(
        Math.round(parseFloat(0.07 * parseFloat(this.CostReal - rewardDiscount)) + "e2") +
          "e-2"
      )
        .toFixed(2)
        .toString();
    },
    reinicialize_variables() {
      this.unitWeight = "";
      this.weightGrabr = "";
      this.costGrabr = "";
      this.taxGrabr = "";
      this.shippingGrabr = "";
      this.CostReal = "";
      this.TaxReal = "";
      this.shippingReal = "";
      this.finalBuyingLink = "";
      this.finalBuyingCode = "";
      this.numberTracking = "";
      this.postingDate = "";
      this.sendingDate = "";
      this.operatorOrigin = "";
      this.flagFormEvaluetionPurchaseOrder = "toFill";
      this.controllSwithPurchaseOrder = 1;
    },
    inicializeData(id, callback) {
      let url = process.env.API_URL + "/api/purchaseOrder/get/" + id;
      axios
        .get(url)
        .then((response) => {
          let data = response.data.body;
          console.log("Estamos en obtener orden de compra: ", data);
          callback(data);
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 404) {
              self.response = "Error 404";
            }
            console.log(error);
          }
        });
    },
    listUnitWeight(callback) {
      let url = process.env.API_URL + "/api/weightUnit/list";
      axios
        .get(url)
        .then((response) => {
          let data = response.data.body;
          callback(data);
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    listOperatorOrigin(id, callback) {
      let url = process.env.API_URL + "/api/operator/get-operators-origin/" + id;
      axios
        .get(url)
        .then((response) => {
          let data = response.data.body;
          console.log(data);
          callback(data);
        })
        .catch((errors) => {
          console.log(errors.response);
          return;
        });
    },
    dotracking(trackingNumber) {
      let url = process.env.API_URL + "/api/detectCarrier/" + trackingNumber;
      axios.post(url).then((response) => {
        let respuesta = response.data.data;
        let data3 = response.data;
        if (respuesta === null) {
          this.seguimientoTrackin = "";
        } else {
          let data = response.data.data.trackings[0].events;
          this.seguimientoTrackin = data;
        }
      });
    },
    handleValidationErrorAdvanced() {
      const firstField = Object.keys(this.errors.collect())[0];
      if (firstField) {
        var elements = document.getElementsByName(firstField);
        console.log("Failed validation of field: ".concat(firstField));
        elements[0].scrollIntoView();
      } else console.log("Could not find elements with errors");
    },

    modalControllPurchaseOrder(state) {
      if (state == 1) {
        this.$validator.validate().then((result) => {
          if (!result) {
            return this.handleValidationErrorAdvanced();
          } else {
            console.log("PASSED STATE = 1");
            this.flagFormEvaluetionPurchaseOrder = "toShow";
            this.controllSwithPurchaseOrder = 2;
          }
        });
      }
      if (state == 2) {
        // validar la segunda parte
        console.log("PASSED STATE = 2");
        if (this.controllSwithPurchaseOrder == 1) {
          this.controllSwithPurchaseOrder = 2;
        } else {
          this.controllSwithPurchaseOrder = 1;
        }
      }
    },

    async updateEvaluation() {
      this.$validator.validate().then(async (result) => {
        if (!result) {
          return this.handleValidationErrorAdvanced();
        } else {
          var auxObject = new Object();
          let resp;
          auxObject.weight = this.weightGrabr;
          auxObject.weight_unit_id = this.unitWeight.id;

          if (this.orderDataShow.attributes.is_from_grabr_flag) {
            auxObject.grabr_price_rechecked = this.costGrabr;
            auxObject.grabr_tax_rechecked = this.taxGrabr;
            auxObject.grabr_shipping_web = this.shippingGrabr;
            resp = await ordersService.updateBuyingOrder(
              this.orderDataShow.attributes.order_code,
              auxObject
            );
          } else if (this.orderDataShow.attributes.is_from_linio_flag) {
            auxObject.linio_price_rechecked = this.costGrabr;
            auxObject.linio_tax_rechecked = this.taxGrabr;
            auxObject.linio_shipping_web = this.shippingGrabr;
            resp = await ordersService.updateBuyingLinioOrder(
              this.orderDataShow.attributes.order_code,
              auxObject
            );
          } else if (this.orderDataShow.attributes.is_from_meli_flag) {
            auxObject.meli_price_rechecked = this.costGrabr;
            auxObject.meli_tax_rechecked = this.taxGrabr;
            auxObject.meli_shipping_web = this.shippingGrabr;
            resp = await ordersService.updateBuyingMeliOrder(
              this.orderDataShow.attributes.order_code,
              auxObject
            );
          }
          this.hideModalReevaluetion();
          console.log("Resp:");
          console.log(resp);

          if (resp) {
            console.log("Resp 2:");
            console.log(resp);
            // this.$refs.validacionmodal.show()
            this.inicializeData(this.id, this.setData);
          }
        }
      });
    },

    async updateIncompleOrderData() {
      this.$validator.validate().then(async (result) => {
        if (!result) {
          return this.handleValidationErrorAdvanced();
        } else {
          var auxObject = new Object();
          console.log("está validado");
          if (this.finalBuyingLink != "")
            auxObject.real_purchase_link = this.finalBuyingLink;
          if (this.finalBuyingCode != "")
            auxObject.shopping_order_number = this.finalBuyingCode;

          if (this.otherCarrierName != "") {
            auxObject.carrier_name = this.otherCarrierName;
            auxObject.carrier_url = "";
          } else {
            if (this.carrier != "") {
              auxObject.carrier_name = this.carrier_list[this.carrier].name;
              auxObject.carrier_url = this.carrier_list[this.carrier].url;
            }
          }
          if (this.numberTracking != "") auxObject.tracking_number = this.numberTracking;

          if (this.postingDate != "" && !this.orderDataShow.attributes.is_from_grabr_flag)
            auxObject.promised_origin_arrival_date = this.postingDate;

          if (this.operatorOrigin != "")
            auxObject.sender_operator_id = this.operatorOrigin;

          if (this.sendingDate != "" && !this.orderDataShow.attributes.is_from_grabr_flag)
            auxObject.promised_delivery_date = this.sendingDate;

          console.log("DAta:");
          console.log(auxObject);
          console.log(this.orderDataShow.attributes.order_code);

          let resp = await ordersService.updateBuyingOrderNoGrabr(
            this.orderDataShow.attributes.order_code,
            auxObject
          );
          this.hideModalReevaluetion();
          console.log("Resp:");
          console.log(resp);

          if (resp) {
            if (this.orderDataShow.attributes.is_from_grabr_flag) {
              this.$refs.modalProcess.hide();
            } else {
              this.$refs.modalProcessNoGrabr.hide();
            }

            this.inicializeData(this.id, this.setData);
          }
        }
      });
    },

    async sendEvaluation(id) {
      this.$validator.validate().then(async (result) => {
        if (!result) {
          return this.handleValidationErrorAdvanced();
        } else {
          console.log("PASSED VALIDATIONS OF SEND EVALUATION WITH ID: ".concat(id));
          var auxObject = new Object();
          if (this.orderDataShow.attributes.is_from_grabr_flag) {
            auxObject.grabr_price_rechecked = this.costGrabr;
            auxObject.grabr_tax_rechecked = this.taxGrabr;
            auxObject.grabr_shipping_web = this.shippingGrabr;
          } else if (this.orderDataShow.attributes.is_from_linio_flag) {
            auxObject.linio_price_rechecked = this.costGrabr;
            auxObject.linio_tax_rechecked = this.taxGrabr;
            auxObject.linio_shipping_web = this.shippingGrabr;
          } else if (this.orderDataShow.attributes.is_from_meli_flag) {
            auxObject.meli_price_rechecked = this.costGrabr;
            auxObject.meli_tax_rechecked = this.taxGrabr;
            auxObject.meli_shipping_web = this.shippingGrabr;
          }

          auxObject.weight = this.weightGrabr;
          auxObject.weight_unit_id = this.unitWeight.id;
          auxObject.real_price = this.CostReal;
          auxObject.real_tax = this.TaxReal;
          auxObject.real_shipping = this.shippingReal;
          auxObject.real_purchase_link = this.finalBuyingLink;
          if (this.rewardDiscount != "") {
            auxObject.reward_discount = this.rewardDiscount;
          }
          console.log(auxObject);

          let resp;
          if (this.orderDataShow.attributes.is_from_grabr_flag) {
            console.log("grabr");
            resp = await this.registerCostBuyingOrder(this.id, auxObject);
          } else if (this.orderDataShow.attributes.is_from_linio_flag) {
            console.log("linio");
            resp = await this.registerCostBuyingLinioOrder(this.id, auxObject);
          } else if (this.orderDataShow.attributes.is_from_meli_flag) {
            console.log("meli");
            resp = await this.registerCostBuyingMeliOrder(this.id, auxObject);
          }

          if (resp) {
            console.log("OK");

            this.hideModalReevaluetion();
            this.inicializeData(this.id, this.setData);
          } else {
            console.log("Error al registrar la data de evaluación");
          }
        }
      });
    },
    ProcessService(id) {
      console.log("process service");
      if (
        this.orderDataShow.attributes.is_from_grabr_flag &&
        this.orderDataShow.attributes.grabrOrder.attributes.confirmation_flag === 0
      ) {
        console.log("Es una orden GRABR");
        this.confirmApprovedPurchaseOrder(id);
      } else if (
        this.orderDataShow.attributes.is_from_linio_flag &&
        this.orderDataShow.attributes.linioOrder.attributes.confirmation_flag === 0
      ) {
        console.log("Es una orden LINIOO");
        this.confirmApprovedLinioPurchaseOrder(id);
      } else if (
        this.orderDataShow.attributes.is_from_meli_flag &&
        this.orderDataShow.attributes.meliOrder.attributes.confirmation_flag === 0
      ) {
        console.log("Es una orden Meli");
        this.confirmApprovedMeliPurchaseOrder(id);
      }

      if (
        (this.orderDataShow.attributes.is_from_grabr_flag &&
          (this.orderDataShow.attributes.grabrOrder.attributes.confirmation_flag === 1 ||
            this.orderDataShow.attributes.grabrOrder.attributes.confirmation_flag ===
              2)) ||
        (!this.orderDataShow.attributes.is_from_grabr_flag &&
          this.orderDataShow.attributes.status === 3)
      ) {
        console.log("Es una orden DIRECT");
        let idOrigin = this.orderDataShow.attributes.origin.id;
        this.listOperatorOrigin(idOrigin, this.getListOperators);
        if (this.orderDataShow.attributes.is_from_grabr_flag) {
          this.showNodalProcess();
        } else {
          this.showNodalProcessNoGrabr();
        }
      } else if (
        (this.orderDataShow.attributes.is_from_linio_flag &&
          (this.orderDataShow.attributes.linioOrder.attributes.confirmation_flag === 1 ||
            this.orderDataShow.attributes.linioOrder.attributes.confirmation_flag ===
              2)) ||
        (!this.orderDataShow.attributes.is_from_linio_flag &&
          this.orderDataShow.attributes.status === 3)
      ) {
        let idOrigin = this.orderDataShow.attributes.origin.id;
        this.listOperatorOrigin(idOrigin, this.getListOperators);
        if (this.orderDataShow.attributes.is_from_linio_flag) {
          this.showNodalProcess();
        } else {
          this.showNodalProcessNoGrabr();
        }
      } else if (
        (this.orderDataShow.attributes.is_from_meli_flag &&
          (this.orderDataShow.attributes.meliOrder.attributes.confirmation_flag === 1 ||
            this.orderDataShow.attributes.meliOrder.attributes.confirmation_flag ===
              2)) ||
        (!this.orderDataShow.attributes.is_from_meli_flag &&
          this.orderDataShow.attributes.status === 3)
      ) {
        let idOrigin = this.orderDataShow.attributes.origin.id;
        this.listOperatorOrigin(idOrigin, this.getListOperators);
        if (this.orderDataShow.attributes.is_from_meli_flag) {
          this.showNodalProcess();
        } else {
          this.showNodalProcessNoGrabr();
        }
      }
    },
    sendProcess(id) {
      this.sendProcessFlag = true;
      this.$validator.validate().then((result) => {
        if (!result) {
          console.log("baaaad");

          return this.handleValidationErrorAdvanced();
        } else {
          console.log("PASSED VALIDATIONS FROM SENDPROCESS WITH ID: ".concat(id));

          if (
            this.orderDataShow.attributes.is_from_grabr_flag ||
            this.orderDataShow.attributes.is_from_linio_flag ||
            this.orderDataShow.attributes.is_from_meli_flag
          ) {
            this.hideModalProcess();
          } else {
            this.hideModalProcessNoGrabr();
          }
          let auxObject = new Object();
          auxObject.shopping_order_number = this.finalBuyingCode;
          auxObject.tracking_number = this.numberTracking;
          auxObject.promised_origin_arrival_date = this.postingDate;
          auxObject.operator_id = this.operatorOrigin;
          if (this.otherCarrierName != "") {
            auxObject.carrier_name = this.otherCarrierName;
          } else {
            auxObject.carrier_name = this.carrier_list[this.carrier].name;
            auxObject.carrier_url = this.carrier_list[this.carrier].url;
          }

          if (
            this.orderDataShow.attributes.is_from_grabr_flag ||
            this.orderDataShow.attributes.is_from_linio_flag ||
            this.orderDataShow.attributes.is_from_meli_flag
          ) {
            auxObject.real_purchase_link = this.finalBuyingLink;
          } else {
            auxObject.promised_delivery_date = this.sendingDate;
          }

          if (this.orderDataShow.attributes.is_from_grabr_flag) {
            this.completeDataToGrabrPurchaseOrder(this.id, auxObject);
          } else if (this.orderDataShow.attributes.is_from_linio_flag) {
            console.log("linio");
            this.completeDataToLinioPurchaseOrder(this.id, auxObject);
          } else if (this.orderDataShow.attributes.is_from_meli_flag) {
            console.log("meli");
            this.completeDataToMeliPurchaseOrder(this.id, auxObject);
          } else {
            this.completeDataToDirectPurchaseOrder(this.id, auxObject);
          }

          this.reinicialize_variables();
          this.inicializeData(this.id, this.setData);
        }
      });
    },
    setData(data) {
      console.log("set data oficial");
      console.log(data);

      this.orderDataShow = data;

      this.dotracking(this.orderDataShow.attributes.tracking_number);
      if (
        this.orderDataShow.attributes.is_from_grabr_flag &&
        this.orderDataShow.attributes.grabrOrder.attributes.grabr_price_rechecked != null
      ) {
        this.costGrabr = this.orderDataShow.attributes.grabrOrder.attributes.grabr_price_rechecked;
        console.log(this.costGrabr);
      } else if (
        this.orderDataShow.attributes.is_from_linio_flag &&
        this.orderDataShow.attributes.linioOrder.attributes.linio_price_rechecked != null
      ) {
        this.costGrabr = this.orderDataShow.attributes.linioOrder.attributes.linio_price_rechecked;
        console.log(this.costGrabr);
      } else if (
        this.orderDataShow.attributes.is_from_meli_flag &&
        this.orderDataShow.attributes.meliOrder.attributes.meli_price_rechecked != null
      ) {
        this.costGrabr = this.orderDataShow.attributes.meliOrder.attributes.meli_price_rechecked;
        console.log(this.costGrabr);
      }
      console.log("PASAMOS -1");

      if (
        this.orderDataShow.attributes.is_from_grabr_flag &&
        this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax_rechecked != null
      ) {
        this.taxGrabr = parseFloat(
          this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax_rechecked
        ).toFixed(2);
        console.log(this.taxGrabr);
      } else if (
        this.orderDataShow.attributes.is_from_linio_flag &&
        this.orderDataShow.attributes.linioOrder.attributes.linio_tax_rechecked != null
      ) {
        this.taxGrabr = parseFloat(
          this.orderDataShow.attributes.linioOrder.attributes.linio_tax_rechecked
        ).toFixed(2);
        console.log(this.taxGrabr);
      } else if (
        this.orderDataShow.attributes.is_from_meli_flag &&
        this.orderDataShow.attributes.meliOrder.attributes.meli_tax_rechecked != null
      ) {
        this.taxGrabr = parseFloat(
          this.orderDataShow.attributes.meliOrder.attributes.meli_tax_rechecked
        ).toFixed(2);
        console.log(this.taxGrabr);
      }
      console.log("PASAMOS 0");

      if (
        this.orderDataShow.attributes.is_from_grabr_flag &&
        this.orderDataShow.attributes.grabrOrder.attributes.grabr_shipping_web != null
      ) {
        this.shippingGrabr = this.orderDataShow.attributes.grabrOrder.attributes.grabr_shipping_web;
        console.log(this.grabr_shipping_web);
      } else if (
        this.orderDataShow.attributes.is_from_linio_flag &&
        this.orderDataShow.attributes.linioOrder.attributes.linio_shipping_web != null
      ) {
        this.shippingGrabr = this.orderDataShow.attributes.linioOrder.attributes.linio_shipping_web;
        console.log(this.linio_shipping_web);
      } else if (
        this.orderDataShow.attributes.is_from_meli_flag &&
        this.orderDataShow.attributes.meliOrder.attributes.meli_shipping_web != null
      ) {
        this.shippingGrabr = this.orderDataShow.attributes.meliOrder.attributes.meli_shipping_web;
        console.log(this.meli_shipping_web);
      }
      console.log("PASAMOS 1");

      if (this.orderDataShow.attributes.real_price != null) {
        this.CostReal = this.orderDataShow.attributes.real_price;
      }
      if (this.orderDataShow.attributes.real_tax != null) {
        this.TaxReal = this.orderDataShow.attributes.real_tax;
      }
      if (this.orderDataShow.attributes.real_shipping != null) {
        this.shippingReal = this.orderDataShow.attributes.real_shipping;
      }

      if (
        this.orderDataShow.attributes.is_from_grabr_flag &&
        this.orderDataShow.attributes.grabrOrder.attributes.reward_discount != null
      ) {
        this.rewardFlag = true;
        this.rewardDiscount = this.orderDataShow.attributes.grabrOrder.attributes.reward_discount;
      } else if (
        this.orderDataShow.attributes.is_from_linio_flag &&
        this.orderDataShow.attributes.linioOrder.attributes.reward_discount != null
      ) {
        this.rewardFlag = true;
        this.rewardDiscount = this.orderDataShow.attributes.linioOrder.attributes.reward_discount;
      } else if (
        this.orderDataShow.attributes.is_from_meli_flag &&
        this.orderDataShow.attributes.meliOrder.attributes.reward_discount != null
      ) {
        this.rewardFlag = true;
        this.rewardDiscount = this.orderDataShow.attributes.meliOrder.attributes.reward_discount;
      }

      if (this.orderDataShow.attributes.weight != null) {
        this.weightGrabr = this.orderDataShow.attributes.weight;
      }

      if (this.orderDataShow.attributes.weight_unit_id != null) {
        this.unitWeight = this.orderDataShow.attributes.weight_unit;
      }

      if (this.orderDataShow.attributes.real_purchase_link != null) {
        this.finalBuyingLink = this.orderDataShow.attributes.real_purchase_link;
      }

      if (this.orderDataShow.attributes.promised_delivery_date != null) {
        this.sendingDate = this.orderDataShow.attributes.promised_delivery_date;
      }

      if (this.orderDataShow.attributes.shopping_order_number != null) {
        this.finalBuyingCode = this.orderDataShow.attributes.shopping_order_number;
      }
      if (this.orderDataShow.attributes.tracking_number != null) {
        this.numberTracking = this.orderDataShow.attributes.tracking_number;
      }
      if (this.orderDataShow.attributes.promised_origin_arrival_date != null) {
        this.postingDate = this.orderDataShow.attributes.promised_origin_arrival_date;
      }

      if (this.orderDataShow.attributes.sender_operator_id != null) {
        this.operatorOrigin = this.orderDataShow.attributes.sender_operator_id;
      }
      console.log("PASAMOS 2");

      if (this.orderDataShow.attributes.carrier_name != null) {
        let taken = false;
        this.carrier_list.forEach((carrier, index) => {
          if (carrier.name == this.orderDataShow.attributes.carrier_name) {
            this.otherCarrierFlag = false;
            this.carrier = index;
            taken = true;
          }
        });

        if (!taken) {
          console.log("no taken");
          console.log(this.orderDataShow.attributes.carrier_name);

          this.otherCarrierFlag = true;
          this.otherCarrierName = this.orderDataShow.attributes.carrier_name;
          console.log(this.otherCarrierName);
        }
      }

      console.log("PASAMOS 3");
      this.calculateSkuUrl();
      try {
        this.packageRepositions = this.orderDataShow.attributes.reposition.attributes.package_repositions;
      } catch (error) {
        this.packageRepositions = [];
      }
      this.listUnitWeight(this.getListUnits);
      this.listOperatorOrigin(
        this.orderDataShow.attributes.origin.id,
        this.getListOperators
      );
      this.activeRoute =
        "Orden Nro.# " +
        this.orderDataShow.attributes.grabrOrder.attributes.grabr_order_number;
      console.log("NUMBER TRACKING");
      console.log(this.numberTracking);
    },
    async confirmPendientOrder() {
      console.log("Vamos a confirmar el pago");

      var response = await ordersService.updateBuyingOrderNoGrabr(
        this.orderDataShow.attributes.order_code,
        { payed: 3 }
      );
      console.log(response);
      if (response) {
        this.inicializeData(this.id, this.setData);
      } else {
        alert("Service fail");
      }
    },
    getListUnits(data) {
      this.listUnits = data;
      console.log(this.listUnits, "listUnits");

      this.listUnits.forEach((unit) => {
        // if (unit.attributes.key_name == 'lb') {
        //   this.unitWeight = unit
        // }
      });
    },
    getListOperators(data) {
      this.listOperators = data;
    },
    backPage() {
      this.$router.go(-1);
    },
    hideModalValidation() {
      this.$refs.validacionmodal.hide();
    },
    hideCancelValidation() {
      this.$refs.cancelOrdermodal.hide();
    },
    hideModalAuthorizeReposition() {
      this.$refs.modalAuthorizeReposition.hide();
    },
    hideModalReevaluetion() {
      //this.reinicialize_variables()
      this.$refs.modalReevaluation.hide();
    },
    hideModalProcess() {
      this.$refs.modalProcess.hide();
    },
    hideModalProcessNoGrabr() {
      this.$refs.modalProcessNoGrabr.hide();
    },
    hideModalConfirmationReposition() {
      this.$refs.modalConfirmationReposition.hide();
    },
    showNodalProcess() {
      this.$refs.modalProcess.show();
    },
    showNodalProcessNoGrabr() {
      this.$refs.modalProcessNoGrabr.show();
    },
    hideModalConfirmation() {
      this.$refs.modalConfirmation.hide();
    },
    showModalConfirmation() {
      this.$refs.modalConfirmation.show();
    },
    showModalConfirmationDelete() {
      this.$refs.modalConfirmationDelete.show();
    },
    hideModalConfirmationDelete() {
      this.$refs.modalConfirmationDelete.hide();
    },

    // hideModalCompleteLinio() {
    //   this.$refs.modalCompleteLinio.hide()
    // },
    // showModalCompleteLinio() {
    //   this.$refs.modalCompleteLinio.show()
    // },
    async registerCostBuyingOrder(id, data) {
      let url =
        process.env.API_URL + "/api/purchaseOrder/" + id + "/register-cost-grabr-info";

      let resp = await axios
        .post(url, data)
        .then((response) => {
          if (response.data.status) {
            this.orderDataShow = response.data.body;
            this.$refs.validacionmodal.show();
            return true;
          } else {
            console.log("Algo raro paso");
            return false;
          }
        })
        .catch((error) => {
          console.log(error.response);
          return false;
        });

      return resp;
    },
    async registerCostBuyingLinioOrder(id, data) {
      let url =
        process.env.API_URL + "/api/purchaseOrder/" + id + "/register-cost-linio-info";
      console.log(url);
      console.log(data);
      let resp = await axios
        .post(url, data)
        .then((response) => {
          if (response.data.status) {
            console.log("Exito");
            console.log(response.data);

            // this.orderDataShow = response.data.body
            this.$refs.validacionmodal.show();
            return true;
          } else {
            console.log("Algo raro paso");
            return false;
          }
        })
        .catch((error) => {
          console.log(error.response);
          return false;
        });

      return resp;
    },
    async registerCostBuyingMeliOrder(id, data) {
      let url =
        process.env.API_URL + "/api/purchaseOrder/" + id + "/register-cost-meli-info";
      console.log(url);
      console.log(data);
      let resp = await axios
        .post(url, data)
        .then((response) => {
          if (response.data.status) {
            console.log("Exito");
            console.log(response.data);

            // this.orderDataShow = response.data.body
            this.$refs.validacionmodal.show();
            return true;
          } else {
            console.log("Algo raro paso");
            return false;
          }
        })
        .catch((error) => {
          console.log(error.response);
          return false;
        });

      return resp;
    },
    completeDataToDirectPurchaseOrder(id, data) {
      let url =
        process.env.API_URL +
        "/api/purchaseOrder/" +
        id +
        "/complete-final-info-no-grabr";
      console.log("URL de completar informacion de orden de compra");
      console.log(url);
      console.log("data:");
      console.log(data);

      axios
        .post(url, data)
        .then((response) => {
          if (response.data.status) {
            console.log("success");
            console.log(response.data.body);
            console.log("-----------------------");

            this.orderDataShow = response.data.body;
            this.$refs.validacionmodal.show();
            console.log(this.orderDataShow);
            console.log("validacion modal");
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
        });
    },
    completeDataToGrabrPurchaseOrder(id, data) {
      let url =
        process.env.API_URL + "/api/purchaseOrder/" + id + "/complete-final-info-grabr";
      console.log("URL de completar informacion de orden de compra");
      console.log(url);
      console.log("data:");
      console.log(data);

      axios
        .post(url, data)
        .then((response) => {
          if (response.data.status) {
            this.orderDataShow = response.data.body;
            this.$refs.validacionmodal.show();
            console.log(this.orderDataShow);
            console.log("validacion modal");
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
        });
    },
    completeDataToLinioPurchaseOrder(id, data) {
      let url =
        process.env.API_URL + "/api/purchaseOrder/" + id + "/complete-final-info-linio";
      console.log("URL de completar informacion de orden de compra");
      console.log(url);
      console.log("data:");
      console.log(data);
      axios
        .post(url, data)
        .then((response) => {
          if (response.data.status) {
            this.orderDataShow = response.data.body;
            this.$refs.validacionmodal.show();
            console.log(this.orderDataShow);
            console.log("validacion modal");
            this.hideModalProcessNoGrabr();
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
        });
    },
    completeDataToMeliPurchaseOrder(id, data) {
      let url =
        process.env.API_URL + "/api/purchaseOrder/" + id + "/complete-final-info-meli";
      console.log("URL de completar informacion de orden de compra");
      console.log(url);
      console.log("data:");
      console.log(data);
      axios
        .post(url, data)
        .then((response) => {
          if (response.data.status) {
            this.orderDataShow = response.data.body;
            this.calculateSkuUrl();
            this.$refs.validacionmodal.show();
            console.log(this.orderDataShow);
            console.log("validacion modal");
            this.hideModalProcessNoGrabr();
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
        });
    },
    confirmApprovedPurchaseOrder(id) {
      let url =
        process.env.API_URL + "/api/purchaseOrder/" + id + "/confirm-approved-flag";
      let data = new Object();
      data.confirmation_flag = 1;
      axios
        .post(url, data)
        .then((response) => {
          if (response.data.status) {
            console.log("ok");
            console.log(response.data);

            this.orderDataShow = response.data.body;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    confirmApprovedLinioPurchaseOrder(id) {
      let url =
        process.env.API_URL + "/api/purchaseOrder/" + id + "/confirm-linio-approved-flag";
      let data = new Object();
      data.confirmation_flag = 1;
      axios
        .post(url, data)
        .then((response) => {
          if (response.data.status) {
            console.log("ok");
            console.log(response.data);
            this.orderDataShow = response.data.body;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    confirmApprovedMeliPurchaseOrder(id) {
      let url =
        process.env.API_URL + "/api/purchaseOrder/" + id + "/confirm-meli-approved-flag";
      let data = new Object();
      data.confirmation_flag = 1;
      axios
        .post(url, data)
        .then((response) => {
          if (response.data.status) {
            console.log("ok");
            this.orderDataShow = response.data.body;
            this.calculateSkuUrl();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cancelatePurchaseOrder(id) {
      this.hideModalConfirmation();
      let status = this.orderDataShow.attributes.status;
      let url, data;
      if (status == 2) {
        // Si está esperando la confirmación
        console.log("Va a cancelar desconfirmando el confirmed approved flag");

        url = process.env.API_URL + "/api/purchaseOrder/" + id + "/confirm-approved-flag";
        data = new Object();
        data.confirmation_flag = 2;
        axios
          .post(url, data)
          .then((response) => {
            if (response.data.status) {
              console.log(response.data);
              // this.orderDataShow = response.data.body
              this.$refs.cancelOrdermodal.show();
              this.inicializeData(this.id, this.setData);
            }
          })
          .catch((error) => {
            console.log(error);
            console.log(error.response);
            console.log(error.response.data);
          });
      } else if (status <= 7 && status != 2) {
        console.log("Va a cancelar directo");

        url = process.env.API_URL + "/api/purchaseOrder/cancel/" + id;
        data = new Object();
        axios
          .put(url, data)
          .then((response) => {
            if (response.data.status) {
              console.log(response.data);

              // this.orderDataShow = response.data.body
              this.$refs.cancelOrdermodal.show();
              this.inicializeData(this.id, this.setData);
            }
          })
          .catch((error) => {
            console.log(error);
            console.log(error.response);
          });
      } else {
        alert("Esta en un estado en el que no debería poder cancelar");
        return;
      }

      this.cancellationComment();
    },
    deletePurchaseOrder(id) {
      let url = "";
      let hardStatus = 1;
      url = process.env.API_URL + "/api/purchaseOrder/delete/" + id + "?hard=1";
      axios
        .delete(url)
        .then((response) => {
          console.log("orden elimnada");
          this.$router.push("/orders");
        })
        .catch((error) => {
          console.log("Error al eliminar");
        });
    },
    cancellationComment() {
      // Creamos el comentario de cancelación

      this.currentContent =
        "Orden cancelada por " +
        this.$store.state.user.attributes.profile.attributes.name +
        " " +
        this.$store.state.user.attributes.profile.attributes.surnames +
        " (" +
        (this.$store.state.user.attributes.profile.attributes.userable_type == "admin"
          ? "Administrador general"
          : this.$store.state.user.attributes.profile.attributes.userable_type == "client"
          ? "Cliente"
          : this.$store.state.user.attributes.operator_type == 1
          ? "Operador de envío"
          : "Operador de recepción") +
        ") con fecha y hora ";

      console.log(this.currentContent);

      let currentDateTime = new Date();
      console.log(currentDateTime);

      this.currentContent =
        this.currentContent +
        moment(String(currentDateTime)).format("DD/MM/YYYY - HH:mm");
      console.log(this.currentContent);
      this.createComment(1);
      // Fin de comentario de cancelación
    },
    toTrackingView(data) {
      console.log(data);
      this.$router.push({
        name: "show-tracking-order",
        params: {
          id: data.id,
          orderData: data,
        },
      });
    },
    validar() {
      console.log(this.postingDate);
      console.log(this.sendingDate);
      if (this.postingDate == this.sendingDate || this.postingDate > this.sendingDate) {
        console.log("Son fechas iguales");
      }
    },
    resetImpuestoWeb() {
      this.taxGrabr = "";
    },
    resetImpuestoReal() {
      this.TaxReal = "";
    },
    cambiarReward() {
      if (this.rewardFlag) {
        this.rewardDiscount = "";
        this.TaxReal = Number(
          Math.round(parseFloat(0.07 * parseFloat(this.CostReal)) + "e2") + "e-2"
        )
          .toFixed(2)
          .toString();
      }
    },
    calculateSkuUrl() {
      var sku = "";
      var publication_code_link = "";
      var hasshipping = true;
      if (this.orderDataShow.attributes.is_from_meli_flag) {
        sku = this.orderDataShow.attributes.meliOrder.attributes.seller_sku;
        var pub = this.orderDataShow.attributes.meliOrder.attributes.publication_code;
        publication_code_link =
          "https://articulo.mercadolibre.com.pe/" +
          pub.substr(0, 3) +
          "-" +
          pub.substr(3) +
          "-_JM";
        this.orderDataShow.attributes.meliOrder.attributes.publication_code_link = publication_code_link;
        if (this.orderDataShow.attributes.meliOrder.attributes.shipping_id == null) {
          hasshipping = false;
        }
      } else if (this.orderDataShow.attributes.is_from_linio_flag) {
        sku = this.orderDataShow.attributes.linioOrder.attributes.seller_sku;
      } else {
        sku = null;
      }
      this.orderDataShow.attributes.sku = sku;
      this.orderDataShow.attributes.hasshipping = hasshipping;
      if (sku != null) {
        if (sku.search("DELETED") != -1) {
          sku = sku.split("_")[0];
          this.orderDataShow.attributes.linksku = "#";
        } else if (sku.search("Z-") == 0) {
          this.orderDataShow.attributes.linksku =
            "https://www.zappos.com/product/" + sku.split("-")[1];
        } else if (
          sku.search("-REG") != -1 ||
          sku.search("-GREY") != -1 ||
          sku.search("-USA") != -1
        ) {
          this.orderDataShow.attributes.linksku =
            "https://www.bhphotovideo.com/c/product/" + sku;
        } else if (sku.length == 7) {
          this.orderDataShow.attributes.linksku = "https://www.6pm.com/product/" + sku;
        } else if (sku.length == 10) {
          this.orderDataShow.attributes.linksku = "https://www.amazon.com/dp/" + sku;
        } else if (sku.length == 12) {
          this.orderDataShow.attributes.linksku = "https://www.ebay.com/itm/" + sku;
        } else {
          var letters = "abcdefghyjklmnñopqrstuvwxyz";
          var found;
          for (i = 0; i < sku.length; i++) {
            if (letters.indexOf(sku.charAt(i), 0) != -1) found = true;
          }
          this.orderDataShow.attributes.linksku = found
            ? "https://www.nike.com/t/" + sku
            : "https://www.footlocker.com/product/~/" + sku;
        }
      }
    },
  },
  computed: {
    servicioReturn() {
      const foundReturn = this.orderDataShow.attributes.services.find(
        (element) => element.name === "Return"
      );
      if (foundReturn) {
        return true;
      } else {
        return false;
      }
    },
    servicioReview() {
      const foundReview = this.orderDataShow.attributes.services.find(
        (element) => element.name === "Review"
      );
      if (foundReview) {
        return true;
      } else {
        return false;
      }
    },
    servicioCheckup() {
      const foundCheckup = this.orderDataShow.attributes.services.find(
        (element) => element.name === "Checkup"
      );
      if (foundCheckup) {
        return true;
      } else {
        return false;
      }
    },
    noGravado() {
      var precioProducto =
        this.orderDataShow.attributes.real_price *
        this.orderDataShow.attributes.product_specimens;
      var shipping = this.orderDataShow.attributes.real_shipping;
      var tax = this.orderDataShow.attributes.real_tax;
      var warehouse = this.orderDataShow.attributes.warehouse;
      var flete = this.orderDataShow.attributes.flete_cost;
      var valorem = this.orderDataShow.attributes.ad_valorem;
      var igv = this.orderDataShow.attributes.igv;
      var ipm = this.orderDataShow.attributes.ipm;

      if (this.orderDataShow.attributes.direct_type === 2) {
        var rstlNogravado1 = 0.0;
        if (this.orderDataShow.attributes.services.length === 0) {
          rstlNogravado1 =
            precioProducto + shipping + tax + warehouse + flete + valorem + igv + ipm;
        } else {
          var totalServices = 0.0;

          this.orderDataShow.attributes.services.forEach((data) => {
            totalServices = totalServices + data.pivot.amount;
          });

          rstlNogravado1 =
            precioProducto +
            shipping +
            tax +
            warehouse +
            flete +
            valorem +
            igv +
            ipm +
            totalServices;
        }

        rstlNogravado1 = Math.ceil(100 * rstlNogravado1) / 100;
        return rstlNogravado1;
      } else {
        var rstlNogravado2 = warehouse + flete + valorem + igv + ipm;
        rstlNogravado2 = Math.ceil(100 * rstlNogravado2) / 100;
        return rstlNogravado2;
      }
    },
    gravado() {
      var tramiteAduanero = this.orderDataShow.attributes.tramite_aduanero;
      var envio = this.orderDataShow.attributes.national_shipping;
      if (this.orderDataShow.attributes.coupon_discount !== null) {
        var rstlgravado =
          (tramiteAduanero + envio + this.orderDataShow.attributes.coupon_discount) /
          1.18;
        rstlgravado = Math.ceil(100 * rstlgravado) / 100;
        return rstlgravado;
      } else {
        var rstlgravado2 = (tramiteAduanero + envio) / 1.18;
        rstlgravado2 = Math.ceil(100 * rstlgravado2) / 100;
        return rstlgravado2;
      }
    },
    totalIgv() {
      var tramiteAduanero = this.orderDataShow.attributes.tramite_aduanero;
      var envio = this.orderDataShow.attributes.national_shipping;
      if (this.orderDataShow.attributes.coupon_discount !== null) {
        var rsligv =
          tramiteAduanero +
          envio +
          this.orderDataShow.attributes.coupon_discount -
          this.gravado;
        rsligv = Math.ceil(100 * rsligv) / 100;
        return rsligv;
      } else {
        var rsligv2 = tramiteAduanero + envio - this.gravado;
        rsligv2 = Math.ceil(100 * rsligv2) / 100;
        return rsligv2;
      }
    },
    totalPrice() {
      if (this.orderDataShow.attributes.is_from_grabr_flag) {
        return (
          this.orderDataShow.attributes.grabrOrder.attributes.grabr_price +
          this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax +
          this.orderDataShow.attributes.grabrOrder.attributes.grabr_fee
        );
      } else if (this.orderDataShow.attributes.is_from_linio_flag) {
        return this.orderDataShow.attributes.linioOrder.attributes.linio_price;
      } else if (this.orderDataShow.attributes.is_from_meli_flag) {
        return this.orderDataShow.attributes.meliOrder.attributes.meli_price;
      } else {
        // return this.orderDataShow.attributes.real_price + this.orderDataShow.attributes.real_tax + this.orderDataShow.attributes.real_shipping
        return (
          this.orderDataShow.attributes.client_flete_cost +
          this.orderDataShow.attributes.client_arancel_cost +
          this.orderDataShow.attributes.real_price *
            this.orderDataShow.attributes.product_specimens +
          this.orderDataShow.attributes.payment_method_cost
        );
      }
    },

    isDirect() {
      return (
        !this.orderDataShow.attributes.is_from_grabr_flag &&
        !this.orderDataShow.attributes.is_from_linio_flag &&
        !this.orderDataShow.attributes.is_from_meli_flag
      );
    },

    readyToSaveIncompleteData() {
      if (
        this.finalBuyingLink != "" ||
        this.finalBuyingCode != "" ||
        this.otherCarrierName != "" ||
        this.carrier != "" ||
        this.numberTracking != "" ||
        this.postingDate != "" ||
        this.operatorOrigin != "" ||
        (!this.orderDataShow.attributes.is_from_grabr_flag && this.sendingDate != "")
      ) {
        return true;
      }
      return false;
    },

    readyToProcessIncompleteData() {
      console.log(this.otherCarrierName != "" || this.carrier != "");
      //verdadero
      if (
        (this.orderDataShow.attributes.is_from_grabr_flag &&
          this.finalBuyingLink != "" &&
          this.finalBuyingCode != "" &&
          (this.otherCarrierName != "" || this.carrier !== "") &&
          this.numberTracking != "" &&
          this.postingDate != "" &&
          this.operatorOrigin != "") ||
        (!this.orderDataShow.attributes.is_from_grabr_flag &&
          this.sendingDate != "" &&
          this.finalBuyingCode != "" &&
          (this.otherCarrierName !== "" || this.carrier !== "") &&
          this.numberTracking != "" &&
          this.postingDate != "" &&
          this.operatorOrigin != "")
      ) {
        return true;
      }
      return false;
    },

    debitCalculated() {
      console.log("Estamos en calculate debit");
      let costGrabr, taxGrabr, shippingGrabr;
      if (this.costGrabr == "") costGrabr = 0;
      else costGrabr = parseFloat(this.costGrabr);

      if (this.taxGrabr == "") taxGrabr = 0;
      else taxGrabr = parseFloat(this.taxGrabr);

      if (this.shippingGrabr == "") shippingGrabr = 0;
      else shippingGrabr = parseFloat(this.shippingGrabr);

      console.log("Precio de la web: ");
      console.log(costGrabr);
      console.log("Impuesto de la web: ");
      console.log(taxGrabr);
      console.log("Costo de envío de la web");
      console.log(shippingGrabr);

      let subtotal1, subtotal2;
      subtotal1 = 0;
      subtotal2 = 0;
      if (this.orderDataShow.attributes.is_from_grabr_flag) {
        console.log("Precio Grabr");
        console.log(this.orderDataShow.attributes.grabrOrder.attributes.grabr_price);

        console.log("Impuesto Grabr");
        console.log(this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax);

        subtotal1 =
          this.orderDataShow.attributes.grabrOrder.attributes.grabr_price <= costGrabr
            ? costGrabr - this.orderDataShow.attributes.grabrOrder.attributes.grabr_price
            : 0;
        console.log(subtotal1);

        subtotal2 =
          this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax <= taxGrabr
            ? taxGrabr - this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax
            : 0;
        console.log(subtotal2);
      } else if (this.orderDataShow.attributes.is_from_linio_flag) {
        console.log("Precio Linio");
        console.log(this.orderDataShow.attributes.linioOrder.attributes.linio_price);

        subtotal1 =
          this.orderDataShow.attributes.linioOrder.attributes.linio_price <= costGrabr
            ? costGrabr - this.orderDataShow.attributes.linioOrder.attributes.linio_price
            : 0;
        console.log(subtotal1);

        subtotal2 = taxGrabr;
        console.log(subtotal2);
      } else if (this.orderDataShow.attributes.is_from_meli_flag) {
        console.log("Precio meli");
        console.log(this.orderDataShow.attributes.meliOrder.attributes.meli_price);

        subtotal1 =
          this.orderDataShow.attributes.meliOrder.attributes.meli_price <= costGrabr
            ? costGrabr - this.orderDataShow.attributes.meliOrder.attributes.meli_price
            : 0;
        console.log(subtotal1);

        subtotal2 = taxGrabr;
        console.log(subtotal2);
      }

      return parseFloat(subtotal1) + parseFloat(subtotal2) + parseFloat(shippingGrabr);
    },
    formatPostingDate() {
      if (!this.postingDate) return "2000-01-01";
      let postingDate2 = new Date(this.postingDate);
      console.log("Habia postingDate: ".concat(postingDate2));
      let formatted_month = ("0" + (postingDate2.getMonth() + 1)).slice(-2);
      let formatted_day = ("0" + (postingDate2.getDate() + 1)).slice(-2);
      let formatted_date =
        postingDate2.getFullYear() + "-" + formatted_month + "-" + formatted_day;
      console.log("Formatted date: ".concat(formatted_date));
      return formatted_date;
    },
    formatSendingDate() {
      if (!this.sendingDate) return "2000-01-01";
      let sendingDate2 = new Date(this.sendingDate);
      console.log("Habia postingDate: ".concat(sendingDate2));
      let formatted_month = ("0" + (sendingDate2.getMonth() + 1)).slice(-2);
      let formatted_day = ("0" + (sendingDate2.getDate() + 1)).slice(-2);
      let formatted_date =
        sendingDate2.getFullYear() + "-" + formatted_month + "-" + formatted_day;
      console.log("Formatted date: ".concat(formatted_date));
      return formatted_date;
    },
    packagedRealValue: function () {
      let packagedAux = this.orderDataShow.attributes.packaged;
      console.log("estoy en computed");

      if (packagedAux == null) {
        return 1;
      } else if (packagedAux == 1) {
        return 2;
      } else {
        return 3;
      }
    },

    repositionAuthorizedFlag: function () {
      try {
        return this.orderDataShow.attributes.reposition.attributes.authorized;
      } catch (error) {
        return null;
      }
    },

    noEvaluationFlag: function () {
      let flag = false;
      if (this.orderDataShow.attributes.status != 1) return false;
      if (this.orderDataShow.attributes.is_from_grabr_flag) {
        flag =
          this.orderDataShow.attributes.grabrOrder.attributes.grabr_tax == null ||
          this.orderDataShow.attributes.grabrOrder.attributes.grabr_fee == null ||
          this.orderDataShow.attributes.origin_id == null ||
          this.orderDataShow.attributes.destination_id == null;
      } else if (
        this.orderDataShow.attributes.is_from_linio_flag ||
        this.orderDataShow.attributes.is_from_meli_flag
      ) {
        flag =
          this.orderDataShow.attributes.origin_id == null ||
          this.orderDataShow.attributes.destination_id == null;
      }
      return flag;
    },

    totalMeli() {
      return this.totalPrice + this.orderDataShow.attributes.meliOrder.attributes.rebate;
    },
    totalCommissions() {
      return (
        0.09 * this.totalPrice +
        0.09 * this.orderDataShow.attributes.meliOrder.attributes.rebate
      );
    },
    totalNeto() {
      return this.totalMeli - this.totalCommissions;
    },
  },
  watch: {
    orderDataShow: function (newval) {
      this.pagosStatus = newval.attributes.payed;
      this.trakingStatus =
        newval.attributes.order_tracking_details[
          this.orderDataShow.attributes.order_tracking_details.length - 1
        ].attributes.status;
    },

    otherCarrierFlag: function (newFlag) {
      console.log("estamos cambiando de valor");
      if (!newFlag) this.otherCarrierName = "";
      if (newFlag) this.carrier = "";
    },
  },
};
</script>
<style>
ul,
li {
  margin: 0 0 0 0;
  padding: 0 0 0 0;
}
.cursorNot:hover {
  cursor: not-allowed;
}
.cursorPointer:hover {
  cursor: pointer;
}
.slider {
  height: 100vh;
  overflow: scroll;
  scroll-snap-align: y mandatory;
}
.slider_content {
  scroll-snap-align: center;
}
.button {
  display: flex;
  gap: 2.5rem;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;

  font-size: 16px;
  font-weight: 600;

  border-radius: 14px;
  border: 2px solid #d9e1e7;
  background: transparent;
  color: #384455;
}

.button-error {
  background: rgba(234, 58, 61, 0.101961);
  border: 2px solid #ea3a3d;
}

.button-success {
  background: rgba(26, 213, 152, 0.101961);
  border: 2px solid #1ad598;
}

.listStyle {
  margin: 0 0 0 0;
  padding: 0 0 0 0;
}
.listStyle ol {
  margin: 0 0 0 0;
  padding: 0 0 0 0;
}

.switch {
  background-color: #e5e7eb46;
  padding: 1rem;
  border-radius: 24px;
  border: 1px solid #ccc;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
  display: flex;
  gap: 1.5rem;
  justify-content: space-around;
  margin-bottom: 1rem;
  margin-top: 1rem;
  position: relative;
  text-decoration: underline;

  font-size: 14px;
}

.switch__link {
  z-index: 10;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  color: rgb(96, 100, 98) !important;
  transition: color 0.3s;
  cursor: pointer;
}
.switch__link:hover {
  color: #1ea9e4 !important;
}
.switch__link--active {
  color: #1ea9e4 !important;
}

.switch__bg--active {
  position: absolute;
  width: 50%;
  border-radius: 24px;
  top: 0;
  bottom: 0;
  border: 3px solid #1ea9e4;
  transition: all 0.3s;
  background-color: #fff;
}

.switch__bg--left {
  left: 0;
}

.switch__bg--right {
  right: 0;
}

.details-info-viajero {
  display: grid;
  grid-template-columns: 2fr 3fr;
  font-size: 14px;
  border-bottom: 1px solid #ccc;
}

.details-info-viajero :nth-child(1) {
  padding-bottom: 0.5rem;
}
.phil-success {
  font-size: 12px;
  font-weight: 600;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  background: rgba(17, 201, 17, 0.1);
  color: rgba(9, 99, 9, 0.8);
  border: 1px solid rgb(16, 185, 16);
  margin-right: auto;
  margin-left: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// purchase-order-show-view.vue?93abce00